import React, { useEffect, useState, useRef } from 'react';
import { FaBars, FaUser, FaCog, FaSignOutAlt, FaTachometerAlt, FaBox, FaList, FaEdit, FaTrash, FaTags, FaImage, FaChartBar, FaClipboardList, FaEye, FaArrowLeft, FaBell, FaBoxOpen, FaCar, FaTruck, FaRegTrashAlt, FaExclamationCircle, FaDrumstickBite, FaSpeakerDeck, } from 'react-icons/fa';
import axios from 'axios';
// import Modal from 'react-modal';
import { Table, Container, Modal } from 'react-bootstrap';
import logo from '../Header/logo1.jpeg';
import { useNavigate } from 'react-router-dom';
import { MdNotificationsActive, MdRemoveShoppingCart } from 'react-icons/md';

import Select from 'react-select';
import './Dashboard.css'
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend, LineChart,
  Line,
  CartesianGrid
} from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";



const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];


const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState('Dashboard');

  useEffect(() => {
    const storedComponent = sessionStorage.getItem('activeComponent');
    if (storedComponent) {
      setActiveComponent(storedComponent);
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // logout
  const navigate = useNavigate();





  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    // Clear all data from localStorage
    localStorage.clear();

    // Clear all data from sessionStorage
    sessionStorage.clear();

    navigate("/adminlogin");
  };







  //---------------------- category --------------------------//


  const [supercategoriesget, setSupercategoriesget] = useState([]);
  const [supercategoryId, setSuperCategoryId] = useState('');
  const [superCategoryName, setSuperCategoryName] = useState('');
  const [superCategoryimg, setSuperCategoryImg] = useState('');

  // Fetch supercategories from API
  const fetchDatagetsuper = () => {
    axios.get("https://api.glocart.in/pages/api/api/supercategories")
      .then((res) => setSupercategoriesget(res.data))
      .catch((err) => console.error("Error fetching supercategories:", err));
  };

  useEffect(() => {
    fetchDatagetsuper();
  }, []);

  const [categoryName, setCategoryName] = useState('');
  const [categoryImage, setCategoryImage] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  console.log(error)
  const fileInputRef = useRef(null);
  const handleCategorySubmit = async (e) => {
    e.preventDefault();

    if (!categoryName || !categoryImage) {
      setError('Please provide both name and image.');
      return;
    }

    const formData = new FormData();
    formData.append('name', categoryName);
    formData.append('image', categoryImage);
    formData.append("super_cat_id", supercategoryId);
    formData.append("super_cat_name", superCategoryName);
    formData.append("super_cat_img", superCategoryimg);

    try {
      const response = await axios.post('https://api.glocart.in/pages/api/api/categories',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      console.log(response)
      setSuccess(true);
      setError('');
      fetchcategories();
      alert('Category added successfully!');

      // ✅ Reset all form fields
      setCategoryName('');
      setCategoryImage(null);
      setSuperCategoryId('');
      setSuperCategoryName('');
      setSuperCategoryImg('');

      // ✅ Reset file input manually
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (err) {
      console.error(err);
      setError('Failed to add category');
      setSuccess(false);
    }
  };


  const [editingCategoryId, setEditingCategoryId] = useState(null);

  const handleCategoryUpdate = async (categoryId) => {
    if (!categoryName) {
      setError('Please provide a category name.');
      return;
    }

    const formData = new FormData();
    formData.append('name', categoryName);
    if (categoryImage) formData.append('image', categoryImage); // optional
    formData.append("super_cat_id", supercategoryId);
    formData.append("super_cat_name", superCategoryName);
    formData.append("super_cat_img", superCategoryimg);

    try {
      const response = await axios.put(`https://api.glocart.in/pages/api/api/categories/${categoryId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log(response);
      alert('Category updated successfully');
      fetchcategories();
      setError('');
      setCategoryName('');
      setCategoryImage(null);
      setSuperCategoryId('');
      setSuperCategoryName('');
      setSuperCategoryImg('');
      setEditingCategoryId(null);
    } catch (err) {
      console.error(err);
      setError('Failed to update category');
    }
  };


  const [subCategoryName, setSubCategoryName] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [imageSub, setImageSub] = useState(null);
  const [categories, setCategories] = useState([]);

  // Fetch categories from API

  const fetchcategories = async (e) => {
    axios.get('https://api.glocart.in/pages/api/api/categories')
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  };

  useEffect(() => {
    fetchcategories();
  }, []);


  // Pagination states
  const [currentPagex, setCurrentPagex] = useState(1);
  const itemsPerPagex = 10;
  // Derived indices
  const indexOfLastItemx = currentPagex * itemsPerPagex;
  const indexOfFirstItemx = indexOfLastItemx - itemsPerPagex;
  // Slice the data
  const categoriesx = categories.slice(indexOfFirstItemx, indexOfLastItemx);
  // Calculate total pages
  const totalPagesx = Math.ceil(categories.length / itemsPerPagex);



  const handleDeleteCategort = async (id) => {
    try {
      const response = await axios.delete(`https://api.glocart.in/pages/api/delete/categories/${id}`);
      alert(response.data.message);
      fetchcategories();
      fetchsubcategories();
      alert('Delete the product Sucess.');
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete the product.');
    }
  };






  //----------------------Sub category --------------------------//


  const [selectedSuperCatName, setSelectedSuperCatName] = useState('');

  // Handle form submission for adding subcategory
  const handleSubCategorySubmit = async (e) => {
    e.preventDefault();
    // Validate required fields
    if (!subCategoryName || !categoryId || (!imageSub && !editSubcategoryId)) {
      setError('Please provide all fields.');
      alert('Please provide all fields.');
      return;
    }
    const formData = new FormData();
    formData.append('subCategory', subCategoryName);
    formData.append('category_id', categoryId);
    formData.append('category_name', categoryName);
    formData.append('super_cat_id', selectedSuperCatId);
    formData.append('super_cat_name', selectedSuperCatName);
    if (imageSub) {
      formData.append('image_sub', imageSub);
    }
    try {
      if (editSubcategoryId) {
        await axios.put(`https://api.glocart.in/pages/api/api/subcategories/${editSubcategoryId}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        alert('Subcategory updated successfully!');
      } else {
        await axios.post('https://api.glocart.in/pages/api/api/subcategories',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        alert('Subcategory added successfully!');
      }

      setSuccess(true);
      fetchsubcategories();       // Refresh subcategory list
      resetSubCategoryForm();     // Reset form fields
      setError(null);             // Clear previous errors
    } catch (err) {
      console.error('Subcategory save error:', err);
      setError('Failed to save subcategory');
      setSuccess(false);
      alert('Failed to save subcategory. Please try again.');
    }
  };

  const [selectedSuperCatId, setSelectedSuperCatId] = useState('');
  const filteredCategories = categories.filter(
    (cat) => String(cat.super_cat_id) === String(selectedSuperCatId)
  );

  const [editSubcategoryId, setEditSubcategoryId] = useState(null);
  const handleEditSubCategory = (subcategory) => {
    setEditSubcategoryId(subcategory.id);
    setSubCategoryName(subcategory.subCategory);
    setImageSub(null); // clear file input (optional)
    setSelectedSuperCatId(subcategory.super_cat_id || '');
    setSelectedSuperCatName(subcategory.super_cat_name || '');
    setCategoryId(subcategory.category_id || '');
    setCategoryName(subcategory.category_name || '');
  };

  const resetSubCategoryForm = () => {
    setSelectedSuperCatId('');
    setSelectedSuperCatName('');
    setCategoryId('');
    setCategoryName('');
    setSubCategoryName('');
    setImageSub(null);          // reset file state
    setEditSubcategoryId(null); // reset edit mode if any
    setSuccess(false);          // hide success message
    setError(null);             // clear errors
  };



  const [subcategories, setSubcategories] = useState([]);

  const fetchsubcategories = async (e) => {
    axios.get('https://api.glocart.in/pages/api/api/subcategories')
      .then(response => {
        setSubcategories(response.data);
      })
      .catch(err => {
        console.error('Error fetching subcategories:', err);
        setError('Failed to load  data.');
      });
  };

  const handleDeleteSubCategort = async (id) => {
    try {
      const response = await axios.delete(`https://api.glocart.in/pages/api/delete/Subcategories/${id}`);
      alert(response.data.message);
      fetchcategories();
      fetchsubcategories();
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Failed to delete the product.');
    }
  };

  useEffect(() => {
    fetchsubcategories();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = subcategories.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(subcategories.length / itemsPerPage);

















  // brand 

  const [brands, setBrands] = useState([]);
  const [name, setName] = useState('');
  const [image, setImage] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [currentPageb, setCurrentPageb] = useState(1);
  const itemsPerPageb = 10;

  useEffect(() => {
    fetchBrands();
  }, []);

  const fetchBrands = async () => {
    const res = await axios.get('https://api.glocart.in/pages/api/brands');
    setBrands(res.data);
  };

  // const handleSubmitBrand = async () => {
  //   if (!name) {
  //     alert("Please fill the Brand Name.");
  //     return;
  //   }
  //   try {
  //     const formData = new FormData();
  //     formData.append('name', name);
  //     if (image) formData.append('image', image);

  //     if (editingId) {
  //       await axios.put(`https://api.glocart.in/pages/api/brands/${editingId}`, formData);
  //       alert('Brand updated successfully!');
  //     } else {
  //       await axios.post('https://api.glocart.in/pages/api/brands', formData);
  //       alert('Brand added successfully!');
  //     }

  //     setName('');
  //     setImage(null);
  //     setEditingId(null);
  //     fetchBrands();
  //   } catch (error) {
  //     alert('Error saving brand. Please try again.');
  //     console.error(error);
  //   }
  // };

  const handleSubmitBrand = async () => {
    if (!name) {
      alert("Please fill the Brand Name.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', name);

      if (image) {
        formData.append('image', image);
      }

      if (editingId) {
        await axios.put(
          `https://api.glocart.in/pages/api/brands/${editingId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
        alert('Brand updated successfully!');
      } else {
        await axios.post(
          'https://api.glocart.in/pages/api/brands',
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
        alert('Brand added successfully!');
      }

      setName('');
      setImage(null);
      setEditingId(null);
      fetchBrands();

    } catch (error) {
      alert('Error saving brand. Please try again.');
      console.error(error);
    }
  };

  const handleDeleteBrand = async (id) => {
    if (!window.confirm('Are you sure you want to delete this brand?')) return;

    try {
      await axios.delete(`https://api.glocart.in/pages/api/brands/${id}`);
      alert('Brand deleted successfully!');
      fetchBrands();
    } catch (error) {
      alert('Error deleting brand.');
      console.error(error);
    }
  };

  // const handleEditBrand = (brand) => {
  //   setName(brand.name);
  //   setEditingId(brand.id);
  // };

  const handleEditBrand = (brand) => {
    setName(brand.name);
    setEditingId(brand.id);
    setImage(null); // important
  };

  const totalPagesb = Math.ceil(brands.length / itemsPerPageb);
  const startIndex = (currentPageb - 1) * itemsPerPageb;
  const currentBrands = brands.slice(startIndex, startIndex + itemsPerPageb);



  // Banners

  const [bannerFile, setBannerFile] = useState(null);
  const [banners, setBanners] = useState([]);

  const handleBannerSubmit = async (e) => {
    e.preventDefault();
    if (!bannerFile) return;

    const formData = new FormData();
    formData.append('image', bannerFile);

    try {
      await axios.post('https://api.glocart.in/pages/api/api/banners', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Banner uploaded successfully!');
      setBannerFile(null);
      fetchBanners();
    } catch (err) {
      console.error('Upload failed:', err);
      alert('Banner upload failed.');
    }
  };

  const fetchBanners = async () => {
    try {
      const response = await axios.get('https://api.glocart.in/pages/api/api/banners');
      setBanners(response.data);
    } catch (error) {
      console.error('Failed to fetch banners:', error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);


  const handleDeleteBanner = async (id) => {
    try {
      await axios.delete(`https://api.glocart.in/pages/api/delete/banner/${id}`);
      fetchBanners();
      alert('Banner deleted.');
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete banner.');
    }
  };



  // Dashboard

  const salesData = [
    { month: 'Jan', value: 18000 },
    { month: 'Feb', value: 15000 },
    { month: 'Mar', value: 8000 },
    { month: 'Apr', value: 2000 },
    { month: 'May', value: 4000 },
    { month: 'Jun', value: 13000 },
    { month: 'Jul', value: 14000 },
    { month: 'Aug', value: 15000 },
    { month: 'Sep', value: 16000 },
    { month: 'Oct', value: 19000 },
    { month: 'Nov', value: 17000 },
    { month: 'Dec', value: 20000 },
  ];
  const maxValue = Math.max(...salesData.map(d => d.value));




  // Variant Master Module

  const predefinedUnits = [
    { value: 'kg', label: 'Kilogram (kg)' },
    { value: 'g', label: 'Gram (g)' },
    { value: 'ltr', label: 'Litre (ltr)' },
    { value: 'ml', label: 'Millilitre (ml)' },
    { value: 'pcs', label: 'Pieces (pcs)' },
    { value: 'pack', label: 'Pack' },
    { value: 'box', label: 'Box' },
    { value: 'combo', label: 'Combo' },
    { value: 'custom', label: 'Custom' },
  ];

  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [customLabel, setCustomLabel] = useState('');
  const [editId, setEditId] = useState(null);

  const API_URL = 'https://api.glocart.in/pages/api/units';

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await axios.get(`${API_URL}/get`);
      setUnits(res.data);
    } catch (err) {
      console.error('Error fetching units:', err);
    }
  };
  const handleSubmitVariant = async (e) => {
    e.preventDefault();
    if (!selectedUnit || (selectedUnit.value === 'custom' && !customLabel.trim())) return;
    // 🔒 Prevent duplicate predefined unit entries
    if (selectedUnit.value !== 'custom') {
      const isAlreadyAdded = units.some(unit => unit.value === selectedUnit.value);
      if (isAlreadyAdded && editId === null) {
        alert('This predefined unit is already added.');
        return;
      }
    }
    const payload =
      selectedUnit.value === 'custom'
        ? { label: 'custom', value: customLabel.trim() }
        : { label: selectedUnit.label, value: selectedUnit.value };
    try {
      if (editId !== null) {
        await axios.put(`${API_URL}/put/${editId}`, payload);
      } else {
        await axios.post(`${API_URL}/post`, payload);
      }
      resetFormVariant();
      fetchUnits();
    } catch (err) {
      console.error('Error submitting unit:', err);
    }
  };

  const resetFormVariant = () => {
    setSelectedUnit(null);
    setCustomLabel('');
    setEditId(null);
  };

  const handleEditVariant = (unit) => {
    setSelectedUnit({ label: unit.label, value: unit.value });
    if (unit.value === 'custom') setCustomLabel(unit.label);
    setEditId(unit.id);
  };

  const handleDeleteVariant = async (id) => {
    if (!window.confirm('Delete this unit?')) return;
    try {
      await axios.delete(`${API_URL}/delete/${id}`);
      fetchUnits();
    } catch (err) {
      console.error('Error deleting unit:', err);
    }
  };

















  // products Form Data
  // const [productsData, setProductsData] = useState({
  //   name: '',
  //   category: '',
  //   sub_category: '',
  //   brand: '',
  //   short_description: '',
  //   long_description: '',
  //   super_category: '',
  // });
  const [productsData, setProductsData] = useState({
    name: '',
    category: '',
    sub_category: '',
    brand: '',
    short_description: '',
    long_description: '',
    super_category: '',
    recipe: '',
    ingredients: '',
    features: '',
    nutritional_facts: ''
  });

  const [images, setImages] = useState({ image_1: null, image_2: null, image_3: null, image_4: null });
  const handleChangeProducts = (e) => {
    const { name, value } = e.target;
    if (name === "super_category") {
      setProductsData({ super_category: value, category: "", sub_category: "", name: productsData.name, brand: productsData.brand, short_description: productsData.short_description, long_description: productsData.long_description });
    } else if (name === "category") {
      setProductsData({ ...productsData, category: value, sub_category: "" });
    } else {
      setProductsData({ ...productsData, [name]: value });
    }
  };

  const handleImageChange = (e) => {
    const { name, files } = e.target;
    setImages({ ...images, [name]: files[0] });
  };
  const [b2bVariants, setB2bVariants] = useState([]);
  const [b2cVariants, setB2cVariants] = useState([]);
  const handleAddB2BVariant = () => {
    setB2bVariants([...b2bVariants, { unit: '', unitvalue: '', Price: '', qty: '', discount: '', offerUntil: '', tax: '', stock: '' }]);
  };
  const handleAddB2CVariant = () => {
    setB2cVariants([...b2cVariants, { unit: '', unitvalue: '', Price: '', qty: '', discount: '', offerUntil: '', tax: '', stock: '' }]);
  };
  const handleVariantChange = (type, index, field, value) => {
    const updated = type === 'B2B' ? [...b2bVariants] : [...b2cVariants];
    updated[index][field] = value;
    type === 'B2B' ? setB2bVariants(updated) : setB2cVariants(updated);
  };
  const [productData12, setProductData12] = useState({ productType: [], category: '', sub_category: '', });
  const handleProductTypeChange = (e) => {
    const { value, checked } = e.target;
    let updatedTypes = [...productData12.productType];
    if (checked) {
      updatedTypes.push(value);
    } else {
      updatedTypes = updatedTypes.filter((type) => type !== value);
    }
    setProductData12({ ...productData12, productType: updatedTypes });
  };
  const handleSubmitProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(productsData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append('product_type', JSON.stringify(productData12.productType));

    const allVariants = [
      ...b2bVariants.map((v) => ({ ...v, type: 'B2B' })),
      ...b2cVariants.map((v) => ({ ...v, type: 'B2C' }))
    ];
    formData.append('variants', JSON.stringify(allVariants));
    // if (images.image_1) formData.append('image_1', images.image_1);
    // if (images.image_2) formData.append('image_2', images.image_2);
    // if (images.image_3) formData.append('image_3', images.image_3);
    // if (images.image_4) formData.append('image_4', images.image_4);

    Object.entries(images).forEach(([key, file]) => {
      if (file instanceof File) {
        formData.append(key, file);
      }
    });

    try {
      const response = await fetch(`https://api.glocart.in/pages/api/products/${editingProductId || 'post'}`, {
        method: editingProductId ? 'PUT' : 'POST',
        body: formData,
      });
      const result = await response.json();
      if (response.ok) {
        alert(editingProductId ? 'Product updated successfully!' : 'Product successfully uploaded!');
        setEditingProductId(null); // reset after save
        resetForm();
        const updatedList = await fetch('https://api.glocart.in/pages/api/products/get');
        setProductsGet(await updatedList.json());
        setActiveComponent('Products List');
      } else {
        alert(`Failed: ${result.error}`);
      }
    } catch (err) {
      console.error('Submit error:', err);
      alert('Something went wrong.');
    }
  };

  const [editingProductId, setEditingProductId] = useState(null);

  const handleEditProduct = (productId) => {
    const product = productsGet.find(p => p.id === productId);
    if (!product) return;
    setEditingProductId(productId);

    console.log(editingProductId);
    console.log('Selected product to edit:', productId);

    // setProductsData({
    //   name: product.name || '',
    //   category: product.category || '',
    //   sub_category: product.sub_category || '',
    //   brand: product.brand || '',
    //   short_description: product.short_description || '',
    //   long_description: product.long_description || '',
    // });

    setProductsData({
      name: product.name || '',
      super_category: product.super_category || '',
      category: product.category || '',
      sub_category: product.sub_category || '',
      brand: product.brand || '',
      short_description: product.short_description || '',
      long_description: product.long_description || '',
      recipe: product.recipe || '',
      ingredients: product.ingredients || '',
      features: product.features || '',
      nutritional_facts: product.nutritional_facts || '',
    });
    setProductData12({ ...productData12, productType: product.product_type || [], });
    const normalizeVariant = (v) => {
      console.log('this is v', v)
      const formattedDate = v.offer_until
        ? new Date(v.offer_until).toISOString().split('T')[0]
        : '';
      return {
        unit: v.unit || '',
        unitvalue: v.unit_value || '',
        Price: v.price || '',
        qty: v.quantity || '',
        discount: v.discount || '',
        offerUntil: formattedDate,
        tax: v.tax || '0',
        stock: v.stock || ''
      };
    };
    const b2b = (product.variants?.filter(v => v.type === 'B2B') || []).map(normalizeVariant);
    const b2c = (product.variants?.filter(v => v.type === 'B2C') || []).map(normalizeVariant);
    setB2bVariants(b2b);
    setB2cVariants(b2c);
    setImages({ image_1: null, image_2: null, image_3: null, image_4: null });
    setActiveComponent("Add Product Form");
  };
  const resetForm = () => {
    setProductsData({
      name: '', category: '', sub_category: '', brand: '', short_description: '', long_description: '',
      super_category: '',
      recipe: '',
      ingredients: '',
      features: '',
      nutritional_facts: ''
    });
    setProductData12({ productType: [], category: '', sub_category: '' });
    setB2bVariants([]);
    setB2cVariants([]);
    setImages({ image_1: null, image_2: null, image_3: null, image_4: null });
    setEditingProductId(null);
  };


  const [subcategories1p, setSubcategories1p] = useState([]);
  const [superCategories, setSuperCategories] = useState([]);
  const fetchSubcategoriesp = async () => {
    try {
      const response = await
        //axios.get('https://api.glocart.in/pages/api/api/subcategories');
        axios.get("https://api.glocart.in/pages/api/api/supercategories")
      setSubcategories1p(response.data);

      // Unique super categories
      // setSuperCategories([...new Set(response.data.map(item => item.super_cat_name))]);
      setSuperCategories(response.data);
    } catch (err) {
      console.error('Error fetching subcategories:', err);
    }
  };

  useEffect(() => {
    fetchSubcategoriesp();
  }, []);
  console.log('this is subcategories1p', subcategories1p);
  console.log('this is productsData', productsData);
  console.log('this is categoriesx', categoriesx);
  console.log('this is subcategories', subcategories);
  // Filter primary categories based on selected super category
  const filteredPrimaryCategories = categoriesx
    // .filter(item => item.super_cat_name === productsData.super_category)
    .map(item => item.name)
    .filter((value, index, self) => self.indexOf(value) === index); // unique

  // Filter subcategories based on selected primary category
  const filteredSubcategoriesp = subcategories.filter(
    subcategory => subcategory.category_name === productsData.category
  );

  // const handleChangeProducts = (e) => {
  //   const { name, value } = e.target;

  //   // Reset dependent dropdowns
  //   if (name === "super_category") {
  //     setProductsData({ super_category: value, category: "", sub_category: "" });
  //   } else if (name === "category") {
  //     setProductsData({ ...productsData, category: value, sub_category: "" });
  //   } else {
  //     setProductsData({ ...productsData, [name]: value });
  //   }
  // };





  const [unitsSelect, setUnitsSelect] = useState([]);
  useEffect(() => { fetchUnitsSelect(); }, []);
  const fetchUnitsSelect = async () => {
    try {
      const res = await axios.get(`https://api.glocart.in/pages/api/units/get`);
      setUnitsSelect(res.data);
    } catch (err) {
      console.error('Error fetching units:', err);
    }
  };

  const [searchTermp, setSearchTermp] = useState('');

  const [productsGet, setProductsGet] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  useEffect(() => {
    axios.get('https://api.glocart.in/pages/api/products/get')
      .then(res => setProductsGet(res.data))
      .catch(err => console.error('Fetch error:', err));
  }, []);
  const ProductCount = productsGet.length;
  const handleView = (product) => { setSelectedProduct(product); };
  const handleBack = () => { setSelectedProduct(null); };
  const handleDeleteProduct = (productId) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    axios.delete(`https://api.glocart.in/pages/api/products/delete/${productId}`)
      .then(res => {
        alert(res.data.message);
        setProductsGet(prev => prev.filter(p => p.id !== productId));
      })
      .catch(err => {
        console.error('Delete error:', err);
        alert('Error deleting product');
      });
  };



















  // notifications

  const notifications = [
    {
      type: 'low-stock',
      message: '⚠️ Low stock alert: Variant "Red - XL" has less than 5 items left.',
      time: '2 minutes ago',
      color: '#ff9800',
    },
    {
      type: 'order-delay',
      message: '📦 Order #12345 is delayed due to courier issues.',
      time: '10 minutes ago',
      color: '#2196f3',
    },
    {
      type: 'payment-issue',
      message: '💳 Payment failed for Order #12346. Please check your settings.',
      time: '30 minutes ago',
      color: '#f44336',
    },
  ];


  const [selectedUnitShipping, setSelectedUnitShipping] = useState(null);
  const [customLabelShipping, setCustomLabelShipping] = useState('');
  const [chargeAmount, setChargeAmount] = useState('');
  const [unitsShipping, setUnitsShipping] = useState([]);
  const [editIdShipping, setEditIdShipping] = useState(null);

  const predefinedUnitsShipping = [
    { value: 'domestic', label: 'Domestic' },
    { value: 'non_domestic', label: 'Non-Domestic' }
  ];

  useEffect(() => {
    // Fetch units from backend
    fetchUnitss();
  }, []);

  const fetchUnitss = async () => {
    try {
      const response = await fetch('https://api.glocart.in/payment/api/api/shipping-charges');
      const data = await response.json();
      setUnitsShipping(data);
    } catch (error) {
      console.error("Error fetching shipping charges:", error);
    }
  };

  const handleSubmitShipping = async (e) => {
    e.preventDefault();

    // Prepare the data to send to the backend
    const newUnit = {
      label: selectedUnitShipping?.label,
      value: chargeAmount,
    };

    try {
      const response = await fetch('https://api.glocart.in/payment/api/api/shipping-charges', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newUnit),
      });

      if (response.ok) {
        fetchUnitss(); // Refresh list of units
      }
    } catch (error) {
      console.error("Error adding shipping charge:", error);
    }
  };

  const handleDeleteUnit = async (unitId) => {
    try {
      const response = await fetch(`https://api.glocart.in/payment/api/api/shipping-charges/${unitId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        fetchUnitss(); // Refresh list after deletion
      }
    } catch (error) {
      console.error("Error deleting shipping charge:", error);
    }
  };

  const handleCancelOrder = async (orderId, cartItems) => {
    const confirm = window.confirm(
      "Are you sure you want to cancel this order?\n\nThis will restock the items."
    );

    if (!confirm) {
      alert("Order cancellation aborted.");
      return;
    }

    try {
      // 1. Cancel the order
      const cancelRes = await fetch(`https://api.glocart.in/payment/api/orders/${orderId}/cancel`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!cancelRes.ok) {
        throw new Error("Order cancellation failed");
      }

      const cancelData = await cancelRes.json();
      console.log("Order cancelled:", cancelData);

      // 2. Restock product variants from cartItems (if available)
      if (Array.isArray(cartItems)) {
        for (const item of cartItems) {
          const { product_id, v_id, quantity } = item;

          if (v_id && quantity) {
            await fetch(`https://api.glocart.in/payment/api/product-variants/${v_id}/restock`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ increaseBy: quantity }),
            });
          }
        }
      }

      alert("Order cancelled and items restocked.");
      // Optional: reload orders or update UI state
    } catch (err) {
      console.error("Cancel failed:", err);
      alert("Failed to cancel order. Please try again.");
    }
  };



  const [selectedOrder, setSelectedOrder] = useState(null);

  const [showRefund, setShowRefund] = useState(false);
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    if (showRefund && selectedOrder) {
      console.log("Fetching data for order:", selectedOrder);

      (async () => {
        try {
          const res = await fetch(`https://api.glocart.in/payment/api/api/orders/${selectedOrder}`);
          const data = await res.json();
          console.log("Fetched order data:", data);
          setOrderData(data);
        } catch (err) {
          console.error('Error loading order data:', err);
        }
      })();
    }
  }, [showRefund, selectedOrder]);


  const Refund = ({ order }) => {
    const item = order.items[0];
    const itemPrice = item.price;
    const taxes = order.tax || 0;
    const maxQuantity = item.quantity;

    const [quantity, setQuantity] = useState(1);
    const [restockItem, setRestockItem] = useState(true);
    const [refundShippingChecked, setRefundShippingChecked] = useState(true);
    const [refundShippingAmount, setRefundShippingAmount] = useState(order.shipping || 0);
    const [refundReason, setRefundReason] = useState("");
    const [refundMethod, setRefundMethod] = useState("Original payment");
    const [refundAmount, setRefundAmount] = useState(itemPrice + taxes + refundShippingAmount);
    const [sendNotification, setSendNotification] = useState(true);

    const handleQuantityChange = (e) => {
      let val = parseInt(e.target.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > maxQuantity) val = maxQuantity;
      setQuantity(val);

      const newRefundAmount = val * itemPrice + taxes + (refundShippingChecked ? refundShippingAmount : 0);
      setRefundAmount(newRefundAmount);
    };

    const handleRefundShippingChange = (e) => {
      const checked = e.target.checked;
      setRefundShippingChecked(checked);

      const newRefundAmount = quantity * itemPrice + taxes + (checked ? refundShippingAmount : 0);
      setRefundAmount(newRefundAmount);
    };

    const handleRefundShippingAmountChange = (e) => {
      let val = parseFloat(e.target.value);
      if (isNaN(val) || val < 0) val = 0;
      setRefundShippingAmount(val);

      const newRefundAmount = quantity * itemPrice + taxes + (refundShippingChecked ? val : 0);
      setRefundAmount(newRefundAmount);
    };

    const handleRefundAmountChange = (e) => {
      let val = parseFloat(e.target.value);
      if (isNaN(val) || val < 0) val = 0;
      setRefundAmount(val);
    };

    //   const handleRefund = () => {
    //     alert(`Refund of ₹${refundAmount.toFixed(2)} initiated via ${refundMethod}`);
    //     // Call your API here
    //   };



    const handleRefund = async () => {
      try {
        const res = await axios.post('https://api.glocart.in/payment/api/api/refund', {
          orderId: selectedOrder,
          refundAmount,
          refundReason,
          sendNotification
        });

        if (res.data.success) {
          alert("Refund processed successfully.");

          //   onClose(); // Optional callback
        }

        setShowRefund(false)
      } catch (error) {
        console.error("Refund error", error);
        alert("Failed to process refund.");
      }
    };




    return (
      <div style={styles.container}>


        {/* Order Information */}
        <div style={styles.card}>
          <div style={{ marginBottom: 8 }}>
            <b>Order {order.orderId || order.id}</b> Refund
          </div>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
            <span style={styles.unfulfilledBadge}>{order.unfulfilled ? "Unfulfilled" : "Fulfilled"}</span>
            <div style={{ marginLeft: 12, fontSize: 12, color: "#555" }}>
              {order.address}
            </div>
          </div>

          {/* Item Info */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={item.image}
              alt={item.name}
              style={styles.productImage}
            />
            <div style={{ flex: 1, marginLeft: 12 }}>
              <div style={{ fontWeight: "bold" }}>{item.name}</div>
              <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>{item.sku}</div>
              <div>
                ₹{itemPrice.toFixed(2)} &nbsp; × &nbsp;
                <input
                  type="number"
                  min={1}
                  max={maxQuantity}
                  value={quantity}
                  onChange={handleQuantityChange}
                  style={styles.quantityInput}
                />
                &nbsp; / {maxQuantity}
              </div>
            </div>
            <div style={{ fontWeight: "bold" }}>₹{(itemPrice * quantity).toFixed(2)}</div>
          </div>

          <div style={{ marginTop: 8, fontSize: 12, color: "#777" }}>
            Refunded items will be removed from the order
          </div>

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={restockItem}
              onChange={() => setRestockItem(!restockItem)}
            />{" "}
            Restock item
          </label>
        </div>

        {/* Refund Shipping */}
        <div style={styles.card}>
          <div style={{ fontWeight: "bold", marginBottom: 8 }}>Refund shipping</div>
          <label style={{ ...styles.checkboxLabel, display: "flex", justifyContent: "space-between" }}>
            <div>
              <input
                type="checkbox"
                checked={refundShippingChecked}
                onChange={handleRefundShippingChange}
              />{" "}
              Standard · ₹{order.shipping.toFixed(2)}
            </div>
            <input
              type="number"
              min={0}
              step={0.01}
              value={refundShippingAmount}
              onChange={handleRefundShippingAmountChange}
              disabled={!refundShippingChecked}
              style={{
                ...styles.shippingInput,
                backgroundColor: refundShippingChecked ? "white" : "#eaeaea",
              }}
            />
          </label>
        </div>

        {/* Refund Reason */}
        <div style={styles.card}>
          <div style={{ fontWeight: "bold", marginBottom: 6 }}>Reason for refund</div>
          <textarea
            placeholder="Add reason for refund"
            value={refundReason}
            onChange={(e) => setRefundReason(e.target.value)}
            style={styles.textarea}
          />
          <div style={{ fontSize: 12, color: "#777", marginTop: 6 }}>
            Only you and other staff can see this reason
          </div>
        </div>

        {/* Summary */}
        <div style={styles.summaryCard}>
          <div style={{ fontWeight: "bold", marginBottom: 16 }}>Summary</div>

          <div style={styles.summaryRow}>
            <div>Item subtotal ({quantity})</div>
            <div>₹{(itemPrice * quantity).toFixed(2)}</div>
          </div>
          <div style={styles.summaryRow}>
            <div>Taxes (Included)</div>
            <div>₹{taxes.toFixed(2)}</div>
          </div>
          <div style={styles.summaryRow}>
            <div>Shipping</div>
            <div>₹{(refundShippingChecked ? refundShippingAmount : 0).toFixed(2)}</div>
          </div>

          <hr style={{ margin: "10px 0" }} />

          <div style={{ ...styles.summaryRow, fontWeight: "bold" }}>
            <div>Refund total</div>
            <div>₹{refundAmount.toFixed(2)}</div>
          </div>

          {/* Refund Method */}
          <div style={{ marginTop: 16 }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: 6 }}>Refund method</label>
            <select
              value={refundMethod}
              onChange={(e) => setRefundMethod(e.target.value)}
              style={styles.select}
            >
              <option>Original payment</option>
              <option>Store credit</option>
              <option>Manual refund</option>
            </select>
          </div>

          {/* Refund Amount */}
          <div style={{ marginTop: 16 }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: 6 }}>Refund amount</label>
            <input
              type="number"
              min={0}
              step={0.01}
              value={refundAmount}
              onChange={handleRefundAmountChange}
              style={styles.input}
            />
            <div style={{ fontSize: 12, color: "#777", marginTop: 4 }}>
              ₹{refundAmount.toFixed(2)} available for refund
            </div>
          </div>

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={sendNotification}
              onChange={() => setSendNotification(!sendNotification)}
            />{" "}
            Send notification once refund is finalized
          </label>

          <button style={styles.refundButton} onClick={handleRefund}>
            Refund ₹{refundAmount.toFixed(2)}
          </button>
        </div>


      </div>
    );
  };


  const RefundModal = ({
    show,
    onHide,
    orderId,
    orderData,
    onOrderDataChange,
  }) => {
    console.log("RefundModal props =>", { show, orderId, orderData });

    return (
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Refund Order #{orderId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!orderData ? (
            <div style={{ textAlign: 'center' }}>Loading...</div>
          ) : (
            <Refund order={orderData} onChange={onOrderDataChange} />
          )}
        </Modal.Body>
      </Modal>
    );
  };


  // const timelineData = [
  //   {
  //     date: "July 29",
  //     events: [
  //       {
  //         text: "This order was archived.",
  //         time: "11:10 AM",
  //       },
  //       {
  //         text: "You sent a shipping confirmation email to Ruatdika Chhakchhuak (nanarennon23@gmail.com).",
  //         time: "11:10 AM",
  //         buttonText: "View email",
  //       },
  //       {
  //         text: "You fulfilled 1 item from Shop no 6, Door no 6-3-10/2, Behind Vimal Theater, Balanagar,.",
  //         time: "11:10 AM",
  //         expandable: true,
  //       },
  //     ],
  //   },
  //   {
  //     date: "July 28",
  //     events: [
  //       {
  //         text: "Order confirmation email was sent to Ruatdika Chhakchhuak.",
  //         time: "3:05 AM",
  //         buttonText: "View email",
  //       },
  //       {
  //         text: "The email nanarennon23@gmail.com was added to this order.",
  //         time: "3:05 AM",
  //       },
  //     ],
  //   },
  // ];

  const [timelineData, setTimelineData] = useState([]);


  const [expandedIndex, setExpandedIndex] = useState(null);
  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };




  // order Fulfillment

  const [showPrintDropdown, setShowPrintDropdown] = useState(false);
  const [showMoreDropdown, setShowMoreDropdown] = useState(false);
  const [showFulfillModal, setShowFulfillModal] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [carrier, setCarrier] = useState('');
  const [fulfillOrderId, setFulfillOrderId] = useState(null); // track which order to fulfill

  const courierCompanies = [
    "Delhivery", "Blue Dart", "Ecom Express", "Shadowfax", "DTDC", "FedEx",
    "India Post", "XpressBees", "Ekart", "Gati", "DHL", "Aramex", "Trackon",
    "Professional Couriers", "Amazon Shipping"
  ];

  useEffect(() => {
    if (!selectedOrder) return;

    fetch(`https://api.glocart.in/payment/api/api/timeline/${selectedOrder}`)
      .then((res) => res.json())
      .then((data) => {
        setTimelineData(data);
      })
      .catch((err) => {
        console.error("Error fetching timeline:", err);
      });
  }, [selectedOrder]);



  const handleFulfillItem = () => {
    setFulfillOrderId(orderDetails.orderNumber);
    setShowFulfillModal(true);
  };

  const handlePrint = () => {
    window.print();
  };

  const [showPrintSlip, setShowPrintSlip] = useState(false);

  function PackageSlip({ orderDetails }) {
    return (
      <div className="package-slip-print">
        <header className="package-slip-header">
          <h1>GloCart</h1>
          <div>
            <div>Order #{orderDetails.orderId}</div>
            <div>{new Date(orderDetails.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
          </div>
        </header>

        <section className="package-slip-addresses">
          <div className="ship-to">
            <h3>SHIP TO</h3>
            <p>{orderDetails.customer.name}</p>
            <p>{orderDetails.customer.shippingAddress}</p>
            <p>{orderDetails.customer.phone}</p>
          </div>

          <div className="bill-to">
            <h3>BILL TO</h3>
            <p>{orderDetails.customer.name}</p>
            <p>{orderDetails.customer.billingAddress || orderDetails.customer.shippingAddress}</p>
            <p>{orderDetails.customer.phone}</p>
          </div>
        </section>

        <section className="package-slip-items">
          <table>
            <thead>
              <tr>
                <th>ITEMS</th>
                <th>QUANTITY</th>
              </tr>
            </thead>
            <tbody>
              {orderDetails.items.map(item => (
                <tr key={item.id}>
                  <td style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                    {item.image && (
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                      />
                    )}
                    <div>
                      <strong>{item.name}</strong> {item.description || ''}
                      <br />
                      <small>{item.barcode || item.id}</small>
                    </div>
                  </td>
                  <td style={{ verticalAlign: 'top' }}>{item.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>


        <footer className="package-slip-footer">
          <p>Thank you for shopping with us!</p>
          <p>GloCart</p>
          <p>Shop no 6, Door no 6-3-10/2, Behind Vimal Theater, Balanagar, 500042 Hyderabad TS, India</p>
          <p>onlinesales@shreenathfoods.com</p>
          <p>shreenathfoods.com</p>
        </footer>
      </div>
    );
  }


  const handlePackageSlipPrint = () => {
    setShowPrintSlip(true);

    setTimeout(() => {
      window.print();
      setShowPrintSlip(false);
    }, 500);  // wait 500ms for the slip to render before printing
  };


  const handleFulfillSubmit = () => {
    if (!trackingNumber || !carrier) {
      alert("Please enter tracking details.");
      return;
    }

    fetch(`https://api.glocart.in/payment/api/api/orders/${fulfillOrderId}/fulfill`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tracking: trackingNumber,
        carrier,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Order fulfilled:', data);
        setShowFulfillModal(false);
        // Optionally refresh order data
      })
      .catch((err) => {
        console.error('Fulfillment failed:', err);
        alert("Error fulfilling order.");
      });
  };


  const [comment, setComment] = useState("");


  //     const orders = Array.from({ length: 10 }, (_, i) => ({
  //         orderId: `#10${50 + i}`,
  //         date: `Aug ${9 - i}, 2025 at ${2 + i}:45 PM`,
  //         customer: `Customer ${i + 1}`,
  //         channel: 'Online Store',
  //         amount: `₹${(700 + i * 50).toFixed(2)}`,
  //         paymentStatus: 'Paid',
  //         fulfillmentStatus: i % 3 === 0 ? 'Unfulfilled' : 'Fulfilled',
  //         items: `${1 + (i % 5)} items`,
  //         tracking: i % 3 === 0 ? '—' : 'Tracking added',
  //         delivery: 'Standard',
  //     }));
  // const ordersData =[ {
  //     orderId: "#1050",
  //   orderNumber: 1050,
  //   paid: true,
  //   unfulfilled: true,
  //   date: "September 1, 2025 at 9:38 am",
  //   source: "Online Store",
  //   items: [
  //     {
  //       id: "8906127310041",
  //       image:
  //         "https://via.placeholder.com/50", // Replace with actual product image URL
  //       name: "Virgo Iodised Salt Sachet 1 Gms X 250 Nos",
  //       price: 67.0,
  //       quantity: 1,
  //       tags: ["Standard", "General Profile"],
  //     },
  //   ],
  //   subtotal: 67.0,
  //   shipping: 75.0,
  //   tax: 10.22,
  //   total: 142.0,
  //   paidAmount: 142.0,
  //   customer: {
  //     name: "Ranjana Sareen",
  //     ordersCount: 1,
  //     email: "ranjanasareen99@yahoo.com",
  //     phone: "+91 77998 70066",
  //     shippingAddress: `Ranjana Sareen
  // Aparna Cyber Commune
  // K 402 Aparna cyber commune, Opp. Citizen Hospital, Nallagandla
  // 500019 Hyderabad TG
  // India`,
  //     billingSameAsShipping: true,
  //   },
  //   conversionSummary: [
  //     "This is their 1st order",
  //     "1st session from Google",
  //     "3 sessions over 1 day",
  //   ],
  // }];


  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://api.glocart.in/payment/api/api/orders')
      .then((res) => res.json())
      .then((data) => {
        setOrders(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load orders:", err);
        setLoading(false);
      });
  }, []);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [ordersData, setOrderDetails] = useState([]);
  // holds just ID
  const [orderDetails, setOrderDetailss] = useState(null);
  // console.log("orderDetails", orderDetails)

  // holds full order object

  const [orderFillPagination, setOrderFillPagination] = useState({
    currentPage: 1,
    itemsPerPage: 15,
  });


  // Filter only paid orders
  const filteredOrders = orders.filter((order) => order.is_paid === 1);

  // Pagination logic
  const startIdx = (orderFillPagination.currentPage - 1) * orderFillPagination.itemsPerPage;
  const paginatedOrders = filteredOrders.slice(startIdx, startIdx + orderFillPagination.itemsPerPage);

  const totalPagess = Math.ceil(filteredOrders.length / orderFillPagination.itemsPerPage);



  const [checkoutFillPagination, setcheckoutFillPagination] = useState({
    currentPage: 1,
    itemsPerPage: 15,
  });


  // Filter only paid orders
  const filteredCheckoutOrders = orders.filter((order) => order.is_paid === 0);

  // Pagination logic
  const startcheckoutIdx = (orderFillPagination.currentPage - 1) * checkoutFillPagination.itemsPerPage;
  const paginatecheckoutdOrders = filteredCheckoutOrders.slice(startcheckoutIdx, startcheckoutIdx + checkoutFillPagination.itemsPerPage);

  const totalcheckoutPagess = Math.ceil(filteredOrders.length / checkoutFillPagination.itemsPerPage);

  const lat = orderDetails?.customer?.lat || orderDetails?.address?.lat;
  const lng = orderDetails?.customer?.lng || orderDetails?.address?.lng;

  const mapUrl = lat && lng ? `https://www.google.com/maps?q=${lat},${lng}` : null;

  useEffect(() => {
    if (!selectedOrder) return;

    fetch(`https://api.glocart.in/payment/api/api/orders/${selectedOrder}`)
      .then((res) => res.json())
      .then((data) => {
        setOrderDetails(data);
        setOrderDetailss(data);
      })
      .catch((err) => {
        console.error("Failed to load order details:", err);
      });
  }, [selectedOrder]);

  // console.log("Selected Order:", selectedOrder) ;







  // -------------------------------super category--------------------------------//

  // ---- React States ----
  const [supercategories, setSupercategories] = useState([]);
  const [formData, setFormData] = useState({ id: null, name: "", image: null, icon: null });
  const [currentPageSC, setCurrentPageSC] = useState(1);
  const itemsPerPageSC = 10;
  // ---- Fetch Data ----
  const fetchData = () => {
    axios.get("https://api.glocart.in/pages/api/api/supercategories")
      .then((res) => setSupercategories(res.data));
  };
  useEffect(() => {
    fetchData();
  }, []);
  // ---- CRUD ----
  const handleSubmitSuper = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("name", formData.name);
    if (formData.image) data.append("image", formData.image);
    if (formData.icon) data.append("icon", formData.icon);

    if (formData.id) {
      await axios.put(`https://api.glocart.in/pages/api/api/supercategories/${formData.id}`, data);
    } else {
      await axios.post("https://api.glocart.in/pages/api/api/supercategories", data);
    }
    setFormData({ id: null, name: "", image: null, icon: null });
    fetchData();
  };
  const handleEditSuper = (cat) => {
    setFormData({
      id: cat.id,
      name: cat.name,
      image: cat.image,
    });
  };
  const handleDeleteSuper = async (id) => {
    await axios.delete(`https://api.glocart.in/pages/api/api/supercategories/${id}`);
    fetchData();
  };
  // ---- Pagination ----
  const totalPagesSC = Math.ceil(supercategories.length / itemsPerPageSC);
  const indexOfLastItemSC = currentPageSC * itemsPerPageSC;
  const indexOfFirstItemSC = indexOfLastItemSC - itemsPerPageSC;
  const currentItemsSC = supercategories.slice(indexOfFirstItemSC, indexOfLastItemSC);

  // -------------------------------categories--------------------------------//

  // --------------------------------Manage Notificatoin-----------------------//


  // Notification code here (Manage Notification)

  const [notificationss, setNotifications] = useState([]);
  const [form, setForm] = useState({
    title: '',
    description: '',
    url: '',
    image: null,
  });

  const [edited, setEdited] = useState(null);

  // Pagination
  const [currentPages, setCurrentPages] = useState(1);
  const perPage = 5;

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const res = await axios.get(
      'https://api.glocart.in/auth/api/api/notifications'
    );
    setNotifications(res.data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  const submitNotification = async () => {
    const data = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key]) data.append(key, form[key]);
    });

    if (edited) {
      await axios.put(
        `https://api.glocart.in/auth/api/api/notifications/${edited}`,
        data
      );
    } else {
      await axios.post(
        'https://api.glocart.in/auth/api/api/notifications',
        data
      );
      alert('Notification sent successfully!');
    }

    resetForms();
    fetchNotifications();
  };

  const resetForms = () => {
    setForm({ title: '', description: '', url: '', image: null });
    setEdited(null);
  };

  // const editNotification = (n) => {
  //   setEdited(n.id);
  //   setForm({
  //     title: n.title,
  //     description: n.description,
  //     url: n.url || '',
  //     image: null,
  //   });
  // };

  // const deleteNotification = async (id) => {
  //   await axios.delete(
  //     `https://spinelleapi.emedha.in/auth/api/api/notifications/${id}`
  //   );
  //   fetchNotifications();
  // };

  // Pagination logic
  const start = (currentPages - 1) * perPage;
  const current = notificationss.slice(start, start + perPage);
  const pages = Math.ceil(notificationss.length / perPage);


  // end here the Manage Notification 

  //---------------------------------Manage Notification-----------------------//




  // -------------------------------Sub category--------------------------------//

  const [rawData, setRawData] = useState([]); // raw joined rows from backend
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    fetchSubcategories();
  }, []);

  const fetchSubcategories = async () => {
    try {
      const res = await fetch("https://api.glocart.in/pages/api/api/subcategories_super"); // your joined GET API
      const data = await res.json();
      setRawData(data || []);
      buildGroups(data || []);
    } catch (err) {
      console.error("Error fetching subcategories:", err);
      setRawData([]);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  // Build grouped structure: unique super categories with unique subcategories underneath
  const buildGroups = (data) => {
    const map = new Map();

    data.forEach((row) => {
      const superId = Number(row.super_cat_id_num ?? row.super_cat_id ?? row.super_cat_id); // handle different field names
      const superName = row.super_cat_name ?? row.super_cat_name ?? row.name ?? row.super_cat_name;
      const superImage = row.super_cat_image ?? row.super_cat_image ?? row.image ?? row.super_cat_image;

      // ensure we have a map entry
      if (!map.has(superId)) {
        map.set(superId, {
          superId,
          superName: superName || "Unknown",
          superImage: superImage || "",
          subcategories: new Map(), // use Map to dedupe subcategories by id
        });
      }

      // get subcategory id (could be 'id' or 's.id' depending on query)
      const subId = Number(row.id ?? row.sub_id ?? row.subcategory_id);
      if (!isNaN(subId)) {
        const subMap = map.get(superId).subcategories;
        if (!subMap.has(subId)) {
          subMap.set(subId, {
            id: subId,
            subCategory: row.subCategory ?? row.sub_category ?? row.sub_cat_name ?? row.subCategory,
            image_sub: row.image_sub ?? row.image_sub ?? row.sub_image ?? "",
            category_name: row.category_name ?? row.category_name ?? "",
            flag: Number(row.flag ?? row.sub_flag ?? 0),
          });
        }
      }
    });

    // convert map -> array and convert inner subcategory Maps to arrays
    const grouped = Array.from(map.values()).map((g) => ({
      superId: g.superId,
      superName: g.superName,
      superImage: g.superImage,
      subcategories: Array.from(g.subcategories.values()),
    }));

    setGroups(grouped);
  };

  const handleCheckboxChange = async (subId, currentFlag) => {
    const newFlag = currentFlag === 1 ? 0 : 1;

    // optimistic UI update: update groups locally first
    setGroups((prev) =>
      prev.map((g) => ({
        ...g,
        subcategories: g.subcategories.map((s) =>
          s.id === subId ? { ...s, flag: newFlag } : s
        ),
      }))
    );

    try {
      const resp = await fetch(`https://api.glocart.in/pages/api/api/subcategories/${subId}/flag`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ flag: newFlag }),
      });
      const result = await resp.json();
      if (!result.success) {
        // revert if backend failed
        setGroups((prev) =>
          prev.map((g) => ({
            ...g,
            subcategories: g.subcategories.map((s) =>
              s.id === subId ? { ...s, flag: currentFlag } : s
            ),
          }))
        );
        console.error("Failed to update flag on server:", result);
      }
    } catch (err) {
      // revert on error
      setGroups((prev) =>
        prev.map((g) => ({
          ...g,
          subcategories: g.subcategories.map((s) =>
            s.id === subId ? { ...s, flag: currentFlag } : s
          ),
        }))
      );
      console.error("Error updating flag:", err);
    }
  };

  //=================================
  // thisis users Members createin 
  //=================================

  //   const [formUsers, setFormUsers] = useState({
  //     name: '',
  //     email: '',
  //     mobile: '',
  //     password: '',
  //     permissions: []
  //   });
  //  const [userEditingId, setUserEditingId] = useState(null);


  const menus = [
    'Dashboard',
    'Brands',
    'Banners',
    'Notifications',
    'Cuisine',
    'Categories',
    'Top Cuisine',
    'Sub Categories',
    'Variant Master',
    'Add Product Form',
    'Analytics',
    'Order Fulfillment',
    'OrderReport',
    'Abandoned checkouts',
    'Products List',
    'Shipping Charges',
    'Reports',
    'Orders'
  ];

  //   const togglePermission = (menu) => {
  //     setFormUsers(prev => ({
  //       ...prev,
  //       permissions: prev.permissions.includes(menu)
  //         ? prev.permissions.filter(p => p !== menu)
  //         : [...prev.permissions, menu]
  //     }));
  //   };

  //   const submitUser = async () => {
  //     await fetch('https://api.glocart.in/pages/api/api/create_user', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(formUsers)
  //     });

  //     alert('User created');
  //   };

  const [users, setUsers] = useState([]);
  const [userEditingId, setUserEditingId] = useState(null);

  const [formUsers, setFormUsers] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    permissions: []
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await fetch('https://api.glocart.in/pages/api/api/users');
    const data = await res.json();
    setUsers(data);
  };

  const togglePermission = (menu) => {
    setFormUsers(prev => ({
      ...prev,
      permissions: prev.permissions.includes(menu)
        ? prev.permissions.filter(p => p !== menu)
        : [...prev.permissions, menu]
    }));
  };

  const submitUser = async () => {
    await fetch('https://api.glocart.in/pages/api/api/create_user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formUsers)
    });
    resetFormUser();
    fetchUsers();
  };

  const editUser = (user) => {
    setUserEditingId(user.id);
    setFormUsers({
      name: user.name,
      email: user.email,
      mobile: user.mobile,
      password: '',
      permissions: JSON.parse(user.permissions)
    });
  };

  const updateUser = async () => {
    await fetch(`https://api.glocart.in/pages/api/api/users/${userEditingId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formUsers)
    });
    resetFormUser();
    fetchUsers();
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    await fetch(`https://api.glocart.in/pages/api/api/users/${id}`, { method: 'DELETE' });
    fetchUsers();
  };

  const resetFormUser = () => {
    setUserEditingId(null);
    setFormUsers({
      name: '',
      email: '',
      mobile: '',
      password: '',
      permissions: []
    });
  };


  useEffect(() => {
    const auth = localStorage.getItem('adminAuth');
    if (!auth) {
      window.location.href = '/login';
    }
  }, []);



  //=====================================
  // users count in dashboard check it 
  //======================================

  const [usersCount, setUsersCount] = useState([]);
  const [thisMonthCount, setThisMonthCount] = useState(0);
  const [lastMonthCount, setLastMonthCount] = useState(0);
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    fetch("https://api.glocart.in/auth/api/userProfile") // change URL if needed
      .then((res) => res.json())
      .then((data) => {
        setUsersCount(data);
        calculateStats(data);
      })
      .catch((err) => console.error(err));
  }, []);

  const calculateStats = (data) => {
    const now = new Date();

    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();

    const lastMonthDate = new Date(thisYear, thisMonth - 1, 1);
    const lastMonth = lastMonthDate.getMonth();
    const lastMonthYear = lastMonthDate.getFullYear();

    const thisMonthUsers = data.filter((user) => {
      const created = new Date(user.created_at);
      return (
        created.getMonth() === thisMonth &&
        created.getFullYear() === thisYear
      );
    });

    const lastMonthUsers = data.filter((user) => {
      const created = new Date(user.created_at);
      return (
        created.getMonth() === lastMonth &&
        created.getFullYear() === lastMonthYear
      );
    });

    setThisMonthCount(thisMonthUsers.length);
    setLastMonthCount(lastMonthUsers.length);

    if (lastMonthUsers.length === 0) {
      setPercentage(100);
    } else {
      const diff =
        ((thisMonthUsers.length - lastMonthUsers.length) /
          lastMonthUsers.length) *
        100;

      setPercentage(diff.toFixed(0));
    }
  };

  const isIncrease = percentage >= 0;



  //======================================
  // this is the sale persentage graph in dashboard
  //========================================
  const [ordersCount, setOrdersCount] = useState([]);
  const [thisMonthSales, setThisMonthSales] = useState(0);
  const [lastMonthSales, setLastMonthSales] = useState(0);
  const [percentageCount, setPercentageCount] = useState(0);

  useEffect(() => {
    fetch("https://api.glocart.in/pages/api/api/orders")
      .then((res) => res.json())
      .then((data) => {
        setOrdersCount(data);
        calculateSales(data);
        calculateSalesChart(data);
      })
      .catch((err) => console.error(err));
  }, []);

  const calculateSales = (data) => {
    const now = new Date();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();

    const lastMonthDate = new Date(thisYear, thisMonth - 1, 1);
    const lastMonth = lastMonthDate.getMonth();
    const lastMonthYear = lastMonthDate.getFullYear();

    // only paid orders
    const paidOrders = data.filter((order) => order.is_paid === 1);

    const thisMonthPaid = paidOrders.filter((order) => {
      const created = new Date(order.created_at);
      return (
        created.getMonth() === thisMonth &&
        created.getFullYear() === thisYear
      );
    });

    const lastMonthPaid = paidOrders.filter((order) => {
      const created = new Date(order.created_at);
      return (
        created.getMonth() === lastMonth &&
        created.getFullYear() === lastMonthYear
      );
    });

    setThisMonthSales(thisMonthPaid.length);
    setLastMonthSales(lastMonthPaid.length);

    if (lastMonthPaid.length === 0) {
      setPercentageCount(100);
    } else {
      const diff =
        ((thisMonthPaid.length - lastMonthPaid.length) /
          lastMonthPaid.length) *
        100;

      setPercentageCount(diff.toFixed(0));
    }
  };

  const totalSales = ordersCount.filter((o) => o.is_paid === 1).length;
  const isIncreaseSale = percentageCount >= 0;

  //======================
  //=====sale chart
  //=====================


  const [salesDataChart, setSalesData] = useState([]);


  const calculateSalesChart1 = (orders) => {
    // last 6 months labels
    const months = [];
    const now = new Date();

    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push({
        month: date.toLocaleString("default", { month: "short" }),
        monthIndex: date.getMonth(),
        year: date.getFullYear(),
        value: 0,
      });
    }

    // count only paid orders
    orders.forEach((order) => {
      if (order.is_paid === 1) {
        const created = new Date(order.created_at);

        months.forEach((m) => {
          if (
            created.getMonth() === m.monthIndex &&
            created.getFullYear() === m.year
          ) {
            m.value += 1;
          }
        });
      }
    });

    setSalesData(months);
  };

  const calculateSalesChart = (orders) => {
    const months = [];
    const now = new Date();

    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push({
        month: date.toLocaleString("default", { month: "short" }),
        monthIndex: date.getMonth(),
        year: date.getFullYear(),
        paid: 0,
        rejected: 0,
      });
    }

    orders.forEach((order) => {
      const created = new Date(order.created_at);

      months.forEach((m) => {
        if (
          created.getMonth() === m.monthIndex &&
          created.getFullYear() === m.year
        ) {
          if (order.is_paid === 1) {
            m.paid += 1;
          } else {
            m.rejected += 1;
          }
        }
      });
    });

    setSalesData(months);
  };


  // const maxValueChart = Math.max(...salesData.map((d) => d.value), 1);

  const maxValueChart = Math.max(
    ...salesDataChart.map((d) => d.paid + d.rejected),
    1
  );
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: "",
    value: 0,
  });
  const Tooltip = ({ tooltip }) => {
    if (!tooltip.visible) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: tooltip.y + 10,
          left: tooltip.x + 10,
          background: "#111827",
          color: "#fff",
          padding: "8px 12px",
          borderRadius: "8px",
          fontSize: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          zIndex: 9999,
          pointerEvents: "none",
          minWidth: "120px",
        }}
      >
        <div style={{ fontWeight: "600", marginBottom: "4px" }}>
          {tooltip.label}
        </div>
        <div style={{ opacity: 0.9 }}>Count: {tooltip.value}</div>
      </div>
    );
  };

  //========================================
  // this is tooltip for chart 
  //===================================

  // const [trafficTooltip, setTrafficTooltip] = useState({
  //   visible: false,
  //   x: 0,
  //   y: 0,
  //   label: "",
  //   value: 0,
  // });


  // const generateColors = (count) => {
  //   return Array.from({ length: count }, (_, i) => {
  //     const hue = Math.floor((360 / count) * i); // evenly spaced
  //     return `hsl(${hue}, 70%, 55%)`; // vibrant & readable
  //   });
  // };

  // const trafficColors = generateColors(categories.length);

  // const totalTraffic = categories.reduce((sum, c) => sum + c.count, 0);

  // let cumulativeOffset = 0;


  // const TrafficTooltip = ({ tooltip }) => {
  //   if (!tooltip.visible) return null;

  //   return (
  //     <div
  //       style={{
  //         position: "fixed",
  //         top: tooltip.y + 12,
  //         left: tooltip.x + 12,
  //         background: "#111827",
  //         color: "#fff",
  //         padding: "10px 14px",
  //         borderRadius: "10px",
  //         fontSize: "12px",
  //         boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
  //         zIndex: 9999,
  //         pointerEvents: "none",
  //         minWidth: "140px",
  //       }}
  //     >
  //       <div style={{ fontWeight: 600, marginBottom: 4 }}>
  //         {tooltip.label}
  //       </div>
  //       <div style={{ opacity: 0.85 }}>Count: {tooltip.value}</div>
  //     </div>
  //   );
  // };


  // Tooltip component
  const TrafficTooltip = ({ tooltip }) => {
    if (!tooltip.visible) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: tooltip.y + 12,
          left: tooltip.x + 12,
          background: "#111827",
          color: "#fff",
          padding: "10px 14px",
          borderRadius: "10px",
          fontSize: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
          zIndex: 9999,
          pointerEvents: "none",
          minWidth: "140px",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 4 }}>{tooltip.label}</div>
        <div style={{ opacity: 0.85 }}>Count: {tooltip.value}</div>
      </div>
    );
  };

  const [trafficTooltip, setTrafficTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: "",
    value: 0,
  });

  // Dynamic colors for categories
  const generateColors = (count) =>
    Array.from({ length: count }, (_, i) => `hsl(${(i * 360) / count}, 70%, 55%)`);

  const trafficColors = generateColors(categories.length);

  const totalTraffic = categories.reduce((sum, c) => sum + c.count, 0);

  const circleRadius = 15.9155; // for SVG viewBox 36
  const circumference = 2 * Math.PI * circleRadius;

  let cumulativePercentage = 0;

  const circles = categories.map((cat, i) => {
    const percentage = cat.count / totalTraffic;
    const dashArray = `${percentage * circumference} ${circumference}`;
    const dashOffset = circumference * (1 - cumulativePercentage);
    cumulativePercentage += percentage;

    return (
      <circle
        key={cat.id}
        cx="18"
        cy="18"
        r={circleRadius}
        fill="none"
        stroke={trafficColors[i]}
        strokeWidth="5"
        strokeDasharray={dashArray}
        strokeDashoffset={dashOffset}
        strokeLinecap="round"
        onMouseEnter={(e) =>
          setTrafficTooltip({
            visible: true,
            x: e.clientX,
            y: e.clientY,
            label: cat.name,
            value: cat.count,
          })
        }
        onMouseMove={(e) =>
          setTrafficTooltip((prev) => ({ ...prev, x: e.clientX, y: e.clientY }))
        }
        onMouseLeave={() =>
          setTrafficTooltip((prev) => ({ ...prev, visible: false }))
        }
        style={{ cursor: "pointer", transition: "all 0.2s" }}
      />
    );
  });


  // report screen code 

  const [activeReport, setActiveReport] = useState("daily");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  //  const today = new Date();
  const today = new Date().toDateString();
  // const today = new Date("Mar 8, 2026");


  // const dailyOrders = orders.filter((o) => {
  //   const orderDate = new Date(o.date);

  //   return (
  //     orderDate.getFullYear() === today.getFullYear() &&
  //     orderDate.getMonth() === today.getMonth() &&
  //     orderDate.getDate() === today.getDate()
  //   );
  // });

  const dailyOrders = orders.filter((order) => order.is_paid === 1).filter((o) => {
    const orderDate = new Date(o.date).toDateString();
    return orderDate === today;
  });


  console.log('this is orders', orders)

  console.log('this is today', today)

  console.log("dailyOrders", dailyOrders);

  console.log('this is dailyOrders', dailyOrders)
  //const dailySalesAmount = dailyOrders.reduce((sum, o) => sum + o.amount, 0);

  const dailySalesAmount = dailyOrders.reduce((sum, o) => {
    const amount = parseFloat(o.amount.replace("₹", ""));
    return sum + amount;
  }, 0);

  const chartData = dailyOrders.map((o) => ({
    orderId: o.orderId,
    amount: parseFloat(o.amount.replace(/[₹,]/g, "")),
  }));

  const dailyStats = [
    { label: "Orders", value: dailyOrders.length },
    {
      label: "Items Ordered",
      // value: dailyOrders.reduce((sum, o) => sum + o.items, 0),
      value: dailyOrders.reduce((sum, o) => {
        return sum + parseInt(o.items);
      }, 0)
    },
    {
      label: "Revenue",
      value: dailySalesAmount,
    },
  ];

  // Pie Chart Data

  const pieData = [
    {
      name: "Fulfilled",
      value: dailyOrders.filter((o) => o.fulfillmentStatus === "Fulfilled")
        .length,
    },
    {
      name: "Unfulfilled",
      value: dailyOrders.filter((o) => o.fulfillmentStatus === "Unfulfilled")
        .length,
    },
  ];

  // -------- COMPLETE SALES (DATE RANGE) --------

  // const filteredOrderss = orders.filter((o) => {
  //   if (!fromDate || !toDate) return true;
  //   return o.date >= fromDate && o.date <= toDate;
  // });
  const filteredOrderss = orders.filter((order) => order.is_paid === 1).filter((order) => {
    const orderDate = new Date(order.date);

    if (!fromDate && !toDate) return true;

    if (fromDate && orderDate < new Date(fromDate)) return false;

    if (toDate && orderDate > new Date(toDate)) return false;

    return true;
  });
  // const filteredOrderss = orders.filter((o) => {
  //   if (!fromDate || !toDate) return true;

  //   const orderDate = new Date(o.date);
  //   const from = new Date(fromDate);
  //   const to = new Date(toDate);

  //   // return orderDate >= from && orderDate <= to;
  //   return orderDate >= from && orderDate <= to;
  // });

  const barData = filteredOrderss.map((o) => ({
    name: o.orderId,
    Sales: parseFloat(o.amount.replace(/[₹,]/g, "")),
  }));

  const lineData = [...filteredOrderss]
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .map((o) => ({
      name: new Date(o.date).toLocaleDateString(),
      sales: Number(o.amount.replace(/[₹,]/g, "")),
    }));




  // order fullfillment report data check 

  //   const [selectedReportOrder, setSelectedReportOrder] = useState("");
  //   const [reportData, setReportData] = useState({});
  //   const [isEditMode, setIsEditMode] = useState(false);


  //   const handleSelectOrder = (orderId) => {
  //   setSelectedReportOrder(orderId);

  //   const order = orders.find((o) => o.id == orderId);

  //   if (!order) return;

  //   const address = JSON.parse(order.address || "{}");
  //   const items = JSON.parse(order.cartItems || "[]");

  //   if (!order.fulfillment_report) {
  //     // No data → enable edit mode
  //     setIsEditMode(true);

  //     setReportData({
  //       orderId: order.id,
  //       name: address.firstName || "",
  //       address1: address.fullAddress || "",
  //       city: "Hyderabad",
  //       state: "Telangana",
  //       postal: "500003",
  //       email: address.email,
  //       phone: address.mobile,
  //       product: items[0]?.productName || "",
  //       weight: 1,
  //       value: order.totals?.grandTotal || 0
  //     });

  //   } else {
  //     // Already exists → show data
  //     setIsEditMode(false);
  //     setReportData(order.fulfillment_report);
  //   }
  // };

  // const handleSaveReport = async () => {
  //   try {
  //     const res = await fetch(`YOUR_API_URL/save-fulfillment-report`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json"
  //       },
  //       body: JSON.stringify({
  //         orderId: selectedReportOrder,
  //         data: reportData
  //       })
  //     });

  //     if (res.ok) {
  //       alert("Saved successfully");
  //       setIsEditMode(false);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const [orderss, setOrderss] = useState([]);

  useEffect(() => {
    fetch('https://api.glocart.in/pages/api/api/ordersReports')
      .then((res) => res.json())
      .then((data) => {
        setOrderss(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load orders:", err);
        setLoading(false);
      });
  }, []);


  const [selectedReportOrder, setSelectedReportOrder] = useState("");
  const [reportData, setReportData] = useState(null);

  console.log("ORDERSss:", orderss);

  const productMap = {};
  productsGet.forEach(p => {
    productMap[p.id] = p;
  });

  const formatDateToMySQL = (date) => {
    if (!date) return null;

    // if already YYYY-MM-DD
    if (date.includes("-") && date.length === 10 && date[4] === "-") {
      return date;
    }

    // convert DD-MM-YYYY → YYYY-MM-DD
    const [dd, mm, yyyy] = date.split("-");
    if (dd && mm && yyyy) {
      return `${yyyy}-${mm}-${dd}`;
    }

    return date;
  };
  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

//   const fetchStateFromPincode = async (pincode) => {
//   const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
//   const data = await res.json();

//   if (data[0].Status === "Success") {
//     const postOffice = data[0].PostOffice[0];
//     setCity(postOffice.District);
//     setState(postOffice.State);
//   }
// };
  const mapOrderToReport = (order) => {
    const addr = order.address || {};
    const items = order.cartItems || [];

    const addressLines = (addr.fullAddress || "").split("\n");

    // ✅ CATEGORY (productType)
    const categories = items.map(i => {
      const product = productMap[i.productId];
      return product?.category || "";
    }).filter(Boolean);

    const uniqueCategories = [...new Set(categories)];

    // ✅ TOTAL WEIGHT (KG)
    const totalWeight = items.reduce((sum, i) => {
      let weight = 0;

      if (i.unit === "g") {
        weight = i.unit_value;
      } else if (i.unit === "ltr") {
        weight = i.unit_value;
      }

      return sum + (weight * (i.quantity || 1));
    }, 0);

    // ✅ STATE FIX
    const getStateFromAddress = () => {
      if (addr.state) return addr.state;

      const line = addressLines[2] || "";

      if (line.includes("TG")) return "Telangana";
      if (line.includes("AP")) return "Andhra Pradesh";

      return "";
    };

    return {
      orderId: order.orderId || "",

      recipientName: addr.firstName || "",
      deliveryNote: order.deliveryNote||"",

      addressLine1: addressLines[0] || addr.house || "",
      addressLine2: addressLines[1] || addr.landmark || "",

      landmark: addr.landmark || "",

      city: addr.city || addressLines[1] || "",
      // state: addr.getStateFromAddress(State),
      state: addr.state || getStateFromAddress(),

      postalCode:
        addr.pincode ||
        addressLines.join(" ").match(/\d{6}/)?.[0] ||
        "",

      email: addr.email || "",
      phone: addr.mobile || "",

      productDescription: items.map(i => i.name || i.productName).join(", "),

      // ✅ FIXED
      productType: uniqueCategories.join(", "),

      length: order.length || "",
      width: order.width || "",
      height: order.height || "",

      // ✅ FIXED
      weight: totalWeight.toFixed(2),

      invoiceNumber: order.invoiceNumber || "",
      // invoiceDate:order.invoiceDate|| "",
      invoiceDate: formatDate(order.invoiceDate),

      productValue: order.totals?.grandTotal || "",

      cgst: order.cgst || "",
      sgst: order.sgst || "",
      igst: order.igst || "",

      cod: order.is_paid === 1 ? "No" : "Yes",
      shippingService: order.delivery || "",

      pickupDate: formatDate(order.pickupDate),
      // pickupDate: order.pickupDate ||"",
      pickupTime: order.pickupTime || "",
      // deliveryDate:  order.deliveryDate ||""
      deliveryDate: formatDate(order.deliveryDate),
    };
  };


  // const handleUpdate = async () => {
  //   await fetch(`http://localhost:3002/pages/api/api/orderss/${selectedReportOrder.replace("#","")}`, {
  //     method: "PUT",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(reportData), // ✅ SEND FULL OBJECT
  //   });

  //   alert("Full order updated");
  // };

  const handleUpdate = async () => {
    const payload = {
      ...reportData,

      invoiceDate: formatDateToMySQL(reportData.invoiceDate),
      pickupDate: formatDateToMySQL(reportData.pickupDate),
      deliveryDate: formatDateToMySQL(reportData.deliveryDate),
    };

    await fetch(
      `https://api.glocart.in/pages/api/api/ordersReports/${selectedReportOrder.replace("#", "")}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    alert("Full order updated");
  };

  // const [isExcelMode, setIsExcelMode] = useState(false);
  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");
  // const [filteredData, setFilteredData] = useState([]);


  // const handleFilter = () => {
  //   if (!fromDate || !toDate) return;

  //   const from = new Date(fromDate);
  //   const to = new Date(toDate);

  //   const result = orderss.filter((order) => {
  //     const created = new Date(order.created_at);
  //     return created >= from && created <= to;
  //   });

  //   setFilteredData(result);
  // };
  // const exportToExcel = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(filteredData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const fileData = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(fileData, "orders.xlsx");
  // };

  const [isExcelMode, setIsExcelMode] = useState(false);

  // ✅ Use your existing state names
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [filteredData, setFilteredData] = useState([]);

  // ✅ Default dates (last 7 days)
  useEffect(() => {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    setEndDate(today.toISOString().split("T")[0]);
    setStartDate(lastWeek.toISOString().split("T")[0]);
  }, []);

  // ✅ Filter using created_at
  const handleFilter = () => {
    if (!startDate || !endDate) return;

    const from = new Date(startDate);
    const to = new Date(endDate);
    to.setHours(23, 59, 59, 999);

    const result = orderss.filter((order) => {
      const created = new Date(order.created_at);
      return created >= from && created <= to;
    });

    setFilteredData(result);
  };

  // ✅ Export Excel
  // const exportToExcel = () => {
  //   if (filteredData.length === 0) return;

  //   const worksheet = XLSX.utils.json_to_sheet(filteredData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const fileData = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(fileData, "orders.xlsx");
  // };


  // const exportToExcel = () => {
  //   if (filteredData.length === 0) return;

  //   // ✅ Convert ALL data to report format
  //   const mappedData = filteredData.map((order) =>
  //     mapOrderToReport(order)
  //   );

  //   // ✅ Optional: Rename headers (better Excel view)
  //   const formattedData = mappedData.map((item) => ({
  //     "Client Reference ID": item.orderId,
  //     "Recipient Name": item.recipientName,
  //     "Delivery Note": item.deliveryNote,
  //     "Address Line 1": item.addressLine1,
  //     "Address Line 2": item.addressLine2,
  //     "Landmark": item.landmark,
  //     City: item.city,
  //     State: item.state,
  //     "Postal Code": item.postalCode,
  //     Email: item.email,
  //     Phone: item.phone,
  //     "Product Description": item.productDescription,
  //     "Product Type": item.productType,
  //     "Length (cm)": item.length,
  //     "Width (cm)": item.width,
  //     "Height (cm)": item.height,
  //     "Weight (KG)": item.weight,
  //     "Invoice Number": item.invoiceNumber,
  //     "Invoice Date": item.invoiceDate,
  //     "Product Value": item.productValue,
  //     CGST: item.cgst,
  //     SGST: item.sgst,
  //     IGST: item.igst,
  //     COD: item.cod,
  //     "Shipping Service": item.shippingService,
  //     "Pickup Date": item.pickupDate,
  //     "Pickup Time": item.pickupTime,
  //     "Delivery Date": item.deliveryDate,
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const fileData = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(fileData, "orders_report.xlsx");
  // };

const exportToExcel = () => {
  if (filteredData.length === 0) return;

  const mappedData = filteredData.map((order) =>
    mapOrderToReport(order)
  );

  const formattedData = mappedData.map((item) => ({
    "Client Reference ID": item.orderId,
    "Recipient Name": item.recipientName,
    "Delivery Note": item.deliveryNote,
    "Address Line 1": item.addressLine1,
    "Address Line 2": item.addressLine2,
    "Landmark": item.landmark,
    City: item.city,
    State: item.state,
    "Postal Code": item.postalCode,
    Email: item.email,
    Phone: item.phone,
    "Product Description": item.productDescription,
    "Product Type": item.productType,
    "Length (cm)": item.length,
    "Width (cm)": item.width,
    "Height (cm)": item.height,
    "Weight (KG)": item.weight,
    "Invoice Number": item.invoiceNumber,
    "Invoice Date": item.invoiceDate,
    "Product Value": item.productValue,
    CGST: item.cgst,
    SGST: item.sgst,
    IGST: item.igst,
    COD: item.cod,
    "Shipping Service": item.shippingService,
    "Pickup Date": item.pickupDate,
    "Pickup Time": item.pickupTime,
    "Delivery Date": item.deliveryDate,
  }));

  // ✅ FILTER: remove rows with empty/null values
  const cleanData = formattedData.filter((row) =>
    Object.values(row).every(
      (val) => val !== "" && val !== null && val !== undefined
    )
  );

  if (cleanData.length === 0) {
    alert("No complete data available to export");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet(cleanData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const fileData = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(fileData, "orders_report.xlsx");
};


  const formattedData = filteredData.map((order) => {
    const item = mapOrderToReport(order);

    return {
      "Client Reference ID": item.orderId,
      "Recipient Name": item.recipientName,
      "Delivery Note": item.deliveryNote,
      "Address Line 1": item.addressLine1,
      "Address Line 2": item.addressLine2,
      "Landmark": item.landmark,
      City: item.city,
      State: item.state,
      "Postal Code": item.postalCode,
      Email: item.email,
      Phone: item.phone,
      "Product Description": item.productDescription,
      "Product Type": item.productType,
      "Length (cm)": item.length,
      "Width (cm)": item.width,
      "Height (cm)": item.height,
      "Weight (KG)": item.weight,
      "Invoice Number": item.invoiceNumber,
      "Invoice Date": item.invoiceDate,
      "Product Value": item.productValue,
      CGST: item.cgst,
      SGST: item.sgst,
      IGST: item.igst,
      COD: item.cod,
      "Shipping Service": item.shippingService,
      "Pickup Date": item.pickupDate,
      "Pickup Time": item.pickupTime,
      "Delivery Date": item.deliveryDate,
    };
  });
  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 80, color: "#555" }}>
        Loading subcategories...
      </div>
    );
  }



  const renderContent = () => {
    switch (activeComponent) {
      case 'Dashboard':
        return (
          <>
            <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', padding: '40px', fontFamily: 'Arial, sans-serif' }}>
              <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '25px', color: '#111827' }}>📊 Dashboard Overview</h2>

              {/* STAT CARDS */}
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                {[
                  { label: 'TOTAL Products', value: ProductCount, note: '↑ 12% Since last month', color: '#22c55e' },
                  { label: 'Total Customers', value: `${usersCount.length}`, note: `${isIncrease ? "↑" : "↓"} ${Math.abs(percentage)}% Since last month (${thisMonthCount})`, color: '#ef4444' },
                  { label: 'Total Sales', value: totalSales, note: `${isIncreaseSale ? "↑" : "↓"} ${Math.abs(percentageCount)}% Since last month (${thisMonthSales})`, color: '#6366f1' },
                  // { label: 'Total Profit', value: '$15k', note: '', color: '#8b5cf6' },
                ].map((item, idx) => (
                  <div key={idx} style={{ backgroundColor: '#ffffff', flex: '1', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', minWidth: '220px' }}>
                    <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>{item.label.toUpperCase()}</div>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: item.color }}>{item.value}</div>
                    {item.note && <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>{item.note}</div>}
                    {item.label === 'Total Sales' && (
                      <div style={{ marginTop: '10px', height: '6px', borderRadius: '4px', background: '#e5e7eb' }}>
                        <div style={{ height: '6px', borderRadius: '4px', background: item.color, width: '75.5%' }}></div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* SALES + DONUT CHART */}
              <div style={{ marginTop: '40px', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                {/* SALES BAR CHART */}
                {/* <div style={{ backgroundColor: '#ffffff', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', flex: 2, minWidth: '300px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '12px', color: '#111827' }}>Sales</div>
                  <div style={{ display: 'flex', alignItems: 'flex-end', height: '200px', gap: '6px' }}>
                    {salesDataChart.map((d, i) => (
                      <div key={i} style={{ flex: '1', height: `${(d.value / maxValueChart) * 100}%`, background: '#6366f1', borderRadius: '6px 6px 0 0' }}></div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                    {salesDataChart.map((d, i) => <div key={i}>{d.month}</div>)}
                  </div>
                </div> */}


                <div
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "20px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    flex: 2,
                    minWidth: "300px",
                  }}
                >
                  <div style={{ fontWeight: "bold", marginBottom: "12px", color: "#111827" }}>
                    Sales
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      height: "200px",
                      gap: "6px",
                    }}
                  >
                    {/* {salesDataChart.map((d, i) => {
                      const total = d.paid + d.rejected;
                      const totalHeight = (total / maxValueChart) * 100;
                      const paidHeight = (d.paid / total) * 100;
                      const rejectedHeight = (d.rejected / total) * 100;

                      return (
                        <div
                          key={i}
                          style={{
                            flex: 1,
                            height: `${totalHeight}%`,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >

                          <div
                            style={{
                              height: `${paidHeight}%`,
                              background: "#2563eb",
                              borderRadius: "6px 6px 0 0",
                            }}
                          />

                          <div
                            style={{
                              height: `${rejectedHeight}%`,
                              background: "#ef4444",
                            }}
                          />
                        </div>
                      );
                    })} */}


                    {salesDataChart.map((d, i) => {
                      const total = d.paid + d.rejected;
                      const totalHeight = (total / maxValueChart) * 100;
                      const paidHeight = (d.paid / total) * 100;
                      const rejectedHeight = (d.rejected / total) * 100;

                      return (
                        <div
                          key={i}
                          style={{
                            flex: 1,
                            height: `${totalHeight}%`,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                          }}
                        >
                          {/* Paid */}
                          <div
                            onMouseEnter={(e) =>
                              setTooltip({
                                visible: true,
                                x: e.clientX,
                                y: e.clientY,
                                label: `${d.month} - Paid`,
                                value: d.paid,
                              })
                            }
                            onMouseMove={(e) =>
                              setTooltip((prev) => ({
                                ...prev,
                                x: e.clientX,
                                y: e.clientY,
                              }))
                            }
                            onMouseLeave={() =>
                              setTooltip({ ...tooltip, visible: false })
                            }
                            style={{
                              height: `${paidHeight}%`,
                              background: "#2563eb",
                              borderRadius: "6px 6px 0 0",
                              cursor: "pointer",
                            }}
                          />

                          {/* Rejected */}
                          <div
                            onMouseEnter={(e) =>
                              setTooltip({
                                visible: true,
                                x: e.clientX,
                                y: e.clientY,
                                label: `${d.month} - Rejected`,
                                value: d.rejected,
                              })
                            }
                            onMouseMove={(e) =>
                              setTooltip((prev) => ({
                                ...prev,
                                x: e.clientX,
                                y: e.clientY,
                              }))
                            }
                            onMouseLeave={() =>
                              setTooltip({ ...tooltip, visible: false })
                            }
                            style={{
                              height: `${rejectedHeight}%`,
                              background: "#ef4444",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      );
                    })}
                    <Tooltip tooltip={tooltip} />




                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "12px",
                      color: "#6b7280",
                      marginTop: "8px",
                    }}
                  >
                    {salesDataChart.map((d, i) => (
                      <div key={i}>{d.month}</div>
                    ))}
                  </div>

                  {/* Legend */}
                  <div style={{ display: "flex", gap: "12px", marginTop: "10px", fontSize: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <span style={{ width: 10, height: 10, background: "#2563eb" }}></span> Paid
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <span style={{ width: 10, height: 10, background: "#ef4444" }}></span> Rejected
                    </div>
                  </div>
                </div>

                {/* TRAFFIC DONUT CHART */}
                <div style={{ backgroundColor: '#ffffff', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', flex: 1, minWidth: '260px', textAlign: 'center' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '12px', color: '#111827' }}>Traffic Source</div>

                  {/* Donut Chart */}
                  {/* <svg width="160" height="160" viewBox="0 0 36 36" style={{ margin: 'auto', display: 'block' }}>
                    <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#10b981" strokeWidth="5" strokeDasharray="20 80" strokeDashoffset="0" />
                    <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#f59e0b" strokeWidth="5" strokeDasharray="20 80" strokeDashoffset="-20" />
                    <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#6366f1" strokeWidth="5" strokeDasharray="20 80" strokeDashoffset="-40" />
                    <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#ec4899" strokeWidth="5" strokeDasharray="20 80" strokeDashoffset="-60" />
                    <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#f43f5e" strokeWidth="5" strokeDasharray="20 80" strokeDashoffset="-80" />
                  </svg> */}

                  {/* Labels   categories */}
                  {/* <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '16px', fontSize: '14px', color: '#6b7280', justifyItems: 'center' }}>
                    {/* <div>🥤 Beverages</div>
                    <div>🍱 Food</div>
                    <div>🧁 Baking</div>
                    <div>🧂 Seasonings</div>
                    <div>🌍 Imported Food</div>
                    {categories.map((category, i) => (
    <span key={category.id}>
      <a
        // href={`/categories/${encodeURIComponent(category.name)}`}
        style={{ color: '#000', textDecoration: 'none' }}
      >
        {category.name}
      </a>
      {i < categories.length - 1 && ', '}
    </span>
  ))}
                  </div> */}


                  {/* Labels */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "10px",
                      marginTop: "16px",
                      fontSize: "13px",
                      color: "#374151",
                      justifyItems: "start",
                    }}
                  >
                    {categories.map((cat, i) => (
                      <div key={cat.id} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span
                          style={{
                            width: 10,
                            height: 10,
                            background: trafficColors[i],
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        />
                        <span>{cat.name}</span>
                      </div>
                    ))}
                  </div>

                </div>

              </div>

              <div style={{ padding: '20px' }}>
                <h5>Product Stock Dashboard</h5>

                {productsGet.map((product) => {
                  const lowStockVariants = product.variants.filter((v) => v.stock <= 5);

                  if (lowStockVariants.length === 0) return null;

                  return (
                    <div key={product.id} style={{ marginBottom: '40px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <h6 style={{ margin: 0 }}>{product.name}</h6>
                        <button onClick={() => handleEditProduct(product.id)} title="Edit" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, }}><FaEdit size={18} color="#0051ff" /></button>
                      </div>

                      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead>
                          <tr>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Type</th>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Unit</th>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Value</th>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Price</th>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Quantity</th>
                            <th style={{ border: '1px solid #ccc', padding: '6px', backgroundColor: '#f0f0f0', textAlign: 'left' }}>Stock</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lowStockVariants.map((v) => {
                            let stockColor = '';
                            let stockLabel = '';

                            if (v.stock === 0) {
                              stockColor = '#ef4444'; // red
                              stockLabel = 'Out of Stock';
                            } else if (v.stock <= 3) {
                              stockColor = '#facc15'; // yellow
                              stockLabel = `${v.stock} left`;
                            } else if (v.stock <= 5) {
                              stockColor = '#3b82f6'; // blue
                              stockLabel = `${v.stock} left`;
                            }

                            return (
                              <tr key={v.id}>
                                <td style={{ border: '1px solid #ccc', padding: '6px' }}>{v.type}</td>
                                <td style={{ border: '1px solid #ccc', padding: '6px' }}>{v.unit}</td>
                                <td style={{ border: '1px solid #ccc', padding: '6px' }}>{v.unit_value}</td>
                                <td style={{ border: '1px solid #ccc', padding: '6px' }}>₹{v.price}</td>
                                <td style={{ border: '1px solid #ccc', padding: '6px' }}>{v.quantity}</td>
                                <td style={{ border: '1px solid #ccc', padding: '6px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  {v.stock}
                                  <span style={{
                                    backgroundColor: stockColor,
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '12px'
                                  }}>
                                    {stockLabel}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  );
                })}
              </div>



            </div>
          </>
        );
      case 'Brands':
        return (
          <>
            <div style={{ margin: '0 auto', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>🏷️ Brands Management</h2>
              <p style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>Add or update Brands categories here.</p>

              <form
                //onClick={handleSubmitBrand} 
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmitBrand();
                }}
                style={{ marginBottom: '20px' }}>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Brand Name" style={{ padding: '10px', marginRight: '10px', borderRadius: '4px' }} />
                <input type="file" onChange={(e) => setImage(e.target.files[0])} accept="image/*" style={{ marginRight: '10px' }} />
                <button style={{ padding: '12px 20px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', border: 'none', borderRadius: '8px', background: 'linear-gradient(145deg, #6a82fb, #fc5c7d)', color: 'white', transition: 'all 0.3s ease', }}>
                  {editingId ? 'Update Brand' : '+ Add Brand'}
                </button>
              </form >

              <div>
                <Table striped bordered hover responsive style={{ textAlign: 'center', overflow: 'hidden', width: '100%' }}>
                  <thead style={{ backgroundColor: '#6a82fb', color: 'white' }}>
                    <tr>
                      <th >Brand Name</th>
                      <th >Image</th>
                      <th >Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBrands.map((brand) => (
                      <tr key={brand.id}>
                        <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>{brand.name}</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>{brand.image_url && (<img src={brand.image_url} alt={brand.name} style={{ width: '50px' }} />)}</td>
                        <td style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                          <button onClick={() => handleEditBrand(brand)} style={{ marginRight: '8px', padding: '6px 12px', backgroundColor: '#f0ad4e', border: 'none', borderRadius: '4px', color: 'white' }}>Edit</button>
                          <button onClick={() => handleDeleteBrand(brand.id)} style={{ padding: '6px 12px', backgroundColor: '#d9534f', border: 'none', borderRadius: '4px', color: 'white' }}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <button onClick={() => setCurrentPageb((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPageb === 1}
                    style={{ padding: '6px 12px', marginRight: '10px', borderRadius: '4px', border: '1px solid #ccc', cursor: 'pointer', }}>
                    ⬅ Prev
                  </button>
                  <span style={{ fontWeight: 'bold' }}>Page {currentPageb} of {totalPagesb}</span>
                  <button onClick={() => setCurrentPageb((prev) => Math.min(prev + 1, totalPagesb))}
                    disabled={currentPageb === totalPagesb}
                    style={{ padding: '6px 12px', marginLeft: '10px', borderRadius: '4px', border: '1px solid #ccc', cursor: 'pointer', }}>
                    Next ➡
                  </button>
                </div>
              </div>
            </div>
          </>
        );

      case 'Top Cuisine':
        return (
          <>
            <div
              style={{
                maxWidth: 980,
                margin: "24px auto",
                padding: 18,
                backgroundColor: "#fff",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <h2 style={{ margin: "0 0 16px 0", color: "#222" }}>Subcategories</h2>

              {groups.length === 0 && (
                <div style={{ color: "#777" }}>No categories found.</div>
              )}

              {groups.map((g) => (
                <div
                  key={g.superId}
                  style={{
                    marginBottom: 20,
                    padding: 12,
                    borderRadius: 10,
                    border: "1px solid #eee",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {/* <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                    <img
                      src={g.superImage}
                      alt={g.superName}
                      style={{ width: 64, height: 64, borderRadius: 8, objectFit: "cover", border: "1px solid #ddd" }}
                    />
                    <div>
                      <div style={{ fontSize: 18, fontWeight: 600, color: "#0b5fa5" }}>{g.superName}</div>
                      <div style={{ fontSize: 13, color: "#666" }}>{g.subcategories.length} subcategory{g.subcategories.length !== 1 ? "ies" : ""}</div>
                    </div>
                  </div> */}

                  <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                    {g.subcategories.map((sub) => (
                      <div
                        key={sub.id}
                        style={{
                          width: 220,
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          padding: 8,
                          borderRadius: 8,
                          border: "1px solid #e6e6e6",
                          backgroundColor: "#fff",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={sub.flag === 1}
                          onChange={() => handleCheckboxChange(sub.id, sub.flag)}
                          style={{ width: 18, height: 18, cursor: "pointer", accentColor: "#0058a3" }}
                        />

                        <img
                          src={sub.image_sub || ""}
                          alt={sub.subCategory}
                          style={{ width: 56, height: 56, borderRadius: 6, objectFit: "cover", border: "1px solid #ddd" }}
                        />

                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: "#222" }}>{sub.subCategory}</div>
                          <div style={{ fontSize: 12, color: "#777" }}>{sub.category_name}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </>

        );
      case 'Notifications':
        return (
          <>
            <div className="manage-container">
              <div className='form-container'>
                <h2>Manage Notifications</h2>

                <div className="form-group1">
                  <input name="title" placeholder="Title" value={form.title} onChange={handleChange} />

                  <input name="url" placeholder="URL (optional)" value={form.url} onChange={handleChange} />
                  <input type="file" onChange={handleFileChange} />
                  <textarea
                    name="description"
                    placeholder="Description"
                    value={form.description}
                    onChange={handleChange}
                    style={{ gridColumn: "1 / 3" }}
                  />
                  <button onClick={submitNotification}>
                    {edited ? 'Update Notification' : 'Send Notification'}
                  </button>
                  {edited && <button onClick={resetForms}>Cancel</button>}
                </div>
              </div>
              {/* 
      <table className="category-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
                   <th>Image</th>
            <th>URL</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {current.map((n, i) => (
            <tr key={n.id}>
              <td>{start + i + 1}</td>
              <td>{n.title}</td>
              
              <td>
                {n.image && <img src={n.image} alt="" width="60" />}
              </td>
                       <td>{n.url}</td>
              <td>
                <button className="edit-btn" onClick={() => editNotification(n)}>Edit</button>
                <button className="delete-btn" onClick={() => deleteNotification(n.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        {[...Array(pages)].map((_, i) => (
          <button
            key={i}
            className={currentPage === i + 1 ? 'active' : ''}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div> */}
            </div>
          </>
        );
      case 'Categories':
        return (
          <>
            <div>
              <div style={{ background: "#fff", padding: "10px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "12px", borderRadius: "4px", fontFamily: "Inter, sans-serif", fontSize: "13px" }}>
                <h2 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#333" }}>ADD NEW CATEGORY</h2>
                <form onSubmit={handleCategorySubmit} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                  {/* <div style={{ display: "flex", flexDirection: "column", flex: '1 1 200px' }}>
                    <label htmlFor="superCategory" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "4px" }}>Select Super Category</label>
                    <select id="superCategory" value={supercategoryId} onChange={(e) => { const selected = supercategoriesget.find(cat => cat.id === parseInt(e.target.value)); setSuperCategoryId(e.target.value); setSuperCategoryName(selected ? selected.name : ''); setSuperCategoryImg(selected ? selected.image : ''); }} required style={{ padding: "6px 8px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "4px", background: "#fdfdfd" }}>
                      <option value="">Select Super Category</option>
                      {supercategoriesget.map(category => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 200px' }}>
                    <label htmlFor="categoryName" style={{ fontSize: '12px', fontWeight: '600', marginBottom: '4px' }}>Enter Category Name</label>
                    <input id="categoryName" type="text" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} required style={{ padding: '6px 8px', fontSize: '13px', border: '1px solid #ccc', borderRadius: '4px' }} />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 150px' }}>
                    <label htmlFor="categoryImage" style={{ fontSize: '12px', fontWeight: '600', marginBottom: '4px' }}>Image</label>
                    <input id="categoryImage" type="file" ref={fileInputRef} onChange={(e) => setCategoryImage(e.target.files[0])} required style={{ padding: '4px 6px', fontSize: '12px', border: '1px solid #ccc', borderRadius: '4px' }} />
                  </div>
                  <button type="button" onClick={(e) => { if (editingCategoryId) { handleCategoryUpdate(editingCategoryId); } else { handleCategorySubmit(e); } }} style={{ backgroundColor: '#007BFF', color: 'white', padding: '8px 12px', border: 'none', borderRadius: '4px', fontSize: '13px', cursor: 'pointer', transition: 'background-color 0.3s' }}>
                    {editingCategoryId ? 'Update Category' : 'Add Category'}
                  </button>
                </form>
              </div>

              <div style={{ background: "#fff", padding: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)", borderRadius: "4px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                  <thead>
                    <tr style={{ background: "#f8f8f8" }}>
                      {/* <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Super Category Name</th> */}
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Category Name</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Image</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categoriesx.map((category) => (
                      <tr key={category.id}>
                        {/* <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", color: "#333" }}>{category.super_cat_name}</td> */}
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", color: "#333" }}>{category.name}</td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", }}><img src={category.image} alt={category.name} style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "3px" }} /></td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}>
                          <button onClick={() => handleDeleteCategort(category.id)} style={{ marginRight: '10px', background: 'none', border: 'none', color: '#f44336', cursor: 'pointer' }}><FaTrash /></button>
                          <button style={{ marginRight: '10px', background: 'none', border: 'none', color: '#4caf50', cursor: 'pointer' }}
                            onClick={() => {
                              setCategoryName(category.name);
                              setSuperCategoryId(category.super_cat_id);
                              setSuperCategoryName(category.super_cat_name);
                              setSuperCategoryImg(category.super_cat_img);
                              setEditingCategoryId(category.id);
                            }}
                          >
                            <FaEdit />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: 'center', marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', flexWrap: 'wrap', }}>
                <button onClick={() => setCurrentPagex((prev) => Math.max(prev - 1, 1))} disabled={currentPagex === 1} style={{ padding: '4px 12px', fontSize: '12px', cursor: currentPagex === 1 ? 'not-allowed' : 'pointer', backgroundColor: currentPagex === 1 ? '#ccc' : '#6a82fb', color: '#fff', border: 'none', borderRadius: '4px', transition: '0.2s', }}>Previous</button>
                <span style={{ fontSize: '12px', color: '#333' }}>Page <strong>{currentPagex}</strong> of <strong>{totalPagesx || 1}</strong> &nbsp;(Showing{' '}<strong>{categories.length === 0 ? 0 : indexOfFirstItemx + 1}–{Math.min(indexOfLastItemx, categories.length)}</strong>{' '}of <strong>{categories.length}</strong> items)</span>
                <button onClick={() => setCurrentPagex((prev) => Math.min(prev + 1, totalPagesx))} disabled={currentPagex === totalPagesx || totalPagesx === 0} style={{ padding: '4px 12px', fontSize: '12px', cursor: currentPagex === totalPagesx || totalPagesx === 0 ? 'not-allowed' : 'pointer', backgroundColor: currentPagex === totalPagesx || totalPagesx === 0 ? '#ccc' : '#6a82fb', color: '#fff', border: 'none', borderRadius: '4px', transition: '0.2s', }}>Next</button>
              </div>
            </div>
          </>
        );
      case 'Variant Master':
        return (
          <>
            <div style={{ padding: '20px', margin: '0 auto', fontSize: '13px', backgroundColor: '#f9fafb', borderRadius: '20px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>📋 Variant Master</h2>
              <form onSubmit={handleSubmitVariant} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', marginBottom: '20px', background: '#f9f9f9', padding: '15px', borderRadius: '8px' }}>
                <div style={{ flex: '1 1 150px' }}>
                  <Select
                    options={predefinedUnits}
                    value={selectedUnit}
                    onChange={(option) => { setSelectedUnit(option); if (option?.value !== 'custom') setCustomLabel(''); }}
                    placeholder="Select Unit"
                    isClearable
                    styles={{ control: (base) => ({ ...base, minHeight: '30px', fontSize: '13px' }), menu: (base) => ({ ...base, fontSize: '13px' }), }}
                  />
                </div>

                {selectedUnit?.value === 'custom' && (
                  <input type="text" placeholder="Enter custom unit" value={customLabel} onChange={(e) => setCustomLabel(e.target.value)} style={{ flex: '1 1 150px', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }} required />
                )}
                <button type="submit" style={{ padding: '6px 12px', background: '#4A5568', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}>
                  {editId !== null ? 'Update' : 'Add'}
                </button>
              </form>
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr', backgroundColor: '#edf2f7', fontWeight: 'bold', fontSize: '13px', padding: '10px 8px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', }}>
                  <div>Unit</div>
                  <div>Type</div>
                  <div>Actions</div>
                </div>
                {units.length === 0 ? (
                  <div style={{ padding: '12px', background: '#f9f9f9', border: '1px solid #e2e8f0', borderTop: 'none', textAlign: 'center', fontSize: '13px', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', }}>No units added yet.</div>
                ) : (
                  units.map((unit, index) => (
                    <div key={unit.id} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr', padding: '10px 8px', backgroundColor: index % 2 === 0 ? '#ffffff' : '#f7fafc', borderBottom: '1px solid #e2e8f0', fontSize: '13px', alignItems: 'center', }}>
                      <div>{unit.label}</div>
                      <div>{unit.value}</div>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button onClick={() => handleEditVariant(unit)} style={{ padding: '4px 6px', fontSize: '12px', background: '#3182ce', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Edit</button>
                        <button onClick={() => handleDeleteVariant(unit.id)} style={{ padding: '4px 6px', fontSize: '12px', background: '#e53e3e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Delete</button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </>
        );

      case 'Banners':
        return (
          <>
            <div style={{ margin: '0 auto', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <h2 style={{ marginBottom: '20px' }}>📢 Upload Banner  </h2>
              {/* <h6>Banner Size Should be width 2000 * height 700</h6> */}
              <form onSubmit={handleBannerSubmit} style={{ marginBottom: '30px' }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setBannerFile(e.target.files[0])}
                  required
                />
                <button
                  type="submit"
                  style={{
                    marginLeft: '15px',
                    backgroundColor: '#007BFF',
                    color: 'white',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Upload Banner
                </button>
              </form>

              <h3>📋 Banner List</h3>
              <Table striped bordered hover responsive>
                <thead style={{ backgroundColor: '#6a82fb', color: 'white' }}>
                  <tr>
                    <th>ID</th>
                    <th>Banner Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {banners.map((banner) => (
                    <tr key={banner.id}>
                      <td>{banner.id}</td>
                      <td>{banner.image_url && (<img src={banner.image_url} alt={banner.name} style={{ width: '50px' }} />)}</td>
                      <td><button onClick={() => handleDeleteBanner(banner.id)} style={{ background: 'none', border: 'none', color: '#f44336', cursor: 'pointer' }}>Delete</button></td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        );
      case 'Users':
        // return (
        //   <>
        //     <div style={{ fontFamily: 'sans-serif', padding: '20px', background: "#f8f9fc" }}>
        //       <h2 style={{ marginBottom: '5px' }}>👤 Manage Users</h2>
        //       <p style={{ marginTop: 0, marginBottom: '20px', color: '#666' }}>
        //         Add, edit, or remove users here.
        //       </p>
        //       <button style={{ backgroundColor: '#4CAF50', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer', marginBottom: '20px', }}>
        //         Add New User
        //       </button>

        //       {/* <table style={{ width: '100%', borderCollapse: 'collapse', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
        //                         <thead>
        //                             <tr style={{ backgroundColor: '#f9f9f9', textAlign: 'left', boxShadow: "0 4px 6px rgba(0,0,0,0.1)", }}>
        //                                 <th style={{ padding: '12px', fontWeight: '600', color: '#555' }}>USER</th>
        //                                 <th style={{ padding: '12px', fontWeight: '600', color: '#555' }}>EMAIL</th>
        //                                 <th style={{ padding: '12px', fontWeight: '600', color: '#555' }}>ROLE</th>
        //                                 <th style={{ padding: '12px', fontWeight: '600', color: '#555' }}>STATUS</th>
        //                             </tr>
        //                         </thead>
        //                         <tbody>
        //                             {[
        //                                 {
        //                                     avatar: 'https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png',
        //                                     name: 'Jordan Stevenson',
        //                                     username: '@amiccoo',
        //                                     email: 'Jacinthe_Blick@hotmail.com',
        //                                     role: { name: 'Admin', color: '#6a0dad', icon: <FaCrown /> },
        //                                     status: { label: 'Pending', color: '#856404', bg: '#fff3cd' },
        //                                 },
        //                                 {
        //                                     avatar: 'https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png',
        //                                     name: 'Richard Payne',
        //                                     username: '@brossiter15',
        //                                     email: 'Jaylon_Bartell3@gmail.com',
        //                                     role: { name: 'Editor', color: '#f39c12', icon: <FaPen /> },
        //                                     status: { label: 'Active', color: '#155724', bg: '#d4edda' },
        //                                 },
        //                                 {
        //                                     avatar: 'https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png',
        //                                     name: 'Jennifer Summers',
        //                                     username: '@jsembnlinf',
        //                                     email: 'Tristin_Johnson@gmail.com',
        //                                     role: { name: 'Author', color: '#e74c3c', icon: <FaLaptop /> },
        //                                     status: { label: 'Active', color: '#155724', bg: '#d4edda' },
        //                                 },
        //                                 {
        //                                     avatar: 'https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png',
        //                                     name: 'Mr. Justin Richardson',
        //                                     username: '@justin45',
        //                                     email: 'Toney21@yahoo.com',
        //                                     role: { name: 'Editor', color: '#f39c12', icon: <FaPen /> },
        //                                     status: { label: 'Pending', color: '#856404', bg: '#fff3cd' },
        //                                 },
        //                                 {
        //                                     avatar: 'https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png',
        //                                     name: 'Nicholas Tanner',
        //                                     username: '@tannernic',
        //                                     email: 'Hunter_Kuhic68@hotmail.com',
        //                                     role: { name: 'Maintainer', color: '#3498db', icon: <FaClock /> },
        //                                     status: { label: 'Active', color: '#155724', bg: '#d4edda' },
        //                                 },

        //                             ].map((user, i) => (
        //                                 <tr key={i} style={{ borderBottom: '1px solid #eee', backgroundColor: '#f9f9f9', boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
        //                                     <td style={{ padding: '12px', display: 'flex', alignItems: 'center' }}>
        //                                         <img src={user.avatar} alt={user.name} style={{ width: '35px', height: '35px', borderRadius: '50%', marginRight: '10px', }} />
        //                                         <div>
        //                                             <div style={{ fontWeight: '600', color: '#333' }}>{user.name}</div>
        //                                             <div style={{ fontSize: '13px', color: '#888' }}>{user.username}</div>
        //                                         </div>
        //                                     </td>
        //                                     <td style={{ padding: '12px', color: '#555' }}>{user.email}</td>
        //                                     <td style={{ padding: '12px', color: user.role.color, fontWeight: 'bold' }}>
        //                                         <span style={{ marginRight: '6px', verticalAlign: 'middle' }}>{user.role.icon}</span>
        //                                         {user.role.name}
        //                                     </td>
        //                                     <td style={{ padding: '12px' }}>
        //                                         <span style={{ backgroundColor: user.status.bg, color: user.status.color, padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', display: 'inline-block', minWidth: '70px', textAlign: 'center', }}>
        //                                             {user.status.label}
        //                                         </span>
        //                                     </td>
        //                                 </tr>
        //                             ))}
        //                         </tbody>
        //                     </table> */}
        //     </div>
        //   </>
        // );
        return (
          <>
            {/* <div>
              <h2>Create User</h2>

              <input placeholder="Name" onChange={e => setFormUsers({ ...formUsers, name: e.target.value })} />
              <input placeholder="Email" onChange={e => setFormUsers({ ...formUsers, email: e.target.value })} />
              <input placeholder="Mobile" onChange={e => setFormUsers({ ...formUsers, mobile: e.target.value })} />
              <input placeholder="Password" onChange={e => setFormUsers({ ...formUsers, password: e.target.value })} />

              <h4>Permissions</h4>
              {menus.map(menu => (
                <label key={menu}>
                  <input
                    type="checkbox"
                    checked={formUsers.permissions.includes(menu)}
                    onChange={() => togglePermission(menu)}
                  />
                  {menu}
                </label>
              ))}

              <button onClick={submitUser}>Create User</button>
            </div> */}

            <div style={{ padding: 20 }}>

              {/* CREATE / EDIT USER */}
              <div style={card}>
                <h2 style={{ color: '#0357a0', marginBottom: 20 }}>
                  {userEditingId ? 'Edit User' : 'Create User'}
                </h2>

                <div style={grid}>
                  <input
                    placeholder="Name"
                    value={formUsers.name}
                    onChange={e => setFormUsers({ ...formUsers, name: e.target.value })}
                    style={input}
                  />
                  <input
                    placeholder="Email"
                    value={formUsers.email}
                    onChange={e => setFormUsers({ ...formUsers, email: e.target.value })}
                    style={input}
                  />
                  <input
                    placeholder="Mobile"
                    value={formUsers.mobile}
                    onChange={e => setFormUsers({ ...formUsers, mobile: e.target.value })}
                    style={input}
                  />
                  <input
                    placeholder="Password"
                    type="password"
                    value={formUsers.password}
                    onChange={e => setFormUsers({ ...formUsers, password: e.target.value })}
                    style={input}
                  />
                </div>

                <div style={{ marginTop: 15 }}>
                  <strong>Permissions</strong>
                  <div style={{ display: 'flex', gap: 10, marginTop: 10, flexWrap: 'wrap' }}>
                    {menus.map(menu => (
                      <label key={menu} style={permission(formUsers.permissions.includes(menu))}>
                        <input
                          type="checkbox"
                          checked={formUsers.permissions.includes(menu)}
                          onChange={() => togglePermission(menu)}
                          style={{ marginRight: 6 }}
                        />
                        {menu}
                      </label>
                    ))}
                  </div>
                </div>

                <button
                  onClick={userEditingId ? updateUser : submitUser}
                  style={primaryBtn}
                >
                  {userEditingId ? 'Update User' : 'Create User'}
                </button>
              </div>

              {/* USERS LIST */}
              <div style={card}>
                <h3 style={{ marginBottom: 15 }}>Users List</h3>

                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f3f3f3' }}>
                      <th style={th}>Name</th>
                      <th style={th}>Email</th>
                      <th style={th}>Mobile</th>
                      <th style={th}>Permissions</th>
                      <th style={th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(u => (
                      <tr key={u.id} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={td}>{u.name}</td>
                        <td style={td}>{u.email}</td>
                        <td style={td}>{u.mobile}</td>
                        <td style={td}>
                          {JSON.parse(u.permissions).map(p => (
                            <span key={p} style={badge}>{p}</span>
                          ))}
                        </td>
                        <td style={td}>
                          <button style={editBtn} onClick={() => editUser(u)}>Edit</button>
                          <button style={deleteBtn} onClick={() => deleteUser(u.id)}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </>
        );
      case 'Reports':
        return (
          // <>
          //   <h2>⚙️ Reports </h2>
          // </>
          <>
            <h2>📊 Reports</h2>

            {/* Tabs */}

            <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
              <button onClick={() => setActiveReport("daily")}>
                Today Sales Report
              </button>

              <button onClick={() => setActiveReport("complete")}>
                Complete Sales
              </button>
            </div>

            {/* ---------------- DAILY SALES REPORT ---------------- */}

            {activeReport === "daily" && (


              <div>
                {dailyOrders.length === 0 && (
                  <div
                    style={{
                      padding: 40,
                      background: "#fff3cd",
                      borderRadius: 10,
                      marginBottom: 20,
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#856404"
                    }}
                  >
                    🚫 No sales today
                  </div>
                )}
                {/* Stats Cards */}

                {/* <div
                  style={{
                    display: "flex",
                    gap: 20,
                    marginBottom: 30,
                  }}
                >
                  {dailyStats.map((stat, i) => (
                    <div
                      key={i}
                      style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 10,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        minWidth: 150,
                      }}
                    >
                      <div style={{ color: "#777" }}>{stat.label}</div>
                      <h3>{stat.value}</h3>
                    </div>
                  ))}
                </div> */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3,1fr)",
                    gap: 20,
                    marginBottom: 30
                  }}
                >
                  {dailyStats.map((stat, i) => (
                    <div
                      key={i}
                      style={{
                        background: "linear-gradient(135deg,#667eea,#764ba2)",
                        color: "white",
                        padding: 25,
                        borderRadius: 12,
                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                      }}
                    >
                      <div style={{ fontSize: 14 }}>{stat.label}</div>
                      <h2 style={{ marginTop: 10 }}>{stat.value}</h2>
                    </div>
                  ))}
                </div>
                {/* Charts */}

                <div style={{ display: "flex", gap: 40 }}>

                  {/* Bar Chart */}

                  <div style={{ width: "50%", height: 300 }}>
                    <ResponsiveContainer>
                      {/* <BarChart data={dailyOrders}>
                        <XAxis dataKey="orderId" />
                        <YAxis />
              
                        <Legend />
                        <Bar dataKey="amount" />
                      </BarChart> */}

                      <BarChart data={chartData}>
                        <XAxis dataKey="orderId" />
                        <YAxis />
                        {/* <Tooltip /> */}
                        <Legend />
                        <Bar dataKey="amount" fill="#6366f1" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>

                  {/* Pie Chart */}

                  <div style={{ width: "50%", height: 300 }}>
                    <ResponsiveContainer>
                      <PieChart>
                        <Pie
                          data={pieData}
                          dataKey="value"
                          nameKey="name"
                          outerRadius={100}
                          label
                        >
                          {pieData.map((entry, index) => (
                            <Cell key={index} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        {/* <Tooltip /> */}
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* Orders Table */}

                <table
                  style={{
                    width: "100%",
                    marginTop: 30,
                    borderCollapse: "collapse",
                    background: "white",
                    borderRadius: 10,
                    overflow: "hidden",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f5f5f5" }}>
                      <th>Order</th>
                      <th>Date</th>
                      <th>Customer</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {dailyOrders.map((order, i) => (
                      <tr key={i}>
                        <td>{order.orderId}</td>
                        <td>{order.date}</td>
                        <td>{order.customer}</td>
                        <td>{order.amount}</td>
                        <td>{order.fulfillmentStatus}</td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ---------------- COMPLETE SALES REPORT ---------------- */}

            {activeReport === "complete" && (
              <div>

                {/* Date Picker */}

                <div
                  style={{
                    display: "flex",
                    gap: 20,
                    marginBottom: 20,
                    background: "#fff",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                  }}
                >
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />

                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                  <button
                    onClick={() => {
                      setFromDate("");
                      setToDate("");
                    }}
                    style={{
                      padding: "8px 16px",
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "600"
                    }}
                  >
                    Reset
                  </button>
                </div>

                {/* Sales Chart */}

                <div
                  style={{
                    width: "100%",
                    height: 350,
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
                  }}
                >
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={lineData}>
                      <XAxis dataKey="name" />
                      <YAxis />
                      <CartesianGrid strokeDasharray="3 3" />
                      <Legend />

                      <Line
                        type="monotone"
                        dataKey="sales"
                        stroke="#6366f1"
                        strokeWidth={3}
                        dot={{ r: 4 }}
                        activeDot={{ r: 7 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>

                {/* Table */}

                <table
                  style={{
                    width: "100%",
                    marginTop: 30,
                    borderCollapse: "collapse",
                    background: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f9fafb", textAlign: "left" }}>
                      <th style={{ padding: "12px" }}>Order</th>
                      <th style={{ padding: "12px" }}>Date</th>
                      <th style={{ padding: "12px" }}>Customer</th>
                      <th style={{ padding: "12px" }}>Amount</th>
                      <th style={{ padding: "12px" }}>Payment Status</th>
                      <th style={{ padding: "12px" }}>Fulfillment Status</th>
                      <th style={{ padding: "12px" }}>Refunded Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredOrderss.map((order, i) => (
                      <tr
                        key={i}
                        style={{
                          borderTop: "1px solid #eee"
                        }}
                      >
                        <td style={{ padding: "12px", fontWeight: "600" }}>
                          {order.orderId}
                        </td>

                        <td style={{ padding: "12px", color: "#666" }}>
                          {order.date}
                        </td>

                        <td style={{ padding: "12px" }}>
                          {order.customer}
                        </td>

                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "#10b981"
                          }}
                        >
                          {order.amount}
                        </td>

                        <td
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "#10b981"
                          }}
                        >
                          {order.paymentStatus}
                        </td>
                        <td style={{ padding: "12px" }}>{order.fulfillmentStatus}</td>

                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              color: order.isRefunded ? "#16a34a" : "#dc2626",
                              backgroundColor: order.isRefunded ? "#dcfce7" : "#fee2e2",
                              padding: "4px 10px",
                              borderRadius: "6px",
                              fontWeight: "500"
                            }}
                          >
                            {order.isRefunded ? "Yes" : "No"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>

        );
      case 'Analytics':
        return (
          <>
            <div style={{ fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif", padding: 20, background: "#f8f9fc", minHeight: "100vh", boxSizing: "border-box", }}>
              <h2 style={{ marginBottom: 20 }}>⚙️ Analytics Panel</h2>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 20, }}>
                {/* Congratulation Card */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                  <div style={{ maxWidth: "60%" }}>
                    <div style={{ fontWeight: "600", fontSize: 16, marginBottom: 6 }}>
                      Congratulations Varma! 🎉
                    </div>
                    <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
                      Best seller of the month
                    </div>
                    <div style={{ fontWeight: "700", fontSize: 24, color: "#7b66f6", marginBottom: 8, }}>
                      42.8k
                    </div>
                    <div style={{ fontSize: 12, color: "#aaa", marginBottom: 12, lineHeight: 1.3, }}>
                      78% of target 🚀
                    </div>
                    <button style={{ backgroundColor: "#7b66f6", border: "none", padding: "8px 14px", borderRadius: 4, color: "#fff", cursor: "pointer", fontWeight: "600", fontSize: 13, }}>
                      View Sales
                    </button>
                  </div>

                </div>

                {/* Transactions Card */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", }}>
                  <div style={{ fontWeight: "600", fontSize: 16, marginBottom: 8 }}>
                    Transactions
                  </div>
                  <div style={{ fontSize: 12, color: "#555", marginBottom: 20 }}>
                    Total <b>48.5% Growth</b> 😎 this month
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12, }}>
                    {[
                      { label: "Sales", value: "245k", bg: "#7b66f6", icon: "⏰" },
                      { label: "Users", value: "12.5k", bg: "#5acb00", icon: "👥" },
                      { label: "Products", value: ProductCount, bg: "#f9a825", icon: "🖥️" },
                      { label: "Revenue", value: "$88k", bg: "#32b7f2", icon: "💰" },
                    ].map(({ label, value, bg, icon }) => (
                      <div key={label} style={{ flex: "1 1 45%", display: "flex", alignItems: "center", gap: 10, }}>
                        <div style={{ backgroundColor: bg, color: "#fff", borderRadius: 6, padding: "6px 10px", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", width: 30, height: 30, }}>
                          {icon}
                        </div>
                        <div>
                          <div style={{ fontWeight: "600", fontSize: 14 }}>{label}</div>
                          <div style={{ fontWeight: "700", fontSize: 16 }}>{value}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Weekly Overview */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                  <div style={{ fontWeight: "600", fontSize: 16, marginBottom: 8 }}>
                    Weekly Overview
                  </div>

                  {/* Placeholder bar chart */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", height: 90, marginBottom: 10, gap: 8, }}>
                    {[8000, 30000, 40000, 70000, 50000, 45000, 60000].map((val, i) => (
                      <div key={i} style={{ width: 18, backgroundColor: i === 3 ? "#7b66f6" : "#ddd", height: `${(val / 80000) * 100}%`, borderRadius: 4, }} />
                    ))}
                  </div>

                  <div style={{ fontSize: 12, color: "#555", fontWeight: "600", marginBottom: 10, }}>
                    45%
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>
                    Your sales performance is 45% 😎 better compared to last month
                  </div>

                  <button style={{ marginTop: 15, backgroundColor: "#7b66f6", color: "#fff", border: "none", padding: "8px 14px", borderRadius: 4, cursor: "pointer", fontWeight: "600", fontSize: 13, alignSelf: "start", }}>
                    Details
                  </button>
                </div>

                {/* Total Earning */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", }}>
                  <div style={{ fontWeight: "600", fontSize: 16, marginBottom: 10 }}>
                    Total Earning
                  </div>
                  <div style={{ fontWeight: "700", fontSize: 24, marginBottom: 6, }}>
                    $24,895{" "}
                    <span style={{ color: "#29b95b", fontSize: 16, fontWeight: "600" }}>
                      ↑ 10%
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: "#888", marginBottom: 12 }}>
                    Compared to $84,325 last year
                  </div>

                  {[
                    {
                      company: "Zipcar",
                      details: "Vuejs, React & HTML",
                      amount: "$24,895.65",
                      color: "#7b66f6",
                    },
                    {
                      company: "Bitbank",
                      details: "Sketch, Figma & XD",
                      amount: "$8,650.20",
                      color: "#fdb82a",
                    },
                    {
                      company: "Aviato",
                      details: "HTML & Angular",
                      amount: "$1,245.80",
                      color: "#ccc",
                    },
                  ].map(({ company, details, amount, color }) => (
                    <div key={company} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, }}>
                      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                        <div style={{ backgroundColor: color, width: 26, height: 26, borderRadius: 4, }} />
                        <div>
                          <div style={{ fontWeight: "600" }}>{company}</div>
                          <div style={{ fontSize: 12, color: "#888" }}>{details}</div>
                        </div>
                      </div>
                      <div style={{ fontWeight: "700" }}>{amount}</div>
                    </div>
                  ))}
                </div>

                {/* Total Profit Graph */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                  <div style={{ fontWeight: "600", fontSize: 16 }}>$86.4k</div>
                  <div style={{ fontSize: 12, color: "#555" }}>Total Profit</div>
                  {/* Simple line graph placeholder */}
                  <div style={{ marginTop: 10, height: 60, width: "100%", borderBottom: "2px solid #7b66f6", position: "relative", }}>
                    {[0, 1, 2, 3, 4].map((point, i) => (
                      <div key={i} style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#7b66f6", position: "absolute", bottom: `${10 + i * 10}px`, left: `${i * 22}%`, }} />
                    ))}
                  </div>
                </div>

                {/* Sessions */}
                <div style={{ background: "#fff", borderRadius: 8, padding: 20, boxShadow: "0 4px 6px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", fontWeight: "600", fontSize: 20, color: "#7b66f6", gap: 12, }}>
                  <div>2,856</div>
                  {/* Mini bar chart */}
                  <div style={{ display: "flex", gap: 6 }}>
                    {[20, 40, 60, 40, 50].map((height, i) => (
                      <div key={i} style={{ width: 6, height, backgroundColor: i === 2 ? "#7b66f6" : "#ddd", borderRadius: 4, }} />
                    ))}
                  </div>
                  <div style={{ fontSize: 12, color: "#888" }}>Sessions</div>
                </div>
              </div>
            </div>
          </>
        );

      case 'Logout':
        return (
          <>
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <h2>🔒 You have been logged out.</h2>
              <button onClick={() => navigate('/adminlogin')} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px', backgroundColor: '#3182ce', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', }}>
                Go to Login
              </button>
            </div>
          </>
        );
      case 'Add Product Form':
        return (
          <>
            <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', padding: '10px', fontFamily: 'Arial, sans-serif', }}>
              <form onSubmit={handleSubmitProduct} className="p-4 bg-white shadow-sm">
                <h4 className="mb-4">Add New Product</h4>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label mb-1 small">Product Name</label>
                    <input type="text" className="form-control form-control-sm" name='name' id='name' value={productsData.name} onChange={handleChangeProducts} placeholder="Enter product name" disabled={editingProductId !== null} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1 small">Super Primary Category</label>
                    <select className="form-control form-control-sm" name="super_category" value={productsData.super_category} onChange={handleChangeProducts} required>
                      <option value="">Select Super Category</option>
                      {superCategories.map((superCat, index) => (
                        <option key={index} value={superCat.name}>{superCat.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1 small">Primary Category</label>
                    <select className="form-control form-control-sm" name="category" value={productsData.category} onChange={handleChangeProducts} required disabled={!productsData.super_category}>
                      <option value="">Select Primary Category</option>
                      {filteredPrimaryCategories.map((category, index) => (
                        <option key={index} value={category}>{category}</option>
                      ))}
                    </select>
                  </div>

                  {/* Sub-category */}
                  <div className="col-md-3">
                    <label className="form-label mb-1 small">Sub-category</label>
                    <select className="form-control form-control-sm" name="sub_category" value={productsData.sub_category} onChange={handleChangeProducts} required disabled={!productsData.category}>
                      <option value="">Select Sub-category</option>
                      {filteredSubcategoriesp.map(sub => (
                        <option key={sub.id} value={sub.subCategory}>{sub.subCategory}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <hr className="my-4" />
                <>
                  <div className="mb-3">
                    <label className="form-label d-block">Product Type</label>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="checkbox" value="B2B" checked={productData12.productType.includes('B2B')} onChange={handleProductTypeChange} />
                      <label className="form-check-label">B2B</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="checkbox" value="B2C" checked={productData12.productType.includes('B2C')} onChange={handleProductTypeChange} />
                      <label className="form-check-label">B2C</label>
                    </div>
                  </div>
                  <div className="mb-4">
                    {productData12.productType.includes('B2B') && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>B2B Variants</strong>
                          <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleAddB2BVariant}>+ Add B2B Variant</button>
                        </div>
                        {b2bVariants.map((variant, index) => (
                          <div key={`b2b-${index}`} className="border rounded p-3 mb-3 bg-light">
                            <div className="row g-3">
                              <div className="col-md-3">
                                <label className="form-label">UOM</label>
                                <select className="form-control" value={variant.unit} onChange={(e) => handleVariantChange('B2B', index, 'unit', e.target.value)} disabled={editingProductId !== null}>
                                  <option value="">Select Unit</option>
                                  {unitsSelect.map((unit) => (<option key={unit.id} value={unit.value}>{unit.label}</option>))}
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">UOM Unit Value</label>
                                <input type="number" className="form-control" value={variant.unitvalue} placeholder="Unit Value" onChange={(e) => handleVariantChange('B2B', index, 'unitvalue', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Price</label>
                                <input type="number" className="form-control" value={variant.Price} placeholder="Price" onChange={(e) => handleVariantChange('B2B', index, 'Price', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Quantity</label>
                                <input type="number" className="form-control" value={variant.stock} placeholder="stock" onChange={(e) => handleVariantChange('B2B', index, 'stock', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Discount (%)</label>
                                <input type="number" className="form-control" value={variant.discount} onChange={(e) => handleVariantChange('B2B', index, 'discount', e.target.value)} />
                              </div>
                              {parseFloat(variant.discount) > 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Offer Until</label>
                                  <input type="date" className="form-control" value={variant.offerUntil} min={new Date().toISOString().split('T')[0]} onChange={(e) => handleVariantChange('B2B', index, 'offerUntil', e.target.value)} />
                                </div>
                              )}
                              <div className="col-md-3">
                                <label className="form-label">Tax (%)</label>
                                <input type="number" className="form-control" value={variant.tax} onChange={(e) => handleVariantChange('B2B', index, 'tax', e.target.value)} />
                              </div>
                              {/* {editingProductId !== null && (
                                <div className="col-md-3">
                                  <label className="form-label">Stock</label>
                                  <input type="number" className="form-control" value={variant.stock} onChange={(e) => handleVariantChange('B2B', index, 'stock', e.target.value)} disabled={editingProductId !== null}/>
                                </div>
                              )} */}
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                    {productData12.productType.includes('B2C') && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>B2C Variants</strong>
                          <button type="button" className="btn btn-sm btn-outline-success" onClick={handleAddB2CVariant}>+ Add B2C Variant</button>
                        </div>

                        {b2cVariants.map((variant, index) => (
                          <div key={`b2c-${index}`} className="border rounded p-3 mb-3 bg-light">
                            <div className="row g-3">
                              <div className="col-md-3">
                                <label className="form-label">UOM</label>
                                <select className="form-control" value={variant.unit} onChange={(e) => handleVariantChange('B2C', index, 'unit', e.target.value)} disabled={editingProductId !== null}>
                                  <option value="">Select Unit</option>
                                  {unitsSelect.map((unit) => (<option key={unit.id} value={unit.value}>{unit.label}</option>))}
                                </select>
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">UOM Unit Value</label>
                                <input type="number" className="form-control" value={variant.unitvalue} placeholder="Unit Value" onChange={(e) => handleVariantChange('B2C', index, 'unitvalue', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Price</label>
                                <input type="number" className="form-control" value={variant.Price} placeholder="Price" onChange={(e) => handleVariantChange('B2C', index, 'Price', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Quantity</label>
                                <input type="number" className="form-control" value={variant.stock} placeholder="stock" onChange={(e) => handleVariantChange('B2C', index, 'stock', e.target.value)} />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Discount (%)</label>
                                <input type="number" className="form-control" value={variant.discount} onChange={(e) => handleVariantChange('B2C', index, 'discount', e.target.value)} />
                              </div>
                              {parseFloat(variant.discount) > 0 && (
                                <div className="col-md-3">
                                  <label className="form-label">Offer Until</label>
                                  <input type="date" className="form-control" value={variant.offerUntil} min={new Date().toISOString().split('T')[0]} onChange={(e) => handleVariantChange('B2C', index, 'offerUntil', e.target.value)} />
                                </div>
                              )}
                              <div className="col-md-3">
                                <label className="form-label">Tax (%)</label>
                                <input type="number" className="form-control" value={variant.tax} onChange={(e) => handleVariantChange('B2C', index, 'tax', e.target.value)} />
                              </div>
                              {/* {editingProductId !== null && (
                                <div className="col-md-3">
                                  <label className="form-label">Stock</label>
                                  <input type="number" className="form-control" value={variant.stock} onChange={(e) => handleVariantChange('B2C', index, 'stock', e.target.value)} disabled={editingProductId !== null}/>
                                </div>
                              )} */}
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </>
                <hr className="my-4" />
                <div className="row g-3 mb-3">
                  <div className="col-md-3">
                    <label className="form-label">Brand</label>
                    <select className="form-control" name="brand" id="brand" value={productsData.brand} onChange={handleChangeProducts} disabled={editingProductId !== null}>
                      <option>Select Brand</option>
                      {brands.map((brand) => (
                        <option key={brand.id} value={brand.name}>
                          {brand.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-9">
                    <label className="form-label">Product Images <small className="text-muted">(Only .jpg, .jpeg, .png, .webp)</small></label>
                    <input type="file" name="image_1" onChange={handleImageChange} className="form-control" />
                    <small className="text-muted">Upload thumbnail, gallery, zoomed view etc.</small>
                  </div>
                  <div className="row g-3 mb-3">
                    <div className="col-md-4">
                      <label className="form-label">Top Image <small className="text-muted">(Optional)</small></label>
                      <input type="file" name="image_2" onChange={handleImageChange} className="form-control" accept="image/*" />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Front Images <small className="text-muted">(Optional)</small></label>
                      <input type="file" name="image_3" onChange={handleImageChange} className="form-control" accept="image/*" />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Zoomed View Image <small className="text-muted">(Optional)</small></label>
                      <input type="file" name="image_4" onChange={handleImageChange} className="form-control" accept="image/*" />
                    </div>
                  </div>
                </div>
                {/* Descriptions */}
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Short Description</label>
                    <textarea className="form-control" rows="4" name="short_description" placeholder="Brief description" value={productsData.short_description} onChange={handleChangeProducts} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Long Description <small className="text-muted">(Optional)</small></label>
                    <textarea className="form-control" rows="4" name="long_description" placeholder="Detailed product description" value={productsData.long_description} onChange={handleChangeProducts} />
                  </div>
                  <hr className="my-4" />

                  <div className="row g-3">

                    <div className="col-md-6">
                      <label className="form-label">Recipe</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="recipe"
                        value={productsData.recipe}
                        onChange={handleChangeProducts}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Ingredients</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="ingredients"
                        value={productsData.ingredients}
                        onChange={handleChangeProducts}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Features</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="features"
                        value={productsData.features}
                        onChange={handleChangeProducts}
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Nutritional Facts</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        name="nutritional_facts"
                        value={productsData.nutritional_facts}
                        onChange={handleChangeProducts}
                      />
                    </div>

                  </div>
                </div>
                <hr className="my-4" />
                <div className="d-flex justify-content-end">
                  <button type="submit" className="btn btn-primary">Save Product</button>
                </div>
              </form>

            </div>
          </>
        );
      case 'Products List':
        return (
          <>
            <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', padding: '10px' }}>
              <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
                {selectedProduct ? 'Product Details' : 'Products Data'}
              </h2>
              {!selectedProduct && (
                <input type="text" className="form-control" placeholder="Search by name, brand, category..." style={{ maxWidth: '300px' }} value={searchTermp} onChange={(e) => setSearchTermp(e.target.value)} />)}
              {selectedProduct ? (
                <div style={{ backgroundColor: '#fff', padding: 20, boxShadow: '0 0 8px rgba(0,0,0,0.1)' }}>
                  <button onClick={handleBack} style={{ marginBottom: 20, padding: '6px 12px', backgroundColor: '#0a0a0aff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}><FaArrowLeft /></button>
                  <div style={{ display: 'flex', gap: 40, marginBottom: 30 }}>
                    <div style={{ flex: '1', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: 220 }}>
                      {selectedProduct.image_1 && <img src={selectedProduct.image_1} alt="Image 1" style={{ width: '100%', height: '100px', objectFit: 'cover', border: '1px solid #ccc' }} />}
                      {selectedProduct.image_2 && <img src={selectedProduct.image_2} alt="Image 2" style={{ width: '100%', height: '100px', objectFit: 'cover', border: '1px solid #ccc' }} />}
                      {selectedProduct.image_3 && <img src={selectedProduct.image_3} alt="Image 3" style={{ width: '100%', height: '100px', objectFit: 'cover', border: '1px solid #ccc' }} />}
                      {selectedProduct.image_4 && <img src={selectedProduct.image_4} alt="Image 4" style={{ width: '100%', height: '100px', objectFit: 'cover', border: '1px solid #ccc' }} />}
                    </div>
                    <div style={{ flex: '2' }}>
                      <h3>{selectedProduct.name}</h3>
                      <p className='mb-0'><strong>Category:</strong> {selectedProduct.category}</p>
                      <p className='mb-0'><strong>Sub-category:</strong> {selectedProduct.sub_category}</p>
                      <p className='mb-0'><strong>Brand:</strong> {selectedProduct.brand}</p>
                      <p className='mb-0'><strong>Product Type:</strong> {selectedProduct.product_type?.join(', ')}</p>
                      <p className='mb-0'><strong>Short Description:</strong> {selectedProduct.short_description || ''}</p>
                      <p className='mb-0'><strong>Lonh Description:</strong> {selectedProduct.long_description || ''}</p>
                      <p className='mb-0'><strong>Recipe:</strong> {selectedProduct.recipe}</p>
                      <p className='mb-0'><strong>Ingredients:</strong> {selectedProduct.ingredients}</p>
                      <p className='mb-0'><strong>Features:</strong> {selectedProduct.features}</p>
                      <p className='mb-0'><strong>Nutritional Facts:</strong> {selectedProduct.nutritional_facts}</p>
                    </div>
                  </div>
                  <h4>Variants:</h4>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f5f5f5' }}>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Type</th>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Unit</th>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Value</th>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Price</th>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Quantity</th>
                        <th style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>Stock</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProduct.variants?.map((v) => (
                        <tr key={v.id}>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>{v.type}</td>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>{v.unit}</td>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>{v.unit_value}</td>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>₹{v.price}</td>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>{v.quantity}</td>
                          <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'left' }}>{v.stock}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <table className='mt-2' style={{ width: '100%', borderCollapse: 'collapse', boxShadow: '0 0 8px rgba(0,0,0,0.1)' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>ID</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Image</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Name</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Category</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Sub-category</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Brand</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Product Type</th>
                      <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productsGet
                      .filter((product) =>
                        product.name?.toLowerCase().includes(searchTermp.toLowerCase()) ||
                        product.category?.toLowerCase().includes(searchTermp.toLowerCase()) ||
                        product.sub_category?.toLowerCase().includes(searchTermp.toLowerCase()) ||
                        product.brand?.toLowerCase().includes(searchTermp.toLowerCase())
                      )
                      .map((product) => (
                        <tr key={product.id}>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.id}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.image_1 && <img src={product.image_1} alt="Product" width={40} />}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.name}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.category}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.sub_category}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.brand}</td>
                          <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{product.product_type?.join(', ')}</td>
                          <td style={{ ...{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }, whiteSpace: 'nowrap' }}>
                            <button onClick={() => handleView(product)} title="View" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: 6, }}><FaEye size={18} color="#28a745" /></button>
                            <button onClick={() => handleEditProduct(product.id)} title="Edit" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: 6, }}><FaEdit size={18} color="#0051ff" /></button>
                            <button onClick={() => handleDeleteProduct(product.id)} title="Delete" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: 6, }}><FaTrash size={18} color="#ff0000" /></button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </>
        );
      case 'Notification':
        return (
          <>
            <div style={{ backgroundColor: '#fff', padding: '20px', width: '100%', maxWidth: '500px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', fontFamily: 'Arial, sans-serif' }}>
              <h2 style={{ marginBottom: '16px' }}>Notifications</h2>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {notifications.map((note, index) => (
                  <li key={index} style={{ padding: '12px 16px', marginBottom: '10px', borderLeft: `5px solid ${note.color}`, backgroundColor: '#f9f9f9', borderRadius: '4px', }}>
                    <p style={{ margin: 0, fontSize: '16px' }}>{note.message}</p>
                    <span style={{ fontSize: '12px', color: '#888' }}>{note.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </>
        );
      case 'Order Fulfillment':
        return (
          <>
            {/* Top Stats Bar */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                fontFamily: "Segoe UI, sans-serif",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "20px",
                borderRadius: "8px",
                marginBottom: "20px",
              }}
              className="print-hide"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontWeight: 600,
                  color: "#333",
                  minWidth: "100px",
                }}
              >
                📅 Today
              </div>
              {[
                { label: "Orders", value: 10 },
                { label: "Items ordered", value: 35 },
                { label: "Returns", value: "₹0" },
                { label: "Orders fulfilled", value: 6 },
                { label: "Orders delivered", value: 4 },
                { label: "To fulfill", value: 4 },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    flex: "1 1 120px",
                    minWidth: "120px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      marginBottom: "4px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.label}
                  </div>
                  <div style={{ fontSize: "16px", fontWeight: 600, color: "#000" }}>
                    {item.value}
                  </div>
                  <div
                    style={{
                      height: "2px",
                      marginTop: "6px",
                      backgroundColor: "#00bcd4",
                      borderRadius: "4px",
                      width: "100%",
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Orders List or Details */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                fontFamily: "Segoe UI, sans-serif",
                borderRadius: "8px",
                overflowX: "auto",
              }}
            >
              {!selectedOrder && (
                <>
                  {/* Orders Table */}
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "14px",
                        minWidth: "800px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f9f9f9", textAlign: "left" }}>
                          {[
                            "",
                            "Order",
                            "Date",
                            "Customer",
                            "Channel",
                            "Amount",
                            "Payment",
                            "Fulfillment",
                            "Items",
                            "Tracking",
                            "Delivery",
                          ].map((header, idx) => (
                            <th
                              key={idx}
                              style={{
                                padding: "10px 12px",
                                fontWeight: "600",
                                borderBottom: "2px solid #ddd",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {header || <input type="checkbox" />}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedOrders.filter((order => order.is_paid === 1)).map((order, index) => (
                          <tr
                            key={index}
                            style={{
                              borderBottom: "1px solid #eee",
                              backgroundColor: order.isRefunded === 1 ? "#fff8e1" : "white", // light yellow for refunded
                            }}
                          >

                            <td style={{ padding: "10px 12px" }}>
                              <input type="checkbox" />
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                fontWeight: 500,
                                color: "#1976d2",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const orderId = order.orderId.replace("#", ""); // extract 15 from "#15"
                                setSelectedOrder(orderId); // just pass the ID
                              }}

                            >
                              {order.orderId}
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.date}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.customer}
                              </span>
                            </td>

                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.channel}
                              </span>
                            </td>


                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.amount}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px", fontWeight: 600, color: order.isRefunded === 1 ? "#d32f2f" : "inherit" }}>
                              {order.isRefunded === 1 ? "Refunded" : order.paymentStatus}
                            </td>

                            <td style={{ padding: "10px 12px" }}>
                              <span
                                style={{
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  backgroundColor:
                                    order.fulfillmentStatus === "Fulfilled"
                                      ? "#e6f4ea" // Greenish for Fulfilled
                                      : order.fulfillmentStatus === "Cancelled"
                                        ? "#f8d7da" // Light red for Cancelled
                                        : "#fff3cd", // Yellowish for Unfulfilled
                                  color:
                                    order.fulfillmentStatus === "Fulfilled"
                                      ? "#2e7d32" // Dark green for Fulfilled
                                      : order.fulfillmentStatus === "Cancelled"
                                        ? "#721c24" // Dark red for Cancelled
                                        : "#8a6d3b", // Dark yellowish-brown for Unfulfilled
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                {order.fulfillmentStatus}
                              </span>
                            </td>

                            <td style={{ padding: "10px 12px" }}>{order.items}</td>
                            <td style={{ padding: "10px 12px" }}>{order.tracking}</td>
                            <td style={{ padding: "10px 12px" }}>{order.delivery}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "8px" }}>
                      <button
                        disabled={orderFillPagination.currentPage === 1}
                        onClick={() =>
                          setOrderFillPagination((prev) => ({
                            ...prev,
                            currentPage: prev.currentPage - 1,
                          }))
                        }
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Prev
                      </button>

                      {Array.from({ length: totalPagess }, (_, i) => (
                        <button
                          key={i + 1}
                          onClick={() =>
                            setOrderFillPagination((prev) => ({
                              ...prev,
                              currentPage: i + 1,
                            }))
                          }
                          style={{
                            padding: "6px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            backgroundColor:
                              orderFillPagination.currentPage === i + 1 ? "#0357a0" : "#fff",
                            color: orderFillPagination.currentPage === i + 1 ? "#fff" : "#000",
                            fontWeight: orderFillPagination.currentPage === i + 1 ? "bold" : "normal",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        disabled={orderFillPagination.currentPage === totalPagess}
                        onClick={() =>
                          setOrderFillPagination((prev) => ({
                            ...prev,
                            currentPage: prev.currentPage + 1,
                          }))
                        }
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Next
                      </button>
                    </div>

                  </div>

                </>
              )}

              {/* Order Details View */}
              {orderDetails && (
                <div style={styles.container} className="print-container">
                  <header style={styles.header}>
                    <div className="print-only" style={{ display: "none" }}>
                      <img src="https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png" alt="GloCart" style={{ height: 60 }} />
                    </div>

                    <div>
                      <h1>
                        🛒{orderDetails.orderId}{" "}
                        <span style={{ fontWeight: "normal", fontSize: 16 }}>
                          {orderDetails.paid ? (
                            <span style={styles.paidBadge}>Paid</span>
                          ) : null}
                          {orderDetails.unfulfilled ? (
                            <span style={styles.unfulfilledBadge}>Unfulfilled</span>
                          ) : <span style={styles.unfulfilledBadge}>Fulfilled</span>}
                        </span>
                      </h1>
                      <p style={{ fontSize: 12, color: "#666" }}>
                        {orderDetails.date} from {orderDetails.source}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <button
                        style={styles.button}
                        onClick={() => {
                          console.log("Clicked Refund button for order:", selectedOrder); // log order id
                          setSelectedOrder(selectedOrder); // <-- set the ID of the order you're refunding
                          setShowRefund(true);
                        }}
                      >
                        Refund
                      </button>

                      {/* <button style={styles.button}>Edit</button> */}
                      <div style={{ position: "relative" }}>
                        <button
                          style={styles.button}
                          onClick={() => {
                            setShowPrintDropdown((prev) => !prev);
                            setShowMoreDropdown(false); // close the other one
                          }}
                        >
                          Print ▼
                        </button>
                        {showPrintDropdown && (
                          <div style={styles.dropdownMenu}>
                            <div
                              style={styles.dropdownItem}
                              className="dropdownItem"
                              onClick={handlePrint}
                            >
                              🖨️ Print Order Page
                            </div>

                            <div style={styles.dropdownItem} className='dropdownItem' onClick={handlePackageSlipPrint}>
                              📦 Package Slip
                            </div>
                          </div>
                        )}

                      </div>

                      <div style={{ position: "relative" }}>
                        <button
                          style={styles.button}
                          onClick={() => {
                            setShowMoreDropdown((prev) => !prev);
                            setShowPrintDropdown(false); // close the other one
                          }}
                        >
                          More actions ▼
                        </button>
                        {showMoreDropdown && (
                          <div style={styles.dropdownMenu}>

                            <div
                              style={styles.dropdownItem}
                              onClick={() => handleCancelOrder(selectedOrder)}
                              className='dropdownItem'
                            >
                              ❌ Cancel Order
                            </div>

                            {orders
                              .filter((order) => order.orderId === `#${selectedOrder}`)
                              .map((order) => {
                                const orderId = order.orderId.replace("#", "");

                                // Check if button should be enabled
                                const isEligible =
                                  order.fulfillmentStatus === "Fulfilled" && order.isRefunded === 0;

                                // Determine current state
                                const isArchived = order.status?.toLowerCase() === "archived";

                                const handleArchiveToggle = async () => {
                                  if (!isEligible) return;

                                  const newStatus = isArchived ? "success" : "archived";

                                  try {
                                    const response = await fetch(`https://api.glocart.in/payment/api/api/orders/${orderId}/archive-status`, {
                                      method: "PUT",
                                      headers: {
                                        "Content-Type": "application/json",
                                      },
                                      body: JSON.stringify({ status: newStatus }),
                                    });

                                    if (!response.ok) {
                                      throw new Error("Failed to update order status.");
                                    }

                                    alert(`Order ${isArchived ? "unarchived" : "archived"} successfully!`);

                                    // Optionally: refresh data or update UI state
                                    // e.g., refetchOrders();

                                  } catch (error) {
                                    console.error(error);
                                    alert("Something went wrong.");
                                  }
                                };

                                return (
                                  <div
                                    key={order.orderId}
                                    style={{
                                      ...styles.dropdownItem,
                                      opacity: isEligible ? 1 : 0.5,
                                      cursor: isEligible ? "pointer" : "not-allowed",
                                    }}
                                    onClick={handleArchiveToggle}
                                    className="dropdownItem"
                                  >
                                    🗄️ {isArchived ? "Unarchive" : "Archive"}
                                  </div>
                                );
                              })}



                          </div>
                        )}

                      </div>
                      <button
                        onClick={() => {
                          setSelectedOrder(null);
                          setOrderDetailss(null); // <-- this hides the details
                        }}

                        style={{
                          position: "absolute",  // 👈 this makes it float in the parent
                          top: "150px",
                          right: "30px",
                          backgroundColor: "transparent",
                          border: "none",
                          fontSize: "24px",
                          cursor: "pointer",
                          color: "#0357a0",
                          zIndex: 10
                        }}
                        title="Close"
                      >
                        ✕
                      </button>
                    </div>
                  </header>

                  {/* Items section */}
                  <section style={styles.section}>
                    <div style={styles.unfulfilledLabel}>  {orderDetails.unfulfilled ? (
                      <span style={styles.unfulfilledBadge}>Unfulfilled</span>
                    ) : (
                      <span style={styles.fulfilledBadge}>Fulfilled</span>
                    )}</div>
                    {orderDetails?.items?.map((item) => (
                      <div key={item.id} style={styles.itemCard}>
                        <div style={styles.tagRow}>
                          {item.tags?.map((tag) => (
                            <span key={tag} style={styles.tag}>
                              {tag}
                            </span>
                          ))}
                        </div>
                        <div style={styles.itemContent}>
                          <img
                            src={item.image}
                            alt={item.name}
                            style={{ width: 60, height: 60, marginRight: 10 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold" }}>{item.name}</div>
                            <small>{item.id}</small>
                          </div>
                          <div style={{ marginRight: 10 }}>
                            ₹{item.price.toFixed(2)} × {item.quantity}
                          </div>
                          <div>₹{(item.price * item.quantity).toFixed(2)}</div>
                          <button
                            style={{
                              ...styles.fulfillButton,
                              backgroundColor: orderDetails.unfulfilled ? '#0357a0' : '#ccc',
                              cursor: orderDetails.unfulfilled ? 'pointer' : 'not-allowed',
                            }}
                            onClick={handleFulfillItem}
                            disabled={!orderDetails.unfulfilled}
                          >
                            Fulfill item
                          </button>

                        </div>
                      </div>
                    ))}
                  </section>


                  {/* Summary Section */}
                  <section
                    style={{
                      ...styles.section,
                      maxWidth: '600px',       // limit max width of section card
                      padding: '16px',
                      overflowX: 'auto',       // enable horizontal scroll if needed
                      boxSizing: 'border-box',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      backgroundColor: '#fff'
                    }}
                  >
                    <h3>Payment Summary</h3>
                    <table
                      style={{
                        ...styles.summaryTable,
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed'    // fix column widths to avoid overflow
                      }}
                    >
                      <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '20%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Subtotal</td>
                          <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                            {ordersData.items.length} item{ordersData.items.length > 1 ? 's' : ''}
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.subtotal}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Shipping</td>
                          <td style={{ padding: '8px 12px', whiteSpace: 'normal' }}>
                            Standard (0.25 kg: Items 0.25 kg, Package 0.0 kg)
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.shipping}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Taxes</td>
                          <td style={{ padding: '8px 12px' }}>IGST 18% (Included)</td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.tax}</td>
                        </tr>
                        <tr style={{ fontWeight: 'bold', borderTop: '2px solid #000' }}>
                          <td style={{ padding: '8px 12px' }}>Total</td>
                          <td></td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.total}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px' }}>Paid</td>
                          <td></td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.paidAmount}</td>
                        </tr>
                      </tbody>
                    </table>
                  </section>


                  {/* Timeline / Comments */}
                  <section style={styles.section} className="no-print">
                    <div style={{ fontFamily: "Arial, sans-serif", maxWidth: 600, margin: "auto" }}>
                      {/* Timeline Header */}
                      <h2>Timeline</h2>

                      {/* Comment input */}
                      <div
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 8,
                          padding: 10,
                          display: "flex",
                          border: "1px solid #ddd",
                          marginBottom: 20,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f06292",
                            color: "white",
                            width: 40,
                            height: 40,
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: 18,
                            marginRight: 10,
                            userSelect: "none",
                          }}
                        >
                          MT
                        </div>
                        <input
                          type="text"
                          placeholder="Leave a comment..."
                          onChange={(e) => setComment(e.target.value)}
                          style={{ flexGrow: 1, padding: 10, borderRadius: 8, border: "1px solid #ddd" }}
                        />
                        <button
                          style={{
                            ...styles.postButton,
                            backgroundColor: "#007bff",
                            cursor: "pointer",
                          }}
                          onClick={async () => {
                            if (!comment.trim() || !selectedOrder) {
                              console.warn("Missing comment or selectedOrder.id");
                              return;
                            }

                            console.log("📤 Posting comment to timeline...");
                            console.log("Order ID:", selectedOrder.id);
                            console.log("Comment:", comment);

                            try {
                              const res = await fetch('https://api.glocart.in/payment/api/api/timeline', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                  orderId: selectedOrder,
                                  comment,
                                }),
                              });

                              console.log("🧾 POST response status:", res.status);

                              if (res.ok) {
                                console.log("✅ Comment posted successfully.");
                                setComment("");

                                console.log("📥 Fetching updated timeline...");

                                const timelineRes = await fetch(`https://api.glocart.in/payment/api/api/timeline/${selectedOrder}`);
                                const timeline = await timelineRes.json();

                                console.log("📦 Timeline data received:", timeline);
                                setTimelineData(timeline);
                              } else {
                                const errText = await res.text();
                                console.error("❌ Failed to post comment:", errText);
                              }
                            } catch (err) {
                              console.error("💥 Error during timeline post:", err);
                            }
                          }}
                        >
                          Post
                        </button>


                      </div>

                      <div style={{ fontSize: 12, color: "#888", marginBottom: 20 }}>
                        Only you and other staff can see comments
                      </div>

                      {/* Timeline Items */}
                      <div style={{ position: "relative", paddingLeft: 30 }}>
                        {/* Vertical line */}
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 15,
                            width: 2,
                            height: "100%",
                            backgroundColor: "#ddd",
                          }}
                        />

                        {timelineData.map(({ date, events }, sectionIndex) => (
                          <div key={sectionIndex} style={{ marginBottom: 30 }}>
                            {/* Date label */}
                            <div
                              style={{
                                fontWeight: "bold",
                                color: "#666",
                                fontSize: 14,
                                marginBottom: 10,
                              }}
                            >
                              {date}
                            </div>
                            {events.map((event, eventIndex) => {
                              const isExpanded = expandedIndex === `${sectionIndex}-${eventIndex}`;

                              return (
                                <div
                                  key={eventIndex}
                                  style={{
                                    position: "relative",
                                    marginBottom: 20,
                                    paddingLeft: 20,
                                    borderLeft: "2px solid transparent",
                                  }}
                                >
                                  {/* Dot */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: -15,
                                      top: 5,
                                      width: 10,
                                      height: 10,
                                      backgroundColor: "#555",
                                      borderRadius: "50%",
                                      border: "2px solid white",
                                    }}
                                  />

                                  {/* Time */}
                                  <div
                                    style={{
                                      fontSize: 10,
                                      color: "#999",
                                      position: "absolute",
                                      right: 0,
                                      top: 0,
                                    }}
                                  >
                                    {event.time}
                                  </div>

                                  {/* Event text */}
                                  <div style={{ fontSize: 14, marginBottom: 8 }}>
                                    {event.text}
                                    {event.expandable && !isExpanded && " ..."}
                                  </div>

                                  {/* View email button */}
                                  {event.buttonText && (
                                    <button
                                      style={{
                                        fontSize: 12,
                                        padding: "5px 10px",
                                        borderRadius: 5,
                                        border: "1px solid #ccc",
                                        background: "white",
                                        cursor: "pointer",
                                        marginBottom: 5,
                                      }}
                                      onClick={() => alert("View email clicked")}
                                    >
                                      {event.buttonText}
                                    </button>
                                  )}

                                  {/* Expand/Collapse toggle */}
                                  {event.expandable && (
                                    <span
                                      onClick={() => toggleExpand(`${sectionIndex}-${eventIndex}`)}
                                      style={{
                                        marginLeft: 8,
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        userSelect: "none",
                                        color: "#555",
                                        fontSize: 18,
                                        verticalAlign: "middle",
                                      }}
                                      title={isExpanded ? "Collapse" : "Expand"}
                                    >
                                      {isExpanded ? "−" : "+"}
                                    </span>
                                  )}

                                  {/* Expanded content example (placeholder) */}
                                  {isExpanded && (
                                    <div
                                      style={{
                                        padding: 10,
                                        backgroundColor: "#f1f1f1",
                                        borderRadius: 5,
                                        marginTop: 5,
                                        fontSize: 13,
                                        color: "#333",
                                      }}
                                    >
                                      Detailed information about this fulfillment event...
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </div>
                  </section>

                  {/* Right side info */}
                  <aside style={styles.sidebar}>
                    {/* <section style={styles.sidebarSection}>
          <h4>Notes</h4>
          <p>No notes from customer</p>
        </section> */}
                    <section style={styles.sidebarSection}>
                      <h4>Customer</h4>
                      {orderDetails?.customer ? (
                        <p>
                          <strong>{orderDetails.customer.name}</strong>
                          <br />
                          {orderDetails.customer.ordersCount} order
                          {orderDetails.customer.ordersCount > 1 ? "s" : ""}
                          <br />
                          <br />
                          Contact information
                          <br />
                          <a href={`mailto:${orderDetails.customer.email}`}>
                            {orderDetails.customer.email}
                          </a>
                          <br />
                          {orderDetails.customer.phone}
                        </p>
                      ) : (
                        <p>Customer info not available</p>
                      )}

                      <br />
                      <p>
                        <strong>Shipping address</strong>
                        <br />
                        {orderDetails?.customer?.shippingAddress
                          ?.split("\n")
                          .map((line, i) => (
                            <span key={i}>
                              {line}
                              <br />
                            </span>
                          ))}
                        {mapUrl ? (
                          <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                            View map
                          </a>
                        ) : (
                          <span>No location info available</span>
                        )}
                      </p>
                      <br />
                      <p>
                        <strong>Billing address</strong>
                        <br />
                        {orderDetails?.customer?.billingSameAsShipping
                          ? "Same as shipping address"
                          : ""}
                      </p>
                    </section>


                    <section style={styles.sidebarSection} className="print-hide">
                      <h4>Conversion summary</h4>
                      <ul style={{ paddingLeft: 18 }}>
                        {orderDetails?.conversionSummary.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>

                      <a href="#" style={{ color: "#007bff" }}>
                        View conversion details
                      </a>
                    </section>
                  </aside>
                </div>
              )}
            </div>
            {showFulfillModal && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3>Tracking Information</h3>
                  <label>
                    Tracking Number:
                    <input
                      type="text"
                      value={trackingNumber}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                      style={styles.input}
                    />
                  </label>

                  <label>
                    Shipping Carrier:
                    <input
                      type="text"
                      list="courier-options"
                      value={carrier}
                      onChange={(e) => setCarrier(e.target.value)}
                      style={styles.input}
                    />
                    <datalist id="courier-options">
                      {courierCompanies.map((name) => (
                        <option key={name} value={name} />
                      ))}
                    </datalist>
                  </label>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
                    <button style={styles.modalButton} onClick={handleFulfillSubmit}>
                      Fulfill
                    </button>
                    <button style={styles.modalCancel} onClick={() => setShowFulfillModal(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showPrintSlip && (
              <div style={{ position: 'fixed', top: 0, left: 0, backgroundColor: 'white', width: '100vw', height: '100vh', zIndex: 9999, overflow: 'auto' }} className="package-slip-overlay">
                <PackageSlip orderDetails={orderDetails} />
              </div>
            )}

            <RefundModal
              show={showRefund}
              onHide={() => {
                setShowRefund(false);
                setOrderData(null);


              }}
              orderId={selectedOrder}
              orderData={orderData}
              onOrderDataChange={setOrderData}
            />

          </>

        );

      case "OrderReport":
        // return (
        //   <>



        //     <select
        //       value={selectedReportOrder}
        //       onChange={(e) => {
        //         const orderId = e.target.value;

        //         setSelectedReportOrder(orderId);

        //         const selected = orderss.find(
        //           (o) => o.orderId === orderId
        //         );

        //         if (selected) {
        //           setReportData(mapOrderToReport(selected));
        //         }
        //       }}
        //     >
        //       <option value="">Select Order</option>

        //       {orderss.map((order) => (
        //         <option key={order.id} value={order.orderId}>
        //           {order.orderId}
        //         </option>
        //       ))}
        //     </select>



        //     {reportData && (
        //    <>  
        //      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        //         <tbody>

        //           {Object.entries({
        //             "Client Reference ID": "orderId",
        //             "Ship To: Recipient Name": "recipientName",
        //             "Ship To: Delivery Note": "deliveryNote",
        //             "Ship To: Address Line 1": "addressLine1",
        //             "Ship To: Address Line 2": "addressLine2",
        //             "Ship To: Address Landmark": "landmark",
        //             "Ship To: City/Town": "city",
        //             "Ship To: State": "state",
        //             "Ship To: Postal Code": "postalCode",
        //             "Ship To: Email Address": "email",
        //             "Ship To: Phone Number": "phone",
        //             "Product Description": "productDescription",
        //             "Product Type": "productType",
        //             "Length (in cm)": "length",
        //             "Width (in cm)": "width",
        //             "Height (in cm)": "height",
        //             "Gross Weight (in KG)": "weight",
        //             "Invoice Number": "invoiceNumber",
        //             "Invoice Date": "invoiceDate",
        //             "Product Value": "productValue",
        //             "CGST Value": "cgst",
        //             "SGST Value": "sgst",
        //             "IGST Value": "igst",
        //             "CollectOnDelivery": "cod",
        //             "Shipping Service": "shippingService",
        //             "Pickup Date": "pickupDate",
        //             "Pickup Time Slot": "pickupTime",
        //             "Desired delivery date": "deliveryDate",
        //           }).map(([label, key]) => (
        //             <tr key={key}>
        //               <td>{label}</td>
        //               <td>
        //                 {key === "orderId" ? (
        //                   reportData[key]
        //                 ) : (
        //                   <input
        //                     value={reportData[key] || ""}
        //                     onChange={(e) =>
        //                       setReportData({
        //                         ...reportData,
        //                         [key]: e.target.value,
        //                       })
        //                     }
        //                   />
        //                 )}
        //               </td>
        //             </tr>
        //           ))}

        //         </tbody>
        //       </table>

        //       <button onClick={handleUpdate}>
        //      Update Order
        //    </button>

        //     </>
        //      )}
        //    </>
        // );


        //         return (
        //   <div className="container">
        //     {/* <h2 className="title">Order Report</h2> */}
        //     <div className="top-bar">
        //   <h2 className="title">Order Report</h2>

        //   <button
        //     className="excel-btn"
        //     onClick={() => setIsExcelMode(!isExcelMode)}
        //   >
        //     {isExcelMode ? "Back to Form" : "Export Excel"}
        //   </button>
        // </div>

        //     {/* Select Order */}
        //     <div className="card">
        //       <label className="label">Select Order</label>
        //       <select
        //         className="select"
        //         value={selectedReportOrder}
        //         onChange={(e) => {
        //           const orderId = e.target.value;
        //           setSelectedReportOrder(orderId);

        //           const selected = orderss.find((o) => o.orderId === orderId);
        //           if (selected) {
        //             setReportData(mapOrderToReport(selected));
        //           }
        //         }}
        //       >
        //         <option value="">-- Select Order --</option>
        //         {orderss.map((order) => (
        //           <option key={order.id} value={order.orderId}>
        //             {order.orderId}
        //           </option>
        //         ))}
        //       </select>
        //     </div>

        //     {/* Report Form */}
        //     {reportData && (
        //       <div className="card form-grid">
        //         {Object.entries({
        //           "Client Reference ID": "orderId",
        //           "Recipient Name": "recipientName",
        //           "Delivery Note": "deliveryNote",
        //           "Address Line 1": "addressLine1",
        //           "Address Line 2": "addressLine2",
        //           "Landmark": "landmark",
        //           "City": "city",
        //           "State": "state",
        //           "Postal Code": "postalCode",
        //           "Email": "email",
        //           "Phone": "phone",
        //           "Product Description": "productDescription",
        //           "Product Type": "productType",
        //           "Length (cm)": "length",
        //           "Width (cm)": "width",
        //           "Height (cm)": "height",
        //           "Weight (KG)": "weight",
        //           "Invoice Number": "invoiceNumber",
        //           "Invoice Date": "invoiceDate",
        //           "Product Value": "productValue",
        //           "CGST": "cgst",
        //           "SGST": "sgst",
        //           "IGST": "igst",
        //           "COD": "cod",
        //           "Shipping Service": "shippingService",
        //           "Pickup Date": "pickupDate",
        //           "Pickup Time": "pickupTime",
        //           "Delivery Date": "deliveryDate",
        //         }).map(([label, key]) => (
        //           <div className="form-group" key={key}>
        //             <label>{label}</label>

        //             {key === "orderId" ? (
        //               <input value={reportData[key]} disabled />
        //             ) : (
        //               <input
        //                 value={reportData[key] || ""}
        //                 onChange={(e) =>
        //                   setReportData({
        //                     ...reportData,
        //                     [key]: e.target.value,
        //                   })
        //                 }
        //               />
        //             )}
        //           </div>
        //         ))}

        //         <div className="button-wrapper">
        //           <button className="btn" onClick={handleUpdate}>
        //             Update Order
        //           </button>
        //         </div>
        //       </div>
        //     )}


        //   </div>
        // );


        return (
          <div className="container">
            {/* Top Bar */}
            <div className="top-bar">
              <h2 className="title">Order Report</h2>

              <button
                className="excel-btn"
                onClick={() => {
                  setIsExcelMode(!isExcelMode);
                  setFilteredData([]);
                }}
              >
                {isExcelMode ? "Back to Form" : "Export Excel"}
              </button>
            </div>

            {/* ================= EXCEL MODE ================= */}
            {isExcelMode ? (
              <div className="card">
                <h3>Export Orders</h3>

                <div className="date-row">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />

                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />

                  <button className="btn" onClick={handleFilter}>
                    Filter Data
                  </button>
                </div>

                {filteredData.length > 0 ? (
                  <>
                    {/* <table className="table">
                    
                      <thead>
                        <tr>
                          <th>Order ID</th>
                          <th>Recipient</th>
                          <th>Invoice Date</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Phone</th>
                          <th>Product</th>
                          <th>Type</th>
                          <th>Weight</th>
                          <th>Shipping</th>
                          <th>Pickup</th>
                          <th>Delivery</th>
                        </tr>
                      </thead>
                   

                      <tbody>
                        {filteredData.map((order) => {
                          const report = mapOrderToReport(order); // ✅ map once

                          return (
                            <tr key={order.id}>
                              <td>{report.orderId}</td>
                              <td>{report.recipientName}</td>
                              <td>{report.invoiceDate}</td>
                              <td>{report.city}</td>
                              <td>{report.state}</td>
                              <td>{report.phone}</td>
                              <td>{report.productDescription}</td>
                              <td>{report.productType}</td>
                              <td>{report.weight}</td>
                              <td>{report.shippingService}</td>
                              <td>{report.pickupDate}</td>
                              <td>{report.deliveryDate}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table> */}


                    {/* <table className="table">
  <thead>
    <tr>
      {filteredData.length > 0 &&
        Object.keys(mapOrderToReport(filteredData[0])).map((key) => (
          <th key={key}>{key}</th>
        ))}
    </tr>
  </thead>

  <tbody>
    {filteredData.map((order) => {
      const report = mapOrderToReport(order);

      return (
        <tr key={order.id}>
          {Object.values(report).map((value, index) => (
            <td key={index}>{value}</td>
          ))}
        </tr>
      );
    })}
  </tbody>
</table> */}


                    <div className="table-container">
                      <table className="table">
                        <thead>
                          <tr>
                            {filteredData.length > 0 &&
                              Object.keys(mapOrderToReport(filteredData[0])).map((key) => (
                                <th key={key}>{key}</th>
                              ))}
                          </tr>
                        </thead>

                        <tbody>
                          {filteredData.map((order) => {
                            const report = mapOrderToReport(order);

                            return (
                              <tr key={order.id}>
                                {Object.values(report).map((value, index) => (
                                  <td key={index}>{value}</td>
                                ))}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <button className="btn" onClick={exportToExcel}>
                      Download Excel
                    </button>
                  </>
                ) : (
                  <p style={{ marginTop: "10px" }}>No data found</p>
                )}
              </div>
            ) : (
              <>
                {/* ================= FORM MODE ================= */}

                <div className="card">
                  <label className="label">Select Order</label>
                  <select
                    className="select"
                    value={selectedReportOrder}
                    onChange={(e) => {
                      const orderId = e.target.value;
                      setSelectedReportOrder(orderId);

                      const selected = orderss.find(
                        (o) => o.orderId === orderId
                      );

                      if (selected) {
                        setReportData(mapOrderToReport(selected));
                      }
                    }}
                  >
                    <option value="">-- Select Order --</option>
                    {orderss.map((order) => (
                      <option key={order.id} value={order.orderId}>
                        {order.orderId}
                      </option>
                    ))}
                  </select>
                </div>

                {reportData && (
                  <div className="card form-grid">
                    {Object.entries({
                      "Client Reference ID": "orderId",
                      "Recipient Name": "recipientName",
                      "Delivery Note": "deliveryNote",
                      "Address Line 1": "addressLine1",
                      "Address Line 2": "addressLine2",
                      "Landmark": "landmark",
                      "City": "city",
                      "State": "state",
                      "Postal Code": "postalCode",
                      "Email": "email",
                      "Phone": "phone",
                      "Product Description": "productDescription",
                      "Product Type": "productType",
                      "Length (cm)": "length",
                      "Width (cm)": "width",
                      "Height (cm)": "height",
                      "Weight (KG)": "weight",
                      "Invoice Number": "invoiceNumber",
                      "Invoice Date": "invoiceDate",
                      "Product Value": "productValue",
                      "CGST": "cgst",
                      "SGST": "sgst",
                      "IGST": "igst",
                      "COD": "cod",
                      "Shipping Service": "shippingService",
                      "Pickup Date": "pickupDate",
                      "Pickup Time": "pickupTime",
                      "Delivery Date": "deliveryDate",
                    }).map(([label, key]) => (
                      <div className="form-group" key={key}>
                        <label>{label}</label>

                        {/* {key === "orderId" ? (
                          <input value={reportData[key]} disabled />
                        ) : (
                          <input
                            value={reportData[key] || ""}
                            onChange={(e) =>
                              setReportData({
                                ...reportData,
                                [key]: e.target.value,
                              })
                            }
                          />
                        )} */}

                        {key === "orderId" ? (
                          <input value={reportData[key]} disabled />
                        ) : key.toLowerCase().includes("date") ? (
                          // ✅ DATE PICKER
                          <input
                            type="date"
                            value={reportData[key] || ""}
                            onChange={(e) =>
                              setReportData({
                                ...reportData,
                                [key]: e.target.value, // already yyyy-mm-dd
                              })
                            }
                          />
                        ) : key.toLowerCase().includes("time") ? (
                          // ✅ TIME PICKER
                          <input
                            type="time"
                            value={reportData[key] || ""}
                            onChange={(e) =>
                              setReportData({
                                ...reportData,
                                [key]: e.target.value,
                              })
                            }
                          />
                        ) : (
                          // ✅ NORMAL INPUT
                          <input
                            value={reportData[key] || ""}
                            onChange={(e) =>
                              setReportData({
                                ...reportData,
                                [key]: e.target.value,
                              })
                            }
                          />
                        )}



                      </div>
                    ))}

                    <div className="button-wrapper">
                      <button className="btn" onClick={handleUpdate}>
                        Update Order
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        );

      case 'Shipping Charges':
        return (
          <>
            <div style={{ padding: '20px', margin: '0 auto', fontSize: '13px', backgroundColor: '#f9fafb', borderRadius: '20px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '12px' }}>📋Shipping Charges</h2>
              <form onSubmit={handleSubmitShipping} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', marginBottom: '20px', background: '#f9f9f9', padding: '15px', borderRadius: '8px' }}>
                <div style={{ flex: '1 1 150px' }}>
                  <Select
                    options={predefinedUnitsShipping}
                    value={selectedUnitShipping}
                    onChange={(option) => {
                      setSelectedUnitShipping(option);
                      setChargeAmount(''); // Clear the amount when switching unit type
                    }}
                    placeholder="Select Shipping"
                    isClearable
                    styles={{
                      control: (base) => ({ ...base, minHeight: '30px', fontSize: '13px' }),
                      menu: (base) => ({ ...base, fontSize: '13px' }),
                    }}
                  />
                </div>

                {(selectedUnitShipping?.value === 'domestic' || selectedUnitShipping?.value === 'non_domestic') && (
                  <input
                    type="number"
                    placeholder="Enter charge amount"
                    value={chargeAmount}
                    onChange={(e) => setChargeAmount(e.target.value)}
                    style={{ flex: '1 1 150px', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
                    required
                  />
                )}

                <button type="submit" style={{ padding: '6px 12px', background: '#4A5568', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px' }}>
                  {editIdShipping !== null ? 'Update' : 'Add'}
                </button>
              </form>

              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr', backgroundColor: '#edf2f7', fontWeight: 'bold', fontSize: '13px', padding: '10px 8px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px', }}>
                  <div>Type</div>
                  <div>Charges</div>
                  <div>Actions</div>
                </div>

                {unitsShipping.length === 0 ? (
                  <div style={{ padding: '12px', background: '#f9f9f9', border: '1px solid #e2e8f0', borderTop: 'none', textAlign: 'center', fontSize: '13px', borderBottomLeftRadius: '6px', borderBottomRightRadius: '6px', }}>No units added yet.</div>
                ) : (
                  unitsShipping.map((unit, index) => (
                    <div key={unit.id} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr', padding: '10px 8px', backgroundColor: index % 2 === 0 ? '#ffffff' : '#f7fafc', borderBottom: '1px solid #e2e8f0', fontSize: '13px', alignItems: 'center', }}>
                      <div>{unit.label}</div>
                      <div>{unit.value}</div>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button onClick={() => handleDeleteUnit(unit.id)} style={{ padding: '4px 6px', fontSize: '12px', background: '#e53e3e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Delete</button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </>
        );
      case 'Abandoned checkouts':
        return (
          <>
            {/* Top Stats Bar */}

            <h5><MdRemoveShoppingCart style={{ marginRight: '8px' }} />Abandoned Checkouts</h5>

            {/* Orders List or Details */}
            <div style={{ backgroundColor: "#fff", padding: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", fontFamily: "Segoe UI, sans-serif", borderRadius: "8px", overflowX: "auto", marginTop: '20px' }}>
              {!selectedOrder && (
                <>
                  {/* Orders Table */}
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px", minWidth: "800px", }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f9f9f9", textAlign: "left" }}>
                          {[
                            "",
                            "Checkout",
                            "Date",
                            "Customer",
                            "Channel",
                            "Amount",
                            "Payment",

                            "Items",

                          ].map((header, idx) => (
                            <th key={idx} style={{ padding: "10px 12px", fontWeight: "600", borderBottom: "2px solid #ddd", fontSize: "13px", whiteSpace: "nowrap", }}>
                              {header || <input type="checkbox" />}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatecheckoutdOrders.filter((order => order.is_paid === 0)).map((order, index) => (
                          <tr
                            key={index}
                            style={{
                              borderBottom: "1px solid #eee",
                              backgroundColor: order.isRefunded === 1 ? "#fff8e1" : "white", // light yellow for refunded
                            }}>

                            <td style={{ padding: "10px 12px" }}>
                              <input type="checkbox" />
                            </td>
                            <td style={{ padding: "10px 12px", fontWeight: 500, color: "#1976d2", cursor: "pointer", }}
                              onClick={() => {
                                const orderId = order.orderId.replace("#", ""); // extract 15 from "#15"
                                setSelectedOrder(orderId); // just pass the ID
                              }}

                            >
                              {order.orderId}
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.date}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.customer}
                              </span>
                            </td>

                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.channel}
                              </span>
                            </td>


                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                textDecoration: order.isRefunded === 1 ? "line-through" : "none",
                                color: order.isRefunded === 1 ? "#999" : "inherit"
                              }}>
                                {order.amount}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px", fontWeight: 600, color: order.isRefunded === 1 ? "#d32f2f" : "inherit" }}>
                              {order.isRefunded === 1 ? "Refunded" : order.paymentStatus}
                            </td>



                            <td style={{ padding: "10px 12px" }}>{order.items}</td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {/* Pagination Controls */}
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "8px" }}>
                      <button
                        disabled={checkoutFillPagination.currentPage === 1}
                        onClick={() =>
                          setcheckoutFillPagination((prev) => ({
                            ...prev,
                            currentPage: prev.currentPage - 1,
                          }))
                        }
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Prev
                      </button>

                      {Array.from({ length: totalcheckoutPagess }, (_, i) => (
                        <button
                          key={i + 1}
                          onClick={() =>
                            setcheckoutFillPagination((prev) => ({
                              ...prev,
                              currentPage: i + 1,
                            }))
                          }
                          style={{
                            padding: "6px 12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            backgroundColor:
                              checkoutFillPagination.currentPage === i + 1 ? "#0357a0" : "#fff",
                            color: checkoutFillPagination.currentPage === i + 1 ? "#fff" : "#000",
                            fontWeight: checkoutFillPagination.currentPage === i + 1 ? "bold" : "normal",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        disabled={checkoutFillPagination.currentPage === totalcheckoutPagess}
                        onClick={() =>
                          setcheckoutFillPagination((prev) => ({
                            ...prev,
                            currentPage: prev.currentPage + 1,
                          }))
                        }
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* Order Details View */}
              {orderDetails && (
                <div style={styles.container} className="print-container">
                  <header style={styles.header}>
                    <div className="print-only" style={{ display: "none" }}>
                      <img src="https://shreenathfoods.emedha.in/static/media/logo.74d570c27f4de9951a84.png" alt="GloCart" style={{ height: 60 }} />
                    </div>

                    <div>
                      <h1>
                        🛒{orderDetails.orderId}{" "}
                        <span style={{ fontWeight: "normal", fontSize: 16 }}>
                          {orderDetails.paid ? (
                            <span style={styles.paidBadge}>Paid</span>
                          ) : null}
                          {orderDetails.unfulfilled ? (
                            <span style={styles.unfulfilledBadge}>Unfulfilled</span>
                          ) : <span style={styles.unfulfilledBadge}>Fulfilled</span>}
                        </span>
                      </h1>
                      <p style={{ fontSize: 12, color: "#666" }}>
                        {orderDetails.date} from {orderDetails.source}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>


                      {/* <button style={styles.button}>Edit</button> */}
                      <div style={{ position: "relative", marginRight: '65px' }}>
                        <button
                          style={styles.button}
                          onClick={() => {
                            setShowPrintDropdown((prev) => !prev);
                            setShowMoreDropdown(false); // close the other one
                          }}
                        >
                          Print ▼
                        </button>
                        {showPrintDropdown && (
                          <div style={styles.dropdownMenu}>
                            <div
                              style={styles.dropdownItem}
                              className="dropdownItem"
                              onClick={handlePrint}
                            >
                              🖨️ Print Order Page
                            </div>

                            <div style={styles.dropdownItem} className='dropdownItem' onClick={handlePackageSlipPrint}>
                              📦 Package Slip
                            </div>
                          </div>
                        )}

                      </div>


                      <button
                        onClick={() => {
                          setSelectedOrder(null);
                          setOrderDetailss(null); // <-- this hides the details
                        }}

                        style={{
                          position: "absolute",  // 👈 this makes it float in the parent
                          top: "80px",
                          right: "30px",
                          backgroundColor: "transparent",
                          border: "none",
                          fontSize: "24px",
                          cursor: "pointer",
                          color: "#0357a0",
                          zIndex: 10
                        }}
                        title="Close"
                      >
                        ✕
                      </button>
                    </div>
                  </header>

                  {/* Items section */}
                  <section style={styles.section}>
                    <div style={styles.unfulfilledLabel}>  {orderDetails.unfulfilled ? (
                      <span style={styles.unfulfilledBadge}>Unfulfilled</span>
                    ) : (
                      <span style={styles.fulfilledBadge}>Fulfilled</span>
                    )}</div>
                    {orderDetails?.items?.map((item) => (
                      <div key={item.id} style={styles.itemCard}>
                        <div style={styles.tagRow}>
                          {item.tags?.map((tag) => (
                            <span key={tag} style={styles.tag}>
                              {tag}
                            </span>
                          ))}
                        </div>
                        <div style={styles.itemContent}>
                          <img
                            src={item.image}
                            alt={item.name}
                            style={{ width: 60, height: 60, marginRight: 10 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: "bold" }}>{item.name}</div>
                            <small>{item.id}</small>
                          </div>
                          <div style={{ marginRight: 10 }}>
                            ₹{item.price.toFixed(2)} × {item.quantity}
                          </div>
                          <div>₹{(item.price * item.quantity).toFixed(2)}</div>


                        </div>
                      </div>
                    ))}
                  </section>


                  {/* Summary Section */}
                  <section
                    style={{
                      ...styles.section,
                      maxWidth: '600px',       // limit max width of section card
                      padding: '16px',
                      overflowX: 'auto',       // enable horizontal scroll if needed
                      boxSizing: 'border-box',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      backgroundColor: '#fff'
                    }}
                  >
                    <h3>Checkout Summary</h3>
                    <table
                      style={{
                        ...styles.summaryTable,
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed'    // fix column widths to avoid overflow
                      }}
                    >
                      <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '20%' }} />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Subtotal</td>
                          <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                            {ordersData.items.length} item{ordersData.items.length > 1 ? 's' : ''}
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.subtotal}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Shipping</td>
                          <td style={{ padding: '8px 12px', whiteSpace: 'normal' }}>
                            Standard (0.25 kg: Items 0.25 kg, Package 0.0 kg)
                          </td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.shipping}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px', wordBreak: 'break-word' }}>Taxes</td>
                          <td style={{ padding: '8px 12px' }}>IGST 18% (Included)</td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.tax}</td>
                        </tr>
                        <tr style={{ fontWeight: 'bold', borderTop: '2px solid #000' }}>
                          <td style={{ padding: '8px 12px' }}>Total</td>
                          <td></td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.total}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '8px 12px' }}>Paid</td>
                          <td></td>
                          <td style={{ padding: '8px 12px', textAlign: 'right' }}>₹{ordersData.paidAmount}</td>
                        </tr>
                      </tbody>
                    </table>
                  </section>


                  {/* Timeline / Comments */}
                  <section style={styles.section}>
                    <div style={{ fontFamily: "Arial, sans-serif", maxWidth: 600, margin: "auto" }}>
                      {/* Timeline Header */}
                      <h2>Timeline</h2>

                      {/* Comment input */}
                      <div
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 8,
                          padding: 10,
                          display: "flex",
                          border: "1px solid #ddd",
                          marginBottom: 20,
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f06292",
                            color: "white",
                            width: 40,
                            height: 40,
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: 18,
                            marginRight: 10,
                            userSelect: "none",
                          }}
                        >
                          MT
                        </div>
                        <input
                          type="text"
                          placeholder="Leave a comment..."
                          onChange={(e) => setComment(e.target.value)}
                          style={{ flexGrow: 1, padding: 10, borderRadius: 8, border: "1px solid #ddd" }}
                        />
                        <button
                          style={{
                            ...styles.postButton,
                            backgroundColor: "#007bff",
                            cursor: "pointer",
                          }}
                          onClick={async () => {
                            if (!comment.trim() || !selectedOrder) {
                              console.warn("Missing comment or selectedOrder.id");
                              return;
                            }

                            console.log("📤 Posting comment to timeline...");
                            console.log("Order ID:", selectedOrder.id);
                            console.log("Comment:", comment);

                            try {
                              const res = await fetch('https://api.glocart.in/payment/api/api/timeline', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                  orderId: selectedOrder,
                                  comment,
                                }),
                              });

                              console.log("🧾 POST response status:", res.status);

                              if (res.ok) {
                                console.log("✅ Comment posted successfully.");
                                setComment("");

                                console.log("📥 Fetching updated timeline...");

                                const timelineRes = await fetch(`https://api.glocart.in/payment/api/api/timeline/${selectedOrder}`);
                                const timeline = await timelineRes.json();

                                console.log("📦 Timeline data received:", timeline);
                                setTimelineData(timeline);
                              } else {
                                const errText = await res.text();
                                console.error("❌ Failed to post comment:", errText);
                              }
                            } catch (err) {
                              console.error("💥 Error during timeline post:", err);
                            }
                          }}
                        >
                          Post
                        </button>


                      </div>

                      <div style={{ fontSize: 12, color: "#888", marginBottom: 20 }}>
                        Only you and other staff can see comments
                      </div>

                      {/* Timeline Items */}
                      <div style={{ position: "relative", paddingLeft: 30 }}>
                        {/* Vertical line */}
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 15,
                            width: 2,
                            height: "100%",
                            backgroundColor: "#ddd",
                          }}
                        />

                        {timelineData.map(({ date, events }, sectionIndex) => (
                          <div key={sectionIndex} style={{ marginBottom: 30 }}>
                            {/* Date label */}
                            <div
                              style={{
                                fontWeight: "bold",
                                color: "#666",
                                fontSize: 14,
                                marginBottom: 10,
                              }}
                            >
                              {date}
                            </div>
                            {events.map((event, eventIndex) => {
                              const isExpanded = expandedIndex === `${sectionIndex}-${eventIndex}`;

                              return (
                                <div
                                  key={eventIndex}
                                  style={{
                                    position: "relative",
                                    marginBottom: 20,
                                    paddingLeft: 20,
                                    borderLeft: "2px solid transparent",
                                  }}
                                >
                                  {/* Dot */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: -15,
                                      top: 5,
                                      width: 10,
                                      height: 10,
                                      backgroundColor: "#555",
                                      borderRadius: "50%",
                                      border: "2px solid white",
                                    }}
                                  />

                                  {/* Time */}
                                  <div
                                    style={{
                                      fontSize: 10,
                                      color: "#999",
                                      position: "absolute",
                                      right: 0,
                                      top: 0,
                                    }}
                                  >
                                    {event.time}
                                  </div>

                                  {/* Event text */}
                                  <div style={{ fontSize: 14, marginBottom: 8 }}>
                                    {event.text}
                                    {event.expandable && !isExpanded && " ..."}
                                  </div>

                                  {/* View email button */}
                                  {event.buttonText && (
                                    <button
                                      style={{
                                        fontSize: 12,
                                        padding: "5px 10px",
                                        borderRadius: 5,
                                        border: "1px solid #ccc",
                                        background: "white",
                                        cursor: "pointer",
                                        marginBottom: 5,
                                      }}
                                      onClick={() => alert("View email clicked")}
                                    >
                                      {event.buttonText}
                                    </button>
                                  )}

                                  {/* Expand/Collapse toggle */}
                                  {event.expandable && (
                                    <span
                                      onClick={() => toggleExpand(`${sectionIndex}-${eventIndex}`)}
                                      style={{
                                        marginLeft: 8,
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        userSelect: "none",
                                        color: "#555",
                                        fontSize: 18,
                                        verticalAlign: "middle",
                                      }}
                                      title={isExpanded ? "Collapse" : "Expand"}
                                    >
                                      {isExpanded ? "−" : "+"}
                                    </span>
                                  )}

                                  {/* Expanded content example (placeholder) */}
                                  {isExpanded && (
                                    <div
                                      style={{
                                        padding: 10,
                                        backgroundColor: "#f1f1f1",
                                        borderRadius: 5,
                                        marginTop: 5,
                                        fontSize: 13,
                                        color: "#333",
                                      }}
                                    >
                                      Detailed information about this fulfillment event...
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </div>
                  </section>

                  {/* Right side info */}
                  <aside style={styles.sidebar}>
                    {/* <section style={styles.sidebarSection}>
          <h4>Notes</h4>
          <p>No notes from customer</p>
        </section> */}
                    <section style={styles.sidebarSection}>
                      <h4>Customer</h4>
                      {orderDetails?.customer ? (
                        <p>
                          <strong>{orderDetails.customer.name}</strong>
                          <br />
                          {orderDetails.customer.ordersCount} order
                          {orderDetails.customer.ordersCount > 1 ? "s" : ""}
                          <br />
                          <br />
                          Contact information
                          <br />
                          <a href={`mailto:${orderDetails.customer.email}`}>
                            {orderDetails.customer.email}
                          </a>
                          <br />
                          {orderDetails.customer.phone}
                        </p>
                      ) : (
                        <p>Customer info not available</p>
                      )}

                      <br />
                      <p>
                        <strong>Shipping address</strong>
                        <br />
                        {orderDetails?.customer?.shippingAddress
                          ?.split("\n")
                          .map((line, i) => (
                            <span key={i}>
                              {line}
                              <br />
                            </span>
                          ))}
                        {mapUrl ? (
                          <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                            View map
                          </a>
                        ) : (
                          <span>No location info available</span>
                        )}
                      </p>
                      <br />
                      <p>
                        <strong>Billing address</strong>
                        <br />
                        {orderDetails?.customer?.billingSameAsShipping
                          ? "Same as shipping address"
                          : ""}
                      </p>
                    </section>


                    <section style={styles.sidebarSection} className="print-hide">
                      <h4>Conversion summary</h4>
                      <ul style={{ paddingLeft: 18 }}>
                        {orderDetails?.conversionSummary.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>

                      <a href="#" style={{ color: "#007bff" }}>
                        View conversion details
                      </a>
                    </section>
                  </aside>
                </div>
              )}
            </div>
            {showFulfillModal && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3>Tracking Information</h3>
                  <label>
                    Tracking Number:
                    <input
                      type="text"
                      value={trackingNumber}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                      style={styles.input}
                    />
                  </label>

                  <label>
                    Shipping Carrier:
                    <input
                      type="text"
                      list="courier-options"
                      value={carrier}
                      onChange={(e) => setCarrier(e.target.value)}
                      style={styles.input}
                    />
                    <datalist id="courier-options">
                      {courierCompanies.map((name) => (
                        <option key={name} value={name} />
                      ))}
                    </datalist>
                  </label>

                  <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
                    <button style={styles.modalButton} onClick={handleFulfillSubmit}>
                      Fulfill
                    </button>
                    <button style={styles.modalCancel} onClick={() => setShowFulfillModal(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showPrintSlip && (
              <div style={{ position: 'fixed', top: 0, left: 0, backgroundColor: 'white', width: '100vw', height: '100vh', zIndex: 9999, overflow: 'auto' }} className="package-slip-overlay">
                <PackageSlip orderDetails={orderDetails} />
              </div>
            )}

            <RefundModal
              show={showRefund}
              onHide={() => {
                setShowRefund(false);
                setOrderData(null);


              }}
              orderId={selectedOrder}
              orderData={orderData}
              onOrderDataChange={setOrderData}
            />

          </>

        );

      case 'Cuisine':
        return (
          <>
            <div style={{ padding: "1rem", margin: "0 auto", fontFamily: "Inter, sans-serif", fontSize: "12px", maxWidth: "1200px" }}>
              {/* CRUD Form */}
              <div style={{ background: "#fff", padding: "8px 12px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "12px", borderRadius: "4px" }}>
                <h6 style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#333" }}>Add / Edit Super Category</h6>
                <form onSubmit={handleSubmitSuper} style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap", marginBottom: "0.5rem" }}>
                  <input type="text" placeholder="Category Name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required style={{ padding: "6px 8px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "12px", background: "#fdfdfd" }} />
                  <input type="file" onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })} style={{ padding: "4px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "11px", background: "#fdfdfd" }} />
                  <input
                    type="file"
                    onChange={(e) =>
                      setFormData({ ...formData, icon: e.target.files[0] })
                    }
                    style={{ padding: "4px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "11px", background: "#fdfdfd" }}
                  />
                  <button type="submit" style={{ padding: "5px 10px", background: "#007bff", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "12px" }}>{formData.id ? "Update" : "Add"}</button>
                </form>
              </div>
              {/* Table View */}
              <div style={{ background: "#fff", padding: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)", borderRadius: "4px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                  <thead>
                    <tr style={{ background: "#f8f8f8" }}>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Name</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>App Image</th>

                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Web Image</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItemsSC.map((cat) => (
                      <tr key={cat.id}>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", color: "#333" }}>{cat.name}</td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}><img src={cat.image} alt="img" style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "3px" }} /></td>
                        <td>
                          <img
                            src={cat.icon}
                            alt="icon"
                            style={{ width: "35px", height: "35px", objectFit: "cover" }}
                          />
                        </td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}>
                          <button onClick={() => handleEditSuper(cat)} style={{ marginRight: "6px", background: "#ffc107", border: "none", padding: "4px 8px", borderRadius: "4px", cursor: "pointer", fontSize: "11px" }}>Edit</button>
                          <button onClick={() => handleDeleteSuper(cat.id)} style={{ background: "#dc3545", border: "none", padding: "4px 8px", borderRadius: "4px", color: "#fff", cursor: "pointer", fontSize: "11px" }}>Delete</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination */}
              <div style={{ textAlign: 'center', marginTop: '15px' }}>
                <button onClick={() => setCurrentPageSC(prev => Math.max(prev - 1, 1))} disabled={currentPageSC === 1} style={{ padding: '4px 10px', fontSize: '12px', marginRight: '8px', borderRadius: '4px', border: '1px solid #ccc', background: currentPageSC === 1 ? '#eee' : '#007bff', color: currentPageSC === 1 ? '#666' : '#fff', cursor: currentPageSC === 1 ? 'default' : 'pointer' }}>Previous</button>
                <span style={{ margin: '0 8px', fontSize: '12px', color: '#333' }}>Page {currentPageSC} of {totalPagesSC || 1}</span>
                <button onClick={() => setCurrentPageSC(prev => Math.min(prev + 1, totalPagesSC))} disabled={currentPageSC === totalPagesSC || totalPagesSC === 0} style={{ padding: '4px 10px', fontSize: '12px', marginLeft: '8px', borderRadius: '4px', border: '1px solid #ccc', background: currentPageSC === totalPagesSC || totalPagesSC === 0 ? '#eee' : '#007bff', color: currentPageSC === totalPagesSC || totalPagesSC === 0 ? '#666' : '#fff', cursor: currentPageSC === totalPagesSC || totalPagesSC === 0 ? 'default' : 'pointer' }}>Next</button>
              </div>
            </div>
          </>
        );

      case 'Sub Categories':
        return (
          <>
            <div >
              <div style={{ background: "#fff", padding: "8px 10px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "10px", borderRadius: "4px", fontFamily: "Inter, sans-serif", fontSize: "12px" }}>
                <h6 style={{ margin: "0 0 6px 0", fontSize: "12px", color: "#333", fontWeight: "600" }}>
                  {editSubcategoryId ? "EDIT SUB CATEGORY" : "ADD NEW SUB CATEGORY"}
                </h6>
                <form onSubmit={handleSubCategorySubmit} style={{ display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap", marginBottom: "0.5rem" }}>
                  {success && (<div style={{ color: "green", fontSize: "11px", width: "100%" }}>Subcategory added successfully!</div>)}
                  {/* <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "11px", marginBottom: "3px", fontWeight: "500" }}>Super Category</label>
                    <select value={selectedSuperCatId} onChange={(e) => { const selectedSuper = supercategoriesget.find((superCat) => superCat.id === parseInt(e.target.value)); setSelectedSuperCatId(e.target.value); setSelectedSuperCatName(selectedSuper ? selectedSuper.name : ''); }} required style={{ padding: "5px 6px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", minWidth: "150px", background: "#fdfdfd", }}>
                      <option value="">Select</option>
                      {supercategoriesget.map((superCat) => (
                        <option key={superCat.id} value={superCat.id}>
                          {superCat.name}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "11px", marginBottom: "3px", fontWeight: "500" }}>Category</label>
                    <select value={categoryId} onChange={(e) => { const selectedCategory = categories.find((cat) => cat.id === parseInt(e.target.value)); setCategoryId(e.target.value); setCategoryName(selectedCategory ? selectedCategory.name : ""); }} required style={{ padding: "5px 6px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", minWidth: "150px", background: "#fdfdfd", }}>
                      <option value="">Select</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "11px", marginBottom: "3px", fontWeight: "500" }}>Name</label>
                    <input type="text" value={subCategoryName} onChange={(e) => setSubCategoryName(e.target.value)} required style={{ padding: "5px 6px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "4px", width: "150px", background: "#fdfdfd" }} />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "11px", marginBottom: "3px", fontWeight: "500" }}>Image</label>
                    <input key={imageSub ? imageSub.name : 'fileInput'} type="file" onChange={(e) => setImageSub(e.target.files[0])} style={{ padding: "3px", fontSize: "11px", border: "1px solid #ccc", borderRadius: "4px", width: "150px" }} />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontSize: "11px", marginBottom: "3px", fontWeight: "500" }}>-</label>
                    <button type="submit" style={{ background: "#007bff", color: "#fff", padding: "5px 10px", border: "none", borderRadius: "4px", fontSize: "12px", cursor: "pointer" }}>{editSubcategoryId ? "Update" : "Add"}</button>
                  </div>
                </form>
              </div>

              <div style={{ background: "#fff", padding: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)", borderRadius: "4px" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                  <thead>
                    <tr style={{ background: "#f8f8f8" }}>
                      {/* <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Super Category Name</th> */}
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Category Name</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Subcategory</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Image</th>
                      <th style={{ textAlign: "left", padding: "8px 6px", borderBottom: "1px solid #ddd", color: "#555" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item) => (
                      <tr key={item.id} style={{ verticalAlign: 'middle' }}>
                        {/* <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", color: "#333" }}>{item.super_cat_name}</td> */}
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee", color: "#333" }}>{item.category_name}</td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}>{item.subCategory}</td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}><img src={item.image_sub} alt={item.image_sub} style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "3px" }} /></td>
                        <td style={{ padding: "6px 6px", borderBottom: "1px solid #eee" }}>
                          <button onClick={() => handleEditSubCategory(item)} style={{ marginRight: '10px', background: 'none', border: 'none', color: '#4caf50', cursor: 'pointer' }}><FaEdit /></button>
                          <button onClick={() => handleDeleteSubCategort(item.id)} style={{ background: 'none', border: 'none', color: '#f44336', cursor: 'pointer' }}><FaTrash /></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ textAlign: 'center', marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ padding: '4px 12px', fontSize: '12px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : '#6a82fb', color: '#fff', border: 'none', borderRadius: '4px', transition: '0.2s', }}>Previous</button>
                <span style={{ fontSize: '12px', color: '#333' }}>Page <strong>{currentPage}</strong> of <strong>{totalPages || 1}</strong> &nbsp;(Showing{" "}<strong>{subcategories.length === 0 ? 0 : indexOfFirstItem + 1}–{Math.min(indexOfLastItem, subcategories.length)}</strong>{" "}of <strong>{subcategories.length}</strong> items)</span>
                <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={{ padding: '4px 12px', fontSize: '12px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : '#6a82fb', color: '#fff', border: 'none', borderRadius: '4px', transition: '0.2s', }}>Next</button>
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            <h2>Welcome!</h2>;
          </>
        );
    }
  };

  const navItems = [
    { label: 'Dashboard', icon: <FaTachometerAlt /> },
    { label: 'Brands', icon: <FaTags /> },
    { label: 'Banners', icon: <FaImage /> },
    { label: 'Notifications', icon: <MdNotificationsActive /> },
    { label: 'Cuisine', icon: <FaList /> },

    { label: 'Top Cuisine', icon: <FaList /> },
    { label: 'Categories', icon: <FaList /> },
    { label: 'Sub Categories', icon: <FaList /> },
    { label: 'Variant Master', icon: <FaTags /> },
    { label: 'Add Product Form', icon: <FaBox /> },
    { label: 'Products List', icon: <FaClipboardList /> },
    // { label: 'Products', icon: <FaBox /> },
    // { label: 'Products List1', icon: <FaClipboardList /> },Order Fulfillment 
    { label: 'Users', icon: <FaUser /> },
    { label: 'Reports', icon: <FaCog /> },
    // { label: 'Analytics', icon: <FaChartBar /> },

    { label: 'OrderReport', icon: <FaBoxOpen /> },

    { label: 'Order Fulfillment', icon: <FaBoxOpen /> },
    // { label: '', icon: <FaBoxOpen /> },
    { label: 'Abandoned checkouts', icon: <FaExclamationCircle /> },
    { label: 'Shipping Charges', icon: <FaTruck /> },


    { label: 'Notification', icon: <FaBell /> },
    { label: 'Logout', icon: <FaSignOutAlt /> },
  ];
  //====================================
  // this is the User Members 
  //====================================
  // const role = localStorage.getItem('role');
  // const permissions = JSON.parse(localStorage.getItem('permissions'));

  const role = sessionStorage.getItem('role');

  // SAFE permissions read
  let permissions = [];
  try {
    const stored = sessionStorage.getItem('permissions');
    permissions = stored ? JSON.parse(stored) : [];
  } catch {
    permissions = [];
  }
  const filteredNavItems =
    role === 'admin'
      ? navItems
      : navItems.filter(
        item =>
          permissions.includes(item.label) ||
          item.label === 'Logout'
      );


  // const filteredNavItems =
  //   role === 'admin'
  //     ? navItems
  //     : navItems.filter(item => permissions.includes(item.label) || item.label === 'Logout');



  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif', fontSize: '12px' }} >
      <div style={{ width: sidebarOpen ? '220px' : '60px', backgroundColor: '#e9eaedff', color: 'white', transition: 'width 0.3s', paddingTop: '20px', position: 'fixed', top: 0, bottom: 0, left: 0, boxShadow: '2px 0 8px rgba(0,0,0,0.2)', zIndex: 1000, display: 'flex', flexDirection: 'column' }} className="print-hide sidebar-space">
        <button onClick={toggleSidebar} style={{ position: 'absolute', top: '20px', right: '-20px', background: '#0357a0', color: 'white', border: 'none', borderRadius: '50%', width: '35px', height: '35px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', outline: 'none', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }}><FaBars /></button>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img src={logo} alt="Logo" style={{ width: sidebarOpen ? '140px' : '40px', transition: 'width 0.3s', objectFit: 'contain', borderRadius: "10px" }} />
        </div>
        <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '20px', scrollbarWidth: 'none', msOverflowStyle: 'none', }} className="sidebar-scroll">
          <style>{`.sidebar-scroll::-webkit-scrollbar {display: none;}`}</style>
          {filteredNavItems.map((item) => (
            <div key={item.label} style={{ display: 'flex', alignItems: 'center', padding: '12px 20px', color: 'black', cursor: 'pointer', transition: 'background 0.2s', whiteSpace: 'nowrap', backgroundColor: activeComponent === item.label ? '#0357a0' : 'transparent', backgroundColor: activeComponent === item.label ? '#0357a0' : 'transparent', color: activeComponent === item.label ? '#fff' : 'black', }}

              // onClick={() => {
              //   setActiveComponent(item.label);
              //   localStorage.setItem('activeComponent', item.label); // Save to localStorage
              // }}

              onClick={() => {
                if (item.label === "Logout") {
                  handleLogout();
                  return;
                }

                setActiveComponent(item.label);
                sessionStorage.setItem('activeComponent', item.label);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#0357a0';
                e.currentTarget.style.color = '#fff';
              }} onMouseLeave={(e) => {
                e.currentTarget.style.background = activeComponent === item.label ? '#0357a0' : 'transparent';
                e.currentTarget.style.color = activeComponent === item.label ? '#fff' : 'black';
              }}>
              <div style={{ marginRight: sidebarOpen ? '12px' : '0', fontSize: '18px', transition: 'margin 0.3s', }}>{item.icon}</div>
              {sidebarOpen && item.label}
            </div>
          ))}
        </div>
      </div>
      <div
        className="main-content"
        style={{
          marginLeft: sidebarOpen ? '220px' : '60px',
          padding: '30px',
          background: '#EDF2F7',
          width: '100%',
          transition: 'margin-left 0.3s',
          minHeight: '100vh',
          overflowY: 'auto'
        }}
      >
        {renderContent()}
      </div>

    </div>

  );
};

const styles = {
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 300px",
    gap: 20,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: 20,
    maxWidth: 1500,
    margin: "auto",
  },
  header: {
    gridColumn: "1 / 3",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
  },
  paidBadge: {
    backgroundColor: "#c8e6c9",
    color: "#256029",
    padding: "2px 6px",
    borderRadius: 4,
    marginRight: 8,
    fontSize: 14,
    fontWeight: "bold",
  },
  unfulfilledBadge: {
    backgroundColor: "#fff59d",
    color: "#725300",
    padding: "2px 6px",
    borderRadius: 4,
    fontSize: 14,
    fontWeight: "bold",
  },
  button: {
    marginLeft: 10,
    backgroundColor: "#e7e7e7",
    border: "none",
    padding: "6px 12px",
    borderRadius: 4,
    cursor: "pointer",
  },
  section: {
    backgroundColor: "#fff",
    borderRadius: 6,
    boxShadow: "0 1px 3px rgba(0,0,0,.1)",
    padding: 20,
    marginBottom: 20,
  },
  unfulfilledLabel: {
    backgroundColor: "#fff59d",
    color: "#725300",
    fontWeight: "bold",
    padding: "6px 10px",
    borderRadius: 6,
    marginBottom: 10,
    display: "inline-block",
  },
  itemCard: {
    border: "1px solid #ddd",
    borderRadius: 6,
    padding: 10,
    marginBottom: 10,
  },
  tagRow: {
    display: "flex",
    gap: 10,
    marginBottom: 10,
  },
  tag: {
    padding: "3px 8px",
    backgroundColor: "#f0f0f0",
    borderRadius: 4,
    fontSize: 12,
  },
  itemContent: {
    display: "flex",
    alignItems: "center",
  },
  fulfillButton: {
    marginLeft: 10,
    backgroundColor: "#0357a0",
    color: "#fff",
    border: "none",
    padding: "6px 15px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 12,
  },
  summaryTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  commentInputContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  avatar: {
    backgroundColor: "#ff5c8d",
    color: "#fff",
    height: 30,
    width: 30,
    textAlign: "center",
    lineHeight: "30px",
    borderRadius: "50%",
    fontWeight: "bold",
  },
  commentInput: {
    flexGrow: 1,
    padding: 8,
    borderRadius: 4,
    border: "1px solid #ccc",
  },
  postButton: {
    padding: "8px 15px",
    border: "none",
    borderRadius: 4,
    color: "#fff",
    marginLeft: 4,
  },
  sidebar: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  sidebarSection: {
    backgroundColor: "#fff",
    borderRadius: 6,
    boxShadow: "0 1px 3px rgba(0,0,0,.1)",
    padding: 15,
  },
  dropdownMenu: {
    position: "absolute",
    top: "100%",
    left: 0,
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: "11px",
    zIndex: 1000,
    marginTop: "4px",
    minWidth: "160px",
    fontSize: "14px",
    padding: '14px'

  },

  dropdownItem: {
    padding: "15px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    marginTop: "8px",
    cursor: 'pointer'
  },

  dropdownItem: {
    marginTop: "5px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    whiteSpace: "nowrap", // ✅ string value
  },

  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: '#fff',
    padding: 30,
    borderRadius: 10,
    width: 400,
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  input: {
    width: '100%',
    padding: 8,
    margin: '8px 0',
    border: '1px solid #ccc',
    borderRadius: 4,
  },
  modalButton: {
    backgroundColor: '#0357a0',
    color: '#fff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    margin: '8px',
  },
  modalCancel: {
    backgroundColor: '#ccc',
    padding: '10px 20px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    margin: '8px',
  },
  card: { backgroundColor: "#f9f9f9", padding: 16, marginBottom: 16, borderRadius: 10, }, unfulfilledBadge: { backgroundColor: "#FFD54F", color: "#3a3a3a", borderRadius: 6, padding: "4px 10px", fontSize: 12, fontWeight: "bold", }, productImage: { width: 50, height: 50, borderRadius: 6, objectFit: "cover", border: "1px solid #ddd", }, quantityInput: { width: 60, borderRadius: 6, border: "1px solid #bbb", padding: 4, textAlign: "center", }, checkboxLabel: { marginTop: 12, display: "inline-flex", alignItems: "center", fontSize: 14, userSelect: "none", }, shippingInput: { width: 90, padding: "6px 8px", borderRadius: 6, border: "1px solid #bbb", textAlign: "right", }, textarea: { width: "100%", borderRadius: 10, border: "1px solid #ccc", padding: 10, fontFamily: "inherit", resize: "vertical", minHeight: 60, }, summaryCard: { backgroundColor: "#fff", padding: 16, borderRadius: 10, border: "1px solid #ddd", }, summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: 8, }, select: { width: "100%", padding: 8, borderRadius: 6, border: "1px solid #bbb", fontSize: 14, }, input: { width: "100%", padding: 8, borderRadius: 6, border: "1px solid #bbb", fontSize: 14, }, refundButton: { marginTop: 20, width: "100%", padding: 12, backgroundColor: "#222", color: "#fff", fontWeight: "bold", borderRadius: 8, border: "none", cursor: "pointer", },



};

const card = {
  background: '#fff',
  padding: 20,
  borderRadius: 12,
  boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
  marginBottom: 30
};

const grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4,1fr)',
  gap: 15
};

const input = {
  padding: 10,
  borderRadius: 8,
  border: '1px solid #ccc',
  outline: 'none'
};

const permission = (active) => ({
  padding: '6px 12px',
  borderRadius: 20,
  background: active ? '#0357a0' : '#eaeaea',
  color: active ? '#fff' : '#333',
  cursor: 'pointer'
});

const primaryBtn = {
  marginTop: 20,
  padding: '10px 20px',
  background: '#0357a0',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer'
};

const editBtn = {
  background: '#4caf50',
  color: '#fff',
  border: 'none',
  padding: '5px 10px',
  borderRadius: 6,
  marginRight: 6,
  cursor: 'pointer'
};

const deleteBtn = {
  background: '#f44336',
  color: '#fff',
  border: 'none',
  padding: '5px 10px',
  borderRadius: 6,
  cursor: 'pointer'
};

const badge = {
  background: '#0357a0',
  color: '#fff',
  padding: '4px 8px',
  borderRadius: 12,
  marginRight: 5,
  fontSize: 12
};

const th = {
  padding: 10,
  textAlign: 'left'
};

const td = {
  padding: 10
};

export default Dashboard;
